//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import BaseClient from "./BaseClient"

export interface IInterventiLayoutClient {

    sendRapportinoByMail(customerEmail: string | null | undefined, saveCustomerEmail: boolean | undefined, idIntervento: number | undefined): Promise<FileResponse | null>;
}

export class InterventiLayoutClient extends BaseClient implements IInterventiLayoutClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendRapportinoByMail(customerEmail: string | null | undefined, saveCustomerEmail: boolean | undefined, idIntervento: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/SendRapportinoByMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerEmail !== null && customerEmail !== undefined)
            content_.append("CustomerEmail", customerEmail.toString());
        if (saveCustomerEmail === null || saveCustomerEmail === undefined)
            throw new Error("The parameter 'saveCustomerEmail' cannot be null.");
        else
            content_.append("SaveCustomerEmail", saveCustomerEmail.toString());
        if (idIntervento === null || idIntervento === undefined)
            throw new Error("The parameter 'idIntervento' cannot be null.");
        else
            content_.append("IdIntervento", idIntervento.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendRapportinoByMail(_response);
        });
    }

    protected processSendRapportinoByMail(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IRapportiControlloLayoutClient {

    sendByMail(customerEmail: string | null | undefined, saveCustomerEmail: boolean | undefined, year: number | undefined, number: number | undefined, type: RapportoControlloTypeDto | undefined): Promise<FileResponse | null>;

    save(year: number | undefined, number: number | undefined, payload_DatiImpianto_TargaImpianto: string | null | undefined, payload_DatiImpianto_PotenzaNominale: string | null | undefined, payload_DatiImpianto_Comune: string | null | undefined, payload_DatiImpianto_Provincia: string | null | undefined, payload_DatiImpianto_Indirizzo: string | null | undefined, payload_DatiImpianto_Piano: string | null | undefined, payload_DatiImpianto_Pod: string | null | undefined, payload_DatiImpianto_Pdr: string | null | undefined, payload_DatiImpianto_Scala: string | null | undefined, payload_DatiImpianto_Interno: string | null | undefined, payload_DatiImpianto_Sezione: string | null | undefined, payload_DatiImpianto_Foglio: string | null | undefined, payload_DatiImpianto_Particella: string | null | undefined, payload_DatiImpianto_Sub: string | null | undefined, payload_Responsabile_Nominativo: string | null | undefined, payload_Responsabile_PartitaIva: string | null | undefined, payload_Responsabile_CodiceFiscale: string | null | undefined, payload_Responsabile_RagioneSociale: string | null | undefined, payload_Responsabile_Indirizzo: string | null | undefined, payload_Responsabile_Comune: string | null | undefined, payload_Responsabile_Provincia: string | null | undefined, payload_Responsabile_TipoResponsabile: TipoResponsabile | null | undefined, payload_ImpresaManutentrice_RagioneSociale: string | null | undefined, payload_ImpresaManutentrice_PartitaIva: string | null | undefined, payload_ImpresaManutentrice_Indirizzo: string | null | undefined, payload_ImpresaManutentrice_Comune: string | null | undefined, payload_ImpresaManutentrice_Provincia: string | null | undefined, payload_DocumentazioneCorredo_ConformitaPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoGeneratorePresente: boolean | null | undefined, payload_DocumentazioneCorredo_CompilatoTutteParti: boolean | null | undefined, payload_TrattamentoAcqua_DurezzaTotale: string | null | undefined, payload_TrattamentoAcqua_TrattamentoNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAssente: boolean | undefined, payload_TrattamentoAcqua_TrattamentoFiltrazione: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAddolcimento: boolean | undefined, payload_TrattamentoAcqua_TrattamentoChimico: boolean | undefined, payload_TrattamentoAcqua_AcsNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_AcsAssente: boolean | undefined, payload_TrattamentoAcqua_AcsFiltrazione: boolean | undefined, payload_TrattamentoAcqua_AcsAddolcimento: boolean | undefined, payload_TrattamentoAcqua_AcsChimico: boolean | undefined, payload_ControlloImpianto_InstallazioneInterna: Flag | null | undefined, payload_ControlloImpianto_InstallazioneEsterna: Flag | null | undefined, payload_ControlloImpianto_ApertureVentilazione: Flag | null | undefined, payload_ControlloImpianto_AdeguateDimensioni: Flag | null | undefined, payload_ControlloImpianto_CanaleDiFumo: Flag | null | undefined, payload_ControlloImpianto_SistemaRegolazione: Flag | null | undefined, payload_ControlloImpianto_AssenzaPerdite: Flag | null | undefined, payload_ControlloImpianto_IdoneaTenuta: Flag | null | undefined, payload_ControlloImpiantoBiomasse_InstallazioneInterna: Flag | null | undefined, payload_ControlloImpiantoBiomasse_InstallazioneEsterna: Flag | null | undefined, payload_ControlloImpiantoBiomasse_ApertureVentilazione: Flag | null | undefined, payload_ControlloImpiantoBiomasse_AdeguateDimensioni: Flag | null | undefined, payload_ControlloImpiantoBiomasse_CanaleDiFumo: Flag | null | undefined, payload_ControlloImpiantoBiomasse_SistemaRegolazione: Flag | null | undefined, payload_ControlloImpiantoBiomasse_IdoneaTenuta: Flag | null | undefined, payload_ControlloImpiantoBiomasse_PuliziaCamino: Flag | null | undefined, payload_VerificaEnergetica_CodGruppo: string | null | undefined, payload_VerificaEnergetica_DataInstallazione: string | null | undefined, payload_VerificaEnergetica_Fabbricante: string | null | undefined, payload_VerificaEnergetica_Modello: string | null | undefined, payload_VerificaEnergetica_Matricola: string | null | undefined, payload_VerificaEnergetica_TipologiaGruppo: TipoGruppo | null | undefined, payload_VerificaEnergetica_TipoGruppo_GruppoSingolo: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_GruppoModulare: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_GeneratoreAria: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Tradizionale: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Condensazione: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Altro: boolean | undefined, payload_VerificaEnergetica_AltroGruppo: string | null | undefined, payload_VerificaEnergetica_PotenzaFocolare: string | null | undefined, payload_VerificaEnergetica_PotenzaUtile: string | null | undefined, payload_VerificaEnergetica_ClimatizzazioneInvernale: boolean | undefined, payload_VerificaEnergetica_ProduzioneAcs: boolean | undefined, payload_VerificaEnergetica_Combustibile: TipoCombustibile | null | undefined, payload_VerificaEnergetica_AltroCombustibile: string | null | undefined, payload_VerificaEnergetica_DispositiviComando: Flag | null | undefined, payload_VerificaEnergetica_DispositiviSicurezza: Flag | null | undefined, payload_VerificaEnergetica_ValvolaSicurezza: Flag | null | undefined, payload_VerificaEnergetica_ControllatoPulito: Flag | null | undefined, payload_VerificaEnergetica_PresenzaRiflusso: Flag | null | undefined, payload_VerificaEnergetica_RisultatiControllo: Flag | null | undefined, payload_VerificaEnergetica_Tiraggio: TipoTiraggio | null | undefined, payload_VerificaEnergetica_DepressioneCanale: string | null | undefined, payload_VerificaEnergeticaBiomasse_CodGruppo: string | null | undefined, payload_VerificaEnergeticaBiomasse_DataInstallazione: string | null | undefined, payload_VerificaEnergeticaBiomasse_Fabbricante: string | null | undefined, payload_VerificaEnergeticaBiomasse_Modello: string | null | undefined, payload_VerificaEnergeticaBiomasse_Matricola: string | null | undefined, payload_VerificaEnergeticaBiomasse_PotenzaFocolare: string | null | undefined, payload_VerificaEnergeticaBiomasse_PotenzaUtile: string | null | undefined, payload_VerificaEnergeticaBiomasse_TipologiaGruppo: TipoGruppoBiomasse | null | undefined, payload_VerificaEnergeticaBiomasse_AltroGruppo1: string | null | undefined, payload_VerificaEnergeticaBiomasse_AltroGruppo2: string | null | undefined, payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale: boolean | undefined, payload_VerificaEnergeticaBiomasse_ProduzioneAcs: boolean | undefined, payload_VerificaEnergeticaBiomasse_Cucina: boolean | undefined, payload_VerificaEnergeticaBiomasse_Combustibile: TipoCombustibile | null | undefined, payload_VerificaEnergeticaBiomasse_AltroCombustibile: string | null | undefined, payload_VerificaEnergeticaBiomasse_DispositiviComando: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_DispositiviSicurezza: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_ValvolaSicurezza: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_ControllatoPulito: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_PresenzaRiflusso: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_RisultatiControllo: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_MarcaturaCE: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_PlaccaCamino: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_EvacuazioneFumi: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_AriaComburente: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_ControlloAriaComburente: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_CaricamentoCombustibile: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_AriaCombustibile: boolean | null | undefined, payload_Misurazioni_TemperaturaFumi: string | null | undefined, payload_Misurazioni_TemperaturaComburente: string | null | undefined, payload_Misurazioni_O2: string | null | undefined, payload_Misurazioni_Co2: string | null | undefined, payload_Misurazioni_Bach1: string | null | undefined, payload_Misurazioni_Bach2: string | null | undefined, payload_Misurazioni_Bach3: string | null | undefined, payload_Misurazioni_Co2FumiSecchi: string | null | undefined, payload_Misurazioni_Co2Corretto: string | null | undefined, payload_Misurazioni_PortataCombustibile: string | null | undefined, payload_Misurazioni_RendimentoCombustione: string | null | undefined, payload_Misurazioni_RendimentoMinimo: string | null | undefined, payload_Misurazioni_ModuloTermico: string | null | undefined, payload_Misurazioni_RispettaIndice: boolean | null | undefined, payload_Misurazioni_CoSecchiMinore1000: boolean | null | undefined, payload_Misurazioni_RendimentoMaggiore: boolean | null | undefined, payload_Misurazioni_Nox: string | null | undefined, payload_CheckList_AdozioneValvole: boolean | undefined, payload_CheckList_IsolamentoRete: boolean | undefined, payload_CheckList_IntroduzioneSistema: boolean | undefined, payload_CheckList_SostituzioneSistema: boolean | undefined, payload_CheckList_Osservazioni: string | null | undefined, payload_CheckList_Osservazioni2: string | null | undefined, payload_CheckList_Raccomandazioni: string | null | undefined, payload_CheckList_Raccomandazioni2: string | null | undefined, payload_CheckList_Prescrizioni: string | null | undefined, payload_CheckList_Prescrizioni2: string | null | undefined, payload_CheckList_ImpiantoPuoFunzionare: boolean | null | undefined, payload_CheckList_DataControllo: string | null | undefined, payload_CheckList_OrarioArrivo: string | null | undefined, payload_CheckList_OrarioPartenza: string | null | undefined, payload_CheckList_NomeTecnico: string | null | undefined, payload_CheckList_ControlloEntroIl: string | null | undefined, payload_TrattamentoAcquaLombardia: TrattamentoAcquaLombardia[] | null | undefined, payload_CombustileLombardia: CombustibileLombardia[] | null | undefined, payload_ElettricitaLombardia: ElettricitaLombardia[] | null | undefined, type: RapportoControlloTypeDto): Promise<FileResponse | null>;

    saveFrigo(year: number | undefined, number: number | undefined, payload_DatiImpianto_TargaImpianto: string | null | undefined, payload_DatiImpianto_PotenzaNominale: string | null | undefined, payload_DatiImpianto_Comune: string | null | undefined, payload_DatiImpianto_Provincia: string | null | undefined, payload_DatiImpianto_Indirizzo: string | null | undefined, payload_DatiImpianto_Piano: string | null | undefined, payload_DatiImpianto_Pod: string | null | undefined, payload_DatiImpianto_Pdr: string | null | undefined, payload_DatiImpianto_Scala: string | null | undefined, payload_DatiImpianto_Interno: string | null | undefined, payload_DatiImpianto_Sezione: string | null | undefined, payload_DatiImpianto_Foglio: string | null | undefined, payload_DatiImpianto_Particella: string | null | undefined, payload_DatiImpianto_Sub: string | null | undefined, payload_Responsabile_Nominativo: string | null | undefined, payload_Responsabile_PartitaIva: string | null | undefined, payload_Responsabile_CodiceFiscale: string | null | undefined, payload_Responsabile_RagioneSociale: string | null | undefined, payload_Responsabile_Indirizzo: string | null | undefined, payload_Responsabile_Comune: string | null | undefined, payload_Responsabile_Provincia: string | null | undefined, payload_Responsabile_TipoResponsabile: TipoResponsabile | null | undefined, payload_ImpresaManutentrice_RagioneSociale: string | null | undefined, payload_ImpresaManutentrice_PartitaIva: string | null | undefined, payload_ImpresaManutentrice_Indirizzo: string | null | undefined, payload_ImpresaManutentrice_Comune: string | null | undefined, payload_ImpresaManutentrice_Provincia: string | null | undefined, payload_DocumentazioneCorredo_ConformitaPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoGeneratorePresente: boolean | null | undefined, payload_DocumentazioneCorredo_CompilatoTutteParti: boolean | null | undefined, payload_TrattamentoAcqua_DurezzaTotale: string | null | undefined, payload_TrattamentoAcqua_TrattamentoNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAssente: boolean | undefined, payload_TrattamentoAcqua_TrattamentoFiltrazione: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAddolcimento: boolean | undefined, payload_TrattamentoAcqua_TrattamentoChimico: boolean | undefined, payload_ControlloImpianto_LocaleInstallazioneIdoneo: Flag | undefined, payload_ControlloImpianto_AperureAdeguate: Flag | undefined, payload_ControlloImpianto_VentilazioneLibere: Flag | undefined, payload_ControlloImpianto_LineeElettricheIdonee: Flag | undefined, payload_ControlloImpianto_CoibentazioniIdonee: Flag | undefined, payload_VerificaEnergetica_CodGruppo: string | null | undefined, payload_VerificaEnergetica_Fabbricante: string | null | undefined, payload_VerificaEnergetica_Modello: string | null | undefined, payload_VerificaEnergetica_Matricola: string | null | undefined, payload_VerificaEnergetica_NrCircuiti: number | undefined, payload_VerificaEnergetica_PotenzaNominaleRaffrescamento: number | undefined, payload_VerificaEnergetica_PotenzaNominaleRiscaldamento: number | undefined, payload_VerificaEnergetica_ProvaRaffrescamento: boolean | undefined, payload_VerificaEnergetica_RecuperoCalore: boolean | undefined, payload_VerificaEnergetica_AssorbimentoFiammaDiretta: boolean | undefined, payload_VerificaEnergetica_CicloCompressione: boolean | undefined, payload_VerificaEnergetica_AssenzaPerditeGas: Flag | undefined, payload_VerificaEnergetica_PresenzaLeakDetector: Flag | undefined, payload_VerificaEnergetica_PresenzaFugheRefrigerante: Flag | undefined, payload_VerificaEnergetica_ScambiatoriPuliti: Flag | undefined, payload_Misurazioni_Surriscald: number | undefined, payload_Misurazioni_Sottoraffredd: number | undefined, payload_Misurazioni_TCondens: number | undefined, payload_Misurazioni_TEvapor: number | undefined, payload_Misurazioni_TIngLatoEst: number | undefined, payload_Misurazioni_TUscLatoEst: number | undefined, payload_Misurazioni_TIngLatUtenze: number | undefined, payload_Misurazioni_TUscLatUtenze: number | undefined, payload_Misurazioni_NCircuito: number | undefined, payload_CheckList_SostituzioneGeneratoriF1: boolean | undefined, payload_CheckList_SostituzioneSistemiF2: boolean | undefined, payload_CheckList_IsolamentoReteF3: boolean | undefined, payload_CheckList_IsolamentoCanaliF4: boolean | undefined, payload_CheckList_Osservazioni: string | null | undefined, payload_CheckList_Osservazioni2: string | null | undefined, payload_CheckList_Raccomandazioni: string | null | undefined, payload_CheckList_Raccomandazioni2: string | null | undefined, payload_CheckList_Prescrizioni: string | null | undefined, payload_CheckList_Prescrizioni2: string | null | undefined, payload_CheckList_ImpiantoPuoFunzionare: boolean | null | undefined, payload_CheckList_DataControllo: string | null | undefined, payload_CheckList_OrarioArrivo: string | null | undefined, payload_CheckList_OrarioPartenza: string | null | undefined, payload_CheckList_NomeTecnico: string | null | undefined, payload_CheckList_ControlloEntroIl: string | null | undefined, type: RapportoControlloTypeDto): Promise<FileResponse | null>;
}

export class RapportiControlloLayoutClient extends BaseClient implements IRapportiControlloLayoutClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendByMail(customerEmail: string | null | undefined, saveCustomerEmail: boolean | undefined, year: number | undefined, number: number | undefined, type: RapportoControlloTypeDto | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/SendByMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerEmail !== null && customerEmail !== undefined)
            content_.append("CustomerEmail", customerEmail.toString());
        if (saveCustomerEmail === null || saveCustomerEmail === undefined)
            throw new Error("The parameter 'saveCustomerEmail' cannot be null.");
        else
            content_.append("SaveCustomerEmail", saveCustomerEmail.toString());
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (number === null || number === undefined)
            throw new Error("The parameter 'number' cannot be null.");
        else
            content_.append("Number", number.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendByMail(_response);
        });
    }

    protected processSendByMail(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    save(year: number | undefined, number: number | undefined, payload_DatiImpianto_TargaImpianto: string | null | undefined, payload_DatiImpianto_PotenzaNominale: string | null | undefined, payload_DatiImpianto_Comune: string | null | undefined, payload_DatiImpianto_Provincia: string | null | undefined, payload_DatiImpianto_Indirizzo: string | null | undefined, payload_DatiImpianto_Piano: string | null | undefined, payload_DatiImpianto_Pod: string | null | undefined, payload_DatiImpianto_Pdr: string | null | undefined, payload_DatiImpianto_Scala: string | null | undefined, payload_DatiImpianto_Interno: string | null | undefined, payload_DatiImpianto_Sezione: string | null | undefined, payload_DatiImpianto_Foglio: string | null | undefined, payload_DatiImpianto_Particella: string | null | undefined, payload_DatiImpianto_Sub: string | null | undefined, payload_Responsabile_Nominativo: string | null | undefined, payload_Responsabile_PartitaIva: string | null | undefined, payload_Responsabile_CodiceFiscale: string | null | undefined, payload_Responsabile_RagioneSociale: string | null | undefined, payload_Responsabile_Indirizzo: string | null | undefined, payload_Responsabile_Comune: string | null | undefined, payload_Responsabile_Provincia: string | null | undefined, payload_Responsabile_TipoResponsabile: TipoResponsabile | null | undefined, payload_ImpresaManutentrice_RagioneSociale: string | null | undefined, payload_ImpresaManutentrice_PartitaIva: string | null | undefined, payload_ImpresaManutentrice_Indirizzo: string | null | undefined, payload_ImpresaManutentrice_Comune: string | null | undefined, payload_ImpresaManutentrice_Provincia: string | null | undefined, payload_DocumentazioneCorredo_ConformitaPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoGeneratorePresente: boolean | null | undefined, payload_DocumentazioneCorredo_CompilatoTutteParti: boolean | null | undefined, payload_TrattamentoAcqua_DurezzaTotale: string | null | undefined, payload_TrattamentoAcqua_TrattamentoNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAssente: boolean | undefined, payload_TrattamentoAcqua_TrattamentoFiltrazione: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAddolcimento: boolean | undefined, payload_TrattamentoAcqua_TrattamentoChimico: boolean | undefined, payload_TrattamentoAcqua_AcsNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_AcsAssente: boolean | undefined, payload_TrattamentoAcqua_AcsFiltrazione: boolean | undefined, payload_TrattamentoAcqua_AcsAddolcimento: boolean | undefined, payload_TrattamentoAcqua_AcsChimico: boolean | undefined, payload_ControlloImpianto_InstallazioneInterna: Flag | null | undefined, payload_ControlloImpianto_InstallazioneEsterna: Flag | null | undefined, payload_ControlloImpianto_ApertureVentilazione: Flag | null | undefined, payload_ControlloImpianto_AdeguateDimensioni: Flag | null | undefined, payload_ControlloImpianto_CanaleDiFumo: Flag | null | undefined, payload_ControlloImpianto_SistemaRegolazione: Flag | null | undefined, payload_ControlloImpianto_AssenzaPerdite: Flag | null | undefined, payload_ControlloImpianto_IdoneaTenuta: Flag | null | undefined, payload_ControlloImpiantoBiomasse_InstallazioneInterna: Flag | null | undefined, payload_ControlloImpiantoBiomasse_InstallazioneEsterna: Flag | null | undefined, payload_ControlloImpiantoBiomasse_ApertureVentilazione: Flag | null | undefined, payload_ControlloImpiantoBiomasse_AdeguateDimensioni: Flag | null | undefined, payload_ControlloImpiantoBiomasse_CanaleDiFumo: Flag | null | undefined, payload_ControlloImpiantoBiomasse_SistemaRegolazione: Flag | null | undefined, payload_ControlloImpiantoBiomasse_IdoneaTenuta: Flag | null | undefined, payload_ControlloImpiantoBiomasse_PuliziaCamino: Flag | null | undefined, payload_VerificaEnergetica_CodGruppo: string | null | undefined, payload_VerificaEnergetica_DataInstallazione: string | null | undefined, payload_VerificaEnergetica_Fabbricante: string | null | undefined, payload_VerificaEnergetica_Modello: string | null | undefined, payload_VerificaEnergetica_Matricola: string | null | undefined, payload_VerificaEnergetica_TipologiaGruppo: TipoGruppo | null | undefined, payload_VerificaEnergetica_TipoGruppo_GruppoSingolo: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_GruppoModulare: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_GeneratoreAria: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Tradizionale: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Condensazione: boolean | undefined, payload_VerificaEnergetica_TipoGruppo_Altro: boolean | undefined, payload_VerificaEnergetica_AltroGruppo: string | null | undefined, payload_VerificaEnergetica_PotenzaFocolare: string | null | undefined, payload_VerificaEnergetica_PotenzaUtile: string | null | undefined, payload_VerificaEnergetica_ClimatizzazioneInvernale: boolean | undefined, payload_VerificaEnergetica_ProduzioneAcs: boolean | undefined, payload_VerificaEnergetica_Combustibile: TipoCombustibile | null | undefined, payload_VerificaEnergetica_AltroCombustibile: string | null | undefined, payload_VerificaEnergetica_DispositiviComando: Flag | null | undefined, payload_VerificaEnergetica_DispositiviSicurezza: Flag | null | undefined, payload_VerificaEnergetica_ValvolaSicurezza: Flag | null | undefined, payload_VerificaEnergetica_ControllatoPulito: Flag | null | undefined, payload_VerificaEnergetica_PresenzaRiflusso: Flag | null | undefined, payload_VerificaEnergetica_RisultatiControllo: Flag | null | undefined, payload_VerificaEnergetica_Tiraggio: TipoTiraggio | null | undefined, payload_VerificaEnergetica_DepressioneCanale: string | null | undefined, payload_VerificaEnergeticaBiomasse_CodGruppo: string | null | undefined, payload_VerificaEnergeticaBiomasse_DataInstallazione: string | null | undefined, payload_VerificaEnergeticaBiomasse_Fabbricante: string | null | undefined, payload_VerificaEnergeticaBiomasse_Modello: string | null | undefined, payload_VerificaEnergeticaBiomasse_Matricola: string | null | undefined, payload_VerificaEnergeticaBiomasse_PotenzaFocolare: string | null | undefined, payload_VerificaEnergeticaBiomasse_PotenzaUtile: string | null | undefined, payload_VerificaEnergeticaBiomasse_TipologiaGruppo: TipoGruppoBiomasse | null | undefined, payload_VerificaEnergeticaBiomasse_AltroGruppo1: string | null | undefined, payload_VerificaEnergeticaBiomasse_AltroGruppo2: string | null | undefined, payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale: boolean | undefined, payload_VerificaEnergeticaBiomasse_ProduzioneAcs: boolean | undefined, payload_VerificaEnergeticaBiomasse_Cucina: boolean | undefined, payload_VerificaEnergeticaBiomasse_Combustibile: TipoCombustibile | null | undefined, payload_VerificaEnergeticaBiomasse_AltroCombustibile: string | null | undefined, payload_VerificaEnergeticaBiomasse_DispositiviComando: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_DispositiviSicurezza: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_ValvolaSicurezza: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_ControllatoPulito: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_PresenzaRiflusso: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_RisultatiControllo: Flag | null | undefined, payload_VerificaEnergeticaBiomasse_MarcaturaCE: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_PlaccaCamino: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_EvacuazioneFumi: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_AriaComburente: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_ControlloAriaComburente: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_CaricamentoCombustibile: boolean | null | undefined, payload_VerificaEnergeticaBiomasse_AriaCombustibile: boolean | null | undefined, payload_Misurazioni_TemperaturaFumi: string | null | undefined, payload_Misurazioni_TemperaturaComburente: string | null | undefined, payload_Misurazioni_O2: string | null | undefined, payload_Misurazioni_Co2: string | null | undefined, payload_Misurazioni_Bach1: string | null | undefined, payload_Misurazioni_Bach2: string | null | undefined, payload_Misurazioni_Bach3: string | null | undefined, payload_Misurazioni_Co2FumiSecchi: string | null | undefined, payload_Misurazioni_Co2Corretto: string | null | undefined, payload_Misurazioni_PortataCombustibile: string | null | undefined, payload_Misurazioni_RendimentoCombustione: string | null | undefined, payload_Misurazioni_RendimentoMinimo: string | null | undefined, payload_Misurazioni_ModuloTermico: string | null | undefined, payload_Misurazioni_RispettaIndice: boolean | null | undefined, payload_Misurazioni_CoSecchiMinore1000: boolean | null | undefined, payload_Misurazioni_RendimentoMaggiore: boolean | null | undefined, payload_Misurazioni_Nox: string | null | undefined, payload_CheckList_AdozioneValvole: boolean | undefined, payload_CheckList_IsolamentoRete: boolean | undefined, payload_CheckList_IntroduzioneSistema: boolean | undefined, payload_CheckList_SostituzioneSistema: boolean | undefined, payload_CheckList_Osservazioni: string | null | undefined, payload_CheckList_Osservazioni2: string | null | undefined, payload_CheckList_Raccomandazioni: string | null | undefined, payload_CheckList_Raccomandazioni2: string | null | undefined, payload_CheckList_Prescrizioni: string | null | undefined, payload_CheckList_Prescrizioni2: string | null | undefined, payload_CheckList_ImpiantoPuoFunzionare: boolean | null | undefined, payload_CheckList_DataControllo: string | null | undefined, payload_CheckList_OrarioArrivo: string | null | undefined, payload_CheckList_OrarioPartenza: string | null | undefined, payload_CheckList_NomeTecnico: string | null | undefined, payload_CheckList_ControlloEntroIl: string | null | undefined, payload_TrattamentoAcquaLombardia: TrattamentoAcquaLombardia[] | null | undefined, payload_CombustileLombardia: CombustibileLombardia[] | null | undefined, payload_ElettricitaLombardia: ElettricitaLombardia[] | null | undefined, type: RapportoControlloTypeDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/save/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (number === null || number === undefined)
            throw new Error("The parameter 'number' cannot be null.");
        else
            content_.append("Number", number.toString());
        if (payload_DatiImpianto_TargaImpianto !== null && payload_DatiImpianto_TargaImpianto !== undefined)
            content_.append("Payload.DatiImpianto.TargaImpianto", payload_DatiImpianto_TargaImpianto.toString());
        if (payload_DatiImpianto_PotenzaNominale !== null && payload_DatiImpianto_PotenzaNominale !== undefined)
            content_.append("Payload.DatiImpianto.PotenzaNominale", payload_DatiImpianto_PotenzaNominale.toString());
        if (payload_DatiImpianto_Comune !== null && payload_DatiImpianto_Comune !== undefined)
            content_.append("Payload.DatiImpianto.Comune", payload_DatiImpianto_Comune.toString());
        if (payload_DatiImpianto_Provincia !== null && payload_DatiImpianto_Provincia !== undefined)
            content_.append("Payload.DatiImpianto.Provincia", payload_DatiImpianto_Provincia.toString());
        if (payload_DatiImpianto_Indirizzo !== null && payload_DatiImpianto_Indirizzo !== undefined)
            content_.append("Payload.DatiImpianto.Indirizzo", payload_DatiImpianto_Indirizzo.toString());
        if (payload_DatiImpianto_Piano !== null && payload_DatiImpianto_Piano !== undefined)
            content_.append("Payload.DatiImpianto.Piano", payload_DatiImpianto_Piano.toString());
        if (payload_DatiImpianto_Pod !== null && payload_DatiImpianto_Pod !== undefined)
            content_.append("Payload.DatiImpianto.Pod", payload_DatiImpianto_Pod.toString());
        if (payload_DatiImpianto_Pdr !== null && payload_DatiImpianto_Pdr !== undefined)
            content_.append("Payload.DatiImpianto.Pdr", payload_DatiImpianto_Pdr.toString());
        if (payload_DatiImpianto_Scala !== null && payload_DatiImpianto_Scala !== undefined)
            content_.append("Payload.DatiImpianto.Scala", payload_DatiImpianto_Scala.toString());
        if (payload_DatiImpianto_Interno !== null && payload_DatiImpianto_Interno !== undefined)
            content_.append("Payload.DatiImpianto.Interno", payload_DatiImpianto_Interno.toString());
        if (payload_DatiImpianto_Sezione !== null && payload_DatiImpianto_Sezione !== undefined)
            content_.append("Payload.DatiImpianto.Sezione", payload_DatiImpianto_Sezione.toString());
        if (payload_DatiImpianto_Foglio !== null && payload_DatiImpianto_Foglio !== undefined)
            content_.append("Payload.DatiImpianto.Foglio", payload_DatiImpianto_Foglio.toString());
        if (payload_DatiImpianto_Particella !== null && payload_DatiImpianto_Particella !== undefined)
            content_.append("Payload.DatiImpianto.Particella", payload_DatiImpianto_Particella.toString());
        if (payload_DatiImpianto_Sub !== null && payload_DatiImpianto_Sub !== undefined)
            content_.append("Payload.DatiImpianto.Sub", payload_DatiImpianto_Sub.toString());
        if (payload_Responsabile_Nominativo !== null && payload_Responsabile_Nominativo !== undefined)
            content_.append("Payload.Responsabile.Nominativo", payload_Responsabile_Nominativo.toString());
        if (payload_Responsabile_PartitaIva !== null && payload_Responsabile_PartitaIva !== undefined)
            content_.append("Payload.Responsabile.PartitaIva", payload_Responsabile_PartitaIva.toString());
        if (payload_Responsabile_CodiceFiscale !== null && payload_Responsabile_CodiceFiscale !== undefined)
            content_.append("Payload.Responsabile.CodiceFiscale", payload_Responsabile_CodiceFiscale.toString());
        if (payload_Responsabile_RagioneSociale !== null && payload_Responsabile_RagioneSociale !== undefined)
            content_.append("Payload.Responsabile.RagioneSociale", payload_Responsabile_RagioneSociale.toString());
        if (payload_Responsabile_Indirizzo !== null && payload_Responsabile_Indirizzo !== undefined)
            content_.append("Payload.Responsabile.Indirizzo", payload_Responsabile_Indirizzo.toString());
        if (payload_Responsabile_Comune !== null && payload_Responsabile_Comune !== undefined)
            content_.append("Payload.Responsabile.Comune", payload_Responsabile_Comune.toString());
        if (payload_Responsabile_Provincia !== null && payload_Responsabile_Provincia !== undefined)
            content_.append("Payload.Responsabile.Provincia", payload_Responsabile_Provincia.toString());
        if (payload_Responsabile_TipoResponsabile !== null && payload_Responsabile_TipoResponsabile !== undefined)
            content_.append("Payload.Responsabile.TipoResponsabile", payload_Responsabile_TipoResponsabile.toString());
        if (payload_ImpresaManutentrice_RagioneSociale !== null && payload_ImpresaManutentrice_RagioneSociale !== undefined)
            content_.append("Payload.ImpresaManutentrice.RagioneSociale", payload_ImpresaManutentrice_RagioneSociale.toString());
        if (payload_ImpresaManutentrice_PartitaIva !== null && payload_ImpresaManutentrice_PartitaIva !== undefined)
            content_.append("Payload.ImpresaManutentrice.PartitaIva", payload_ImpresaManutentrice_PartitaIva.toString());
        if (payload_ImpresaManutentrice_Indirizzo !== null && payload_ImpresaManutentrice_Indirizzo !== undefined)
            content_.append("Payload.ImpresaManutentrice.Indirizzo", payload_ImpresaManutentrice_Indirizzo.toString());
        if (payload_ImpresaManutentrice_Comune !== null && payload_ImpresaManutentrice_Comune !== undefined)
            content_.append("Payload.ImpresaManutentrice.Comune", payload_ImpresaManutentrice_Comune.toString());
        if (payload_ImpresaManutentrice_Provincia !== null && payload_ImpresaManutentrice_Provincia !== undefined)
            content_.append("Payload.ImpresaManutentrice.Provincia", payload_ImpresaManutentrice_Provincia.toString());
        if (payload_DocumentazioneCorredo_ConformitaPresente !== null && payload_DocumentazioneCorredo_ConformitaPresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.ConformitaPresente", payload_DocumentazioneCorredo_ConformitaPresente.toString());
        if (payload_DocumentazioneCorredo_LibrettoPresente !== null && payload_DocumentazioneCorredo_LibrettoPresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.LibrettoPresente", payload_DocumentazioneCorredo_LibrettoPresente.toString());
        if (payload_DocumentazioneCorredo_LibrettoGeneratorePresente !== null && payload_DocumentazioneCorredo_LibrettoGeneratorePresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.LibrettoGeneratorePresente", payload_DocumentazioneCorredo_LibrettoGeneratorePresente.toString());
        if (payload_DocumentazioneCorredo_CompilatoTutteParti !== null && payload_DocumentazioneCorredo_CompilatoTutteParti !== undefined)
            content_.append("Payload.DocumentazioneCorredo.CompilatoTutteParti", payload_DocumentazioneCorredo_CompilatoTutteParti.toString());
        if (payload_TrattamentoAcqua_DurezzaTotale !== null && payload_TrattamentoAcqua_DurezzaTotale !== undefined)
            content_.append("Payload.TrattamentoAcqua.DurezzaTotale", payload_TrattamentoAcqua_DurezzaTotale.toString());
        if (payload_TrattamentoAcqua_TrattamentoNonRichiesto === null || payload_TrattamentoAcqua_TrattamentoNonRichiesto === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoNonRichiesto' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoNonRichiesto", payload_TrattamentoAcqua_TrattamentoNonRichiesto.toString());
        if (payload_TrattamentoAcqua_TrattamentoAssente === null || payload_TrattamentoAcqua_TrattamentoAssente === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoAssente' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoAssente", payload_TrattamentoAcqua_TrattamentoAssente.toString());
        if (payload_TrattamentoAcqua_TrattamentoFiltrazione === null || payload_TrattamentoAcqua_TrattamentoFiltrazione === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoFiltrazione' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoFiltrazione", payload_TrattamentoAcqua_TrattamentoFiltrazione.toString());
        if (payload_TrattamentoAcqua_TrattamentoAddolcimento === null || payload_TrattamentoAcqua_TrattamentoAddolcimento === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoAddolcimento' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoAddolcimento", payload_TrattamentoAcqua_TrattamentoAddolcimento.toString());
        if (payload_TrattamentoAcqua_TrattamentoChimico === null || payload_TrattamentoAcqua_TrattamentoChimico === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoChimico' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoChimico", payload_TrattamentoAcqua_TrattamentoChimico.toString());
        if (payload_TrattamentoAcqua_AcsNonRichiesto === null || payload_TrattamentoAcqua_AcsNonRichiesto === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_AcsNonRichiesto' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.AcsNonRichiesto", payload_TrattamentoAcqua_AcsNonRichiesto.toString());
        if (payload_TrattamentoAcqua_AcsAssente === null || payload_TrattamentoAcqua_AcsAssente === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_AcsAssente' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.AcsAssente", payload_TrattamentoAcqua_AcsAssente.toString());
        if (payload_TrattamentoAcqua_AcsFiltrazione === null || payload_TrattamentoAcqua_AcsFiltrazione === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_AcsFiltrazione' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.AcsFiltrazione", payload_TrattamentoAcqua_AcsFiltrazione.toString());
        if (payload_TrattamentoAcqua_AcsAddolcimento === null || payload_TrattamentoAcqua_AcsAddolcimento === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_AcsAddolcimento' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.AcsAddolcimento", payload_TrattamentoAcqua_AcsAddolcimento.toString());
        if (payload_TrattamentoAcqua_AcsChimico === null || payload_TrattamentoAcqua_AcsChimico === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_AcsChimico' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.AcsChimico", payload_TrattamentoAcqua_AcsChimico.toString());
        if (payload_ControlloImpianto_InstallazioneInterna !== null && payload_ControlloImpianto_InstallazioneInterna !== undefined)
            content_.append("Payload.ControlloImpianto.InstallazioneInterna", payload_ControlloImpianto_InstallazioneInterna.toString());
        if (payload_ControlloImpianto_InstallazioneEsterna !== null && payload_ControlloImpianto_InstallazioneEsterna !== undefined)
            content_.append("Payload.ControlloImpianto.InstallazioneEsterna", payload_ControlloImpianto_InstallazioneEsterna.toString());
        if (payload_ControlloImpianto_ApertureVentilazione !== null && payload_ControlloImpianto_ApertureVentilazione !== undefined)
            content_.append("Payload.ControlloImpianto.ApertureVentilazione", payload_ControlloImpianto_ApertureVentilazione.toString());
        if (payload_ControlloImpianto_AdeguateDimensioni !== null && payload_ControlloImpianto_AdeguateDimensioni !== undefined)
            content_.append("Payload.ControlloImpianto.AdeguateDimensioni", payload_ControlloImpianto_AdeguateDimensioni.toString());
        if (payload_ControlloImpianto_CanaleDiFumo !== null && payload_ControlloImpianto_CanaleDiFumo !== undefined)
            content_.append("Payload.ControlloImpianto.CanaleDiFumo", payload_ControlloImpianto_CanaleDiFumo.toString());
        if (payload_ControlloImpianto_SistemaRegolazione !== null && payload_ControlloImpianto_SistemaRegolazione !== undefined)
            content_.append("Payload.ControlloImpianto.SistemaRegolazione", payload_ControlloImpianto_SistemaRegolazione.toString());
        if (payload_ControlloImpianto_AssenzaPerdite !== null && payload_ControlloImpianto_AssenzaPerdite !== undefined)
            content_.append("Payload.ControlloImpianto.AssenzaPerdite", payload_ControlloImpianto_AssenzaPerdite.toString());
        if (payload_ControlloImpianto_IdoneaTenuta !== null && payload_ControlloImpianto_IdoneaTenuta !== undefined)
            content_.append("Payload.ControlloImpianto.IdoneaTenuta", payload_ControlloImpianto_IdoneaTenuta.toString());
        if (payload_ControlloImpiantoBiomasse_InstallazioneInterna !== null && payload_ControlloImpiantoBiomasse_InstallazioneInterna !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.InstallazioneInterna", payload_ControlloImpiantoBiomasse_InstallazioneInterna.toString());
        if (payload_ControlloImpiantoBiomasse_InstallazioneEsterna !== null && payload_ControlloImpiantoBiomasse_InstallazioneEsterna !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.InstallazioneEsterna", payload_ControlloImpiantoBiomasse_InstallazioneEsterna.toString());
        if (payload_ControlloImpiantoBiomasse_ApertureVentilazione !== null && payload_ControlloImpiantoBiomasse_ApertureVentilazione !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.ApertureVentilazione", payload_ControlloImpiantoBiomasse_ApertureVentilazione.toString());
        if (payload_ControlloImpiantoBiomasse_AdeguateDimensioni !== null && payload_ControlloImpiantoBiomasse_AdeguateDimensioni !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.AdeguateDimensioni", payload_ControlloImpiantoBiomasse_AdeguateDimensioni.toString());
        if (payload_ControlloImpiantoBiomasse_CanaleDiFumo !== null && payload_ControlloImpiantoBiomasse_CanaleDiFumo !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.CanaleDiFumo", payload_ControlloImpiantoBiomasse_CanaleDiFumo.toString());
        if (payload_ControlloImpiantoBiomasse_SistemaRegolazione !== null && payload_ControlloImpiantoBiomasse_SistemaRegolazione !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.SistemaRegolazione", payload_ControlloImpiantoBiomasse_SistemaRegolazione.toString());
        if (payload_ControlloImpiantoBiomasse_IdoneaTenuta !== null && payload_ControlloImpiantoBiomasse_IdoneaTenuta !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.IdoneaTenuta", payload_ControlloImpiantoBiomasse_IdoneaTenuta.toString());
        if (payload_ControlloImpiantoBiomasse_PuliziaCamino !== null && payload_ControlloImpiantoBiomasse_PuliziaCamino !== undefined)
            content_.append("Payload.ControlloImpiantoBiomasse.PuliziaCamino", payload_ControlloImpiantoBiomasse_PuliziaCamino.toString());
        if (payload_VerificaEnergetica_CodGruppo !== null && payload_VerificaEnergetica_CodGruppo !== undefined)
            content_.append("Payload.VerificaEnergetica.CodGruppo", payload_VerificaEnergetica_CodGruppo.toString());
        if (payload_VerificaEnergetica_DataInstallazione !== null && payload_VerificaEnergetica_DataInstallazione !== undefined)
            content_.append("Payload.VerificaEnergetica.DataInstallazione", payload_VerificaEnergetica_DataInstallazione.toString());
        if (payload_VerificaEnergetica_Fabbricante !== null && payload_VerificaEnergetica_Fabbricante !== undefined)
            content_.append("Payload.VerificaEnergetica.Fabbricante", payload_VerificaEnergetica_Fabbricante.toString());
        if (payload_VerificaEnergetica_Modello !== null && payload_VerificaEnergetica_Modello !== undefined)
            content_.append("Payload.VerificaEnergetica.Modello", payload_VerificaEnergetica_Modello.toString());
        if (payload_VerificaEnergetica_Matricola !== null && payload_VerificaEnergetica_Matricola !== undefined)
            content_.append("Payload.VerificaEnergetica.Matricola", payload_VerificaEnergetica_Matricola.toString());
        if (payload_VerificaEnergetica_TipologiaGruppo !== null && payload_VerificaEnergetica_TipologiaGruppo !== undefined)
            content_.append("Payload.VerificaEnergetica.TipologiaGruppo", payload_VerificaEnergetica_TipologiaGruppo.toString());
        if (payload_VerificaEnergetica_TipoGruppo_GruppoSingolo === null || payload_VerificaEnergetica_TipoGruppo_GruppoSingolo === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_GruppoSingolo' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.GruppoSingolo", payload_VerificaEnergetica_TipoGruppo_GruppoSingolo.toString());
        if (payload_VerificaEnergetica_TipoGruppo_GruppoModulare === null || payload_VerificaEnergetica_TipoGruppo_GruppoModulare === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_GruppoModulare' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.GruppoModulare", payload_VerificaEnergetica_TipoGruppo_GruppoModulare.toString());
        if (payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante === null || payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.TuboNastroRadiante", payload_VerificaEnergetica_TipoGruppo_TuboNastroRadiante.toString());
        if (payload_VerificaEnergetica_TipoGruppo_GeneratoreAria === null || payload_VerificaEnergetica_TipoGruppo_GeneratoreAria === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_GeneratoreAria' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.GeneratoreAria", payload_VerificaEnergetica_TipoGruppo_GeneratoreAria.toString());
        if (payload_VerificaEnergetica_TipoGruppo_Tradizionale === null || payload_VerificaEnergetica_TipoGruppo_Tradizionale === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_Tradizionale' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.Tradizionale", payload_VerificaEnergetica_TipoGruppo_Tradizionale.toString());
        if (payload_VerificaEnergetica_TipoGruppo_Condensazione === null || payload_VerificaEnergetica_TipoGruppo_Condensazione === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_Condensazione' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.Condensazione", payload_VerificaEnergetica_TipoGruppo_Condensazione.toString());
        if (payload_VerificaEnergetica_TipoGruppo_Altro === null || payload_VerificaEnergetica_TipoGruppo_Altro === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_TipoGruppo_Altro' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.TipoGruppo.Altro", payload_VerificaEnergetica_TipoGruppo_Altro.toString());
        if (payload_VerificaEnergetica_AltroGruppo !== null && payload_VerificaEnergetica_AltroGruppo !== undefined)
            content_.append("Payload.VerificaEnergetica.AltroGruppo", payload_VerificaEnergetica_AltroGruppo.toString());
        if (payload_VerificaEnergetica_PotenzaFocolare !== null && payload_VerificaEnergetica_PotenzaFocolare !== undefined)
            content_.append("Payload.VerificaEnergetica.PotenzaFocolare", payload_VerificaEnergetica_PotenzaFocolare.toString());
        if (payload_VerificaEnergetica_PotenzaUtile !== null && payload_VerificaEnergetica_PotenzaUtile !== undefined)
            content_.append("Payload.VerificaEnergetica.PotenzaUtile", payload_VerificaEnergetica_PotenzaUtile.toString());
        if (payload_VerificaEnergetica_ClimatizzazioneInvernale === null || payload_VerificaEnergetica_ClimatizzazioneInvernale === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_ClimatizzazioneInvernale' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.ClimatizzazioneInvernale", payload_VerificaEnergetica_ClimatizzazioneInvernale.toString());
        if (payload_VerificaEnergetica_ProduzioneAcs === null || payload_VerificaEnergetica_ProduzioneAcs === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_ProduzioneAcs' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.ProduzioneAcs", payload_VerificaEnergetica_ProduzioneAcs.toString());
        if (payload_VerificaEnergetica_Combustibile !== null && payload_VerificaEnergetica_Combustibile !== undefined)
            content_.append("Payload.VerificaEnergetica.Combustibile", payload_VerificaEnergetica_Combustibile.toString());
        if (payload_VerificaEnergetica_AltroCombustibile !== null && payload_VerificaEnergetica_AltroCombustibile !== undefined)
            content_.append("Payload.VerificaEnergetica.AltroCombustibile", payload_VerificaEnergetica_AltroCombustibile.toString());
        if (payload_VerificaEnergetica_DispositiviComando !== null && payload_VerificaEnergetica_DispositiviComando !== undefined)
            content_.append("Payload.VerificaEnergetica.DispositiviComando", payload_VerificaEnergetica_DispositiviComando.toString());
        if (payload_VerificaEnergetica_DispositiviSicurezza !== null && payload_VerificaEnergetica_DispositiviSicurezza !== undefined)
            content_.append("Payload.VerificaEnergetica.DispositiviSicurezza", payload_VerificaEnergetica_DispositiviSicurezza.toString());
        if (payload_VerificaEnergetica_ValvolaSicurezza !== null && payload_VerificaEnergetica_ValvolaSicurezza !== undefined)
            content_.append("Payload.VerificaEnergetica.ValvolaSicurezza", payload_VerificaEnergetica_ValvolaSicurezza.toString());
        if (payload_VerificaEnergetica_ControllatoPulito !== null && payload_VerificaEnergetica_ControllatoPulito !== undefined)
            content_.append("Payload.VerificaEnergetica.ControllatoPulito", payload_VerificaEnergetica_ControllatoPulito.toString());
        if (payload_VerificaEnergetica_PresenzaRiflusso !== null && payload_VerificaEnergetica_PresenzaRiflusso !== undefined)
            content_.append("Payload.VerificaEnergetica.PresenzaRiflusso", payload_VerificaEnergetica_PresenzaRiflusso.toString());
        if (payload_VerificaEnergetica_RisultatiControllo !== null && payload_VerificaEnergetica_RisultatiControllo !== undefined)
            content_.append("Payload.VerificaEnergetica.RisultatiControllo", payload_VerificaEnergetica_RisultatiControllo.toString());
        if (payload_VerificaEnergetica_Tiraggio !== null && payload_VerificaEnergetica_Tiraggio !== undefined)
            content_.append("Payload.VerificaEnergetica.Tiraggio", payload_VerificaEnergetica_Tiraggio.toString());
        if (payload_VerificaEnergetica_DepressioneCanale !== null && payload_VerificaEnergetica_DepressioneCanale !== undefined)
            content_.append("Payload.VerificaEnergetica.DepressioneCanale", payload_VerificaEnergetica_DepressioneCanale.toString());
        if (payload_VerificaEnergeticaBiomasse_CodGruppo !== null && payload_VerificaEnergeticaBiomasse_CodGruppo !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.CodGruppo", payload_VerificaEnergeticaBiomasse_CodGruppo.toString());
        if (payload_VerificaEnergeticaBiomasse_DataInstallazione !== null && payload_VerificaEnergeticaBiomasse_DataInstallazione !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.DataInstallazione", payload_VerificaEnergeticaBiomasse_DataInstallazione.toString());
        if (payload_VerificaEnergeticaBiomasse_Fabbricante !== null && payload_VerificaEnergeticaBiomasse_Fabbricante !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.Fabbricante", payload_VerificaEnergeticaBiomasse_Fabbricante.toString());
        if (payload_VerificaEnergeticaBiomasse_Modello !== null && payload_VerificaEnergeticaBiomasse_Modello !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.Modello", payload_VerificaEnergeticaBiomasse_Modello.toString());
        if (payload_VerificaEnergeticaBiomasse_Matricola !== null && payload_VerificaEnergeticaBiomasse_Matricola !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.Matricola", payload_VerificaEnergeticaBiomasse_Matricola.toString());
        if (payload_VerificaEnergeticaBiomasse_PotenzaFocolare !== null && payload_VerificaEnergeticaBiomasse_PotenzaFocolare !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.PotenzaFocolare", payload_VerificaEnergeticaBiomasse_PotenzaFocolare.toString());
        if (payload_VerificaEnergeticaBiomasse_PotenzaUtile !== null && payload_VerificaEnergeticaBiomasse_PotenzaUtile !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.PotenzaUtile", payload_VerificaEnergeticaBiomasse_PotenzaUtile.toString());
        if (payload_VerificaEnergeticaBiomasse_TipologiaGruppo !== null && payload_VerificaEnergeticaBiomasse_TipologiaGruppo !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.TipologiaGruppo", payload_VerificaEnergeticaBiomasse_TipologiaGruppo.toString());
        if (payload_VerificaEnergeticaBiomasse_AltroGruppo1 !== null && payload_VerificaEnergeticaBiomasse_AltroGruppo1 !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.AltroGruppo1", payload_VerificaEnergeticaBiomasse_AltroGruppo1.toString());
        if (payload_VerificaEnergeticaBiomasse_AltroGruppo2 !== null && payload_VerificaEnergeticaBiomasse_AltroGruppo2 !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.AltroGruppo2", payload_VerificaEnergeticaBiomasse_AltroGruppo2.toString());
        if (payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale === null || payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale === undefined)
            throw new Error("The parameter 'payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale' cannot be null.");
        else
            content_.append("Payload.VerificaEnergeticaBiomasse.ClimatizzazioneInvernale", payload_VerificaEnergeticaBiomasse_ClimatizzazioneInvernale.toString());
        if (payload_VerificaEnergeticaBiomasse_ProduzioneAcs === null || payload_VerificaEnergeticaBiomasse_ProduzioneAcs === undefined)
            throw new Error("The parameter 'payload_VerificaEnergeticaBiomasse_ProduzioneAcs' cannot be null.");
        else
            content_.append("Payload.VerificaEnergeticaBiomasse.ProduzioneAcs", payload_VerificaEnergeticaBiomasse_ProduzioneAcs.toString());
        if (payload_VerificaEnergeticaBiomasse_Cucina === null || payload_VerificaEnergeticaBiomasse_Cucina === undefined)
            throw new Error("The parameter 'payload_VerificaEnergeticaBiomasse_Cucina' cannot be null.");
        else
            content_.append("Payload.VerificaEnergeticaBiomasse.Cucina", payload_VerificaEnergeticaBiomasse_Cucina.toString());
        if (payload_VerificaEnergeticaBiomasse_Combustibile !== null && payload_VerificaEnergeticaBiomasse_Combustibile !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.Combustibile", payload_VerificaEnergeticaBiomasse_Combustibile.toString());
        if (payload_VerificaEnergeticaBiomasse_AltroCombustibile !== null && payload_VerificaEnergeticaBiomasse_AltroCombustibile !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.AltroCombustibile", payload_VerificaEnergeticaBiomasse_AltroCombustibile.toString());
        if (payload_VerificaEnergeticaBiomasse_DispositiviComando !== null && payload_VerificaEnergeticaBiomasse_DispositiviComando !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.DispositiviComando", payload_VerificaEnergeticaBiomasse_DispositiviComando.toString());
        if (payload_VerificaEnergeticaBiomasse_DispositiviSicurezza !== null && payload_VerificaEnergeticaBiomasse_DispositiviSicurezza !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.DispositiviSicurezza", payload_VerificaEnergeticaBiomasse_DispositiviSicurezza.toString());
        if (payload_VerificaEnergeticaBiomasse_ValvolaSicurezza !== null && payload_VerificaEnergeticaBiomasse_ValvolaSicurezza !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.ValvolaSicurezza", payload_VerificaEnergeticaBiomasse_ValvolaSicurezza.toString());
        if (payload_VerificaEnergeticaBiomasse_ControllatoPulito !== null && payload_VerificaEnergeticaBiomasse_ControllatoPulito !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.ControllatoPulito", payload_VerificaEnergeticaBiomasse_ControllatoPulito.toString());
        if (payload_VerificaEnergeticaBiomasse_PresenzaRiflusso !== null && payload_VerificaEnergeticaBiomasse_PresenzaRiflusso !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.PresenzaRiflusso", payload_VerificaEnergeticaBiomasse_PresenzaRiflusso.toString());
        if (payload_VerificaEnergeticaBiomasse_RisultatiControllo !== null && payload_VerificaEnergeticaBiomasse_RisultatiControllo !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.RisultatiControllo", payload_VerificaEnergeticaBiomasse_RisultatiControllo.toString());
        if (payload_VerificaEnergeticaBiomasse_MarcaturaCE !== null && payload_VerificaEnergeticaBiomasse_MarcaturaCE !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.MarcaturaCE", payload_VerificaEnergeticaBiomasse_MarcaturaCE.toString());
        if (payload_VerificaEnergeticaBiomasse_PlaccaCamino !== null && payload_VerificaEnergeticaBiomasse_PlaccaCamino !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.PlaccaCamino", payload_VerificaEnergeticaBiomasse_PlaccaCamino.toString());
        if (payload_VerificaEnergeticaBiomasse_EvacuazioneFumi !== null && payload_VerificaEnergeticaBiomasse_EvacuazioneFumi !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.EvacuazioneFumi", payload_VerificaEnergeticaBiomasse_EvacuazioneFumi.toString());
        if (payload_VerificaEnergeticaBiomasse_AriaComburente !== null && payload_VerificaEnergeticaBiomasse_AriaComburente !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.AriaComburente", payload_VerificaEnergeticaBiomasse_AriaComburente.toString());
        if (payload_VerificaEnergeticaBiomasse_ControlloAriaComburente !== null && payload_VerificaEnergeticaBiomasse_ControlloAriaComburente !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.ControlloAriaComburente", payload_VerificaEnergeticaBiomasse_ControlloAriaComburente.toString());
        if (payload_VerificaEnergeticaBiomasse_CaricamentoCombustibile !== null && payload_VerificaEnergeticaBiomasse_CaricamentoCombustibile !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.CaricamentoCombustibile", payload_VerificaEnergeticaBiomasse_CaricamentoCombustibile.toString());
        if (payload_VerificaEnergeticaBiomasse_AriaCombustibile !== null && payload_VerificaEnergeticaBiomasse_AriaCombustibile !== undefined)
            content_.append("Payload.VerificaEnergeticaBiomasse.AriaCombustibile", payload_VerificaEnergeticaBiomasse_AriaCombustibile.toString());
        if (payload_Misurazioni_TemperaturaFumi !== null && payload_Misurazioni_TemperaturaFumi !== undefined)
            content_.append("Payload.Misurazioni.TemperaturaFumi", payload_Misurazioni_TemperaturaFumi.toString());
        if (payload_Misurazioni_TemperaturaComburente !== null && payload_Misurazioni_TemperaturaComburente !== undefined)
            content_.append("Payload.Misurazioni.TemperaturaComburente", payload_Misurazioni_TemperaturaComburente.toString());
        if (payload_Misurazioni_O2 !== null && payload_Misurazioni_O2 !== undefined)
            content_.append("Payload.Misurazioni.O2", payload_Misurazioni_O2.toString());
        if (payload_Misurazioni_Co2 !== null && payload_Misurazioni_Co2 !== undefined)
            content_.append("Payload.Misurazioni.Co2", payload_Misurazioni_Co2.toString());
        if (payload_Misurazioni_Bach1 !== null && payload_Misurazioni_Bach1 !== undefined)
            content_.append("Payload.Misurazioni.Bach1", payload_Misurazioni_Bach1.toString());
        if (payload_Misurazioni_Bach2 !== null && payload_Misurazioni_Bach2 !== undefined)
            content_.append("Payload.Misurazioni.Bach2", payload_Misurazioni_Bach2.toString());
        if (payload_Misurazioni_Bach3 !== null && payload_Misurazioni_Bach3 !== undefined)
            content_.append("Payload.Misurazioni.Bach3", payload_Misurazioni_Bach3.toString());
        if (payload_Misurazioni_Co2FumiSecchi !== null && payload_Misurazioni_Co2FumiSecchi !== undefined)
            content_.append("Payload.Misurazioni.Co2FumiSecchi", payload_Misurazioni_Co2FumiSecchi.toString());
        if (payload_Misurazioni_Co2Corretto !== null && payload_Misurazioni_Co2Corretto !== undefined)
            content_.append("Payload.Misurazioni.Co2Corretto", payload_Misurazioni_Co2Corretto.toString());
        if (payload_Misurazioni_PortataCombustibile !== null && payload_Misurazioni_PortataCombustibile !== undefined)
            content_.append("Payload.Misurazioni.PortataCombustibile", payload_Misurazioni_PortataCombustibile.toString());
        if (payload_Misurazioni_RendimentoCombustione !== null && payload_Misurazioni_RendimentoCombustione !== undefined)
            content_.append("Payload.Misurazioni.RendimentoCombustione", payload_Misurazioni_RendimentoCombustione.toString());
        if (payload_Misurazioni_RendimentoMinimo !== null && payload_Misurazioni_RendimentoMinimo !== undefined)
            content_.append("Payload.Misurazioni.RendimentoMinimo", payload_Misurazioni_RendimentoMinimo.toString());
        if (payload_Misurazioni_ModuloTermico !== null && payload_Misurazioni_ModuloTermico !== undefined)
            content_.append("Payload.Misurazioni.ModuloTermico", payload_Misurazioni_ModuloTermico.toString());
        if (payload_Misurazioni_RispettaIndice !== null && payload_Misurazioni_RispettaIndice !== undefined)
            content_.append("Payload.Misurazioni.RispettaIndice", payload_Misurazioni_RispettaIndice.toString());
        if (payload_Misurazioni_CoSecchiMinore1000 !== null && payload_Misurazioni_CoSecchiMinore1000 !== undefined)
            content_.append("Payload.Misurazioni.CoSecchiMinore1000", payload_Misurazioni_CoSecchiMinore1000.toString());
        if (payload_Misurazioni_RendimentoMaggiore !== null && payload_Misurazioni_RendimentoMaggiore !== undefined)
            content_.append("Payload.Misurazioni.RendimentoMaggiore", payload_Misurazioni_RendimentoMaggiore.toString());
        if (payload_Misurazioni_Nox !== null && payload_Misurazioni_Nox !== undefined)
            content_.append("Payload.Misurazioni.Nox", payload_Misurazioni_Nox.toString());
        if (payload_CheckList_AdozioneValvole === null || payload_CheckList_AdozioneValvole === undefined)
            throw new Error("The parameter 'payload_CheckList_AdozioneValvole' cannot be null.");
        else
            content_.append("Payload.CheckList.AdozioneValvole", payload_CheckList_AdozioneValvole.toString());
        if (payload_CheckList_IsolamentoRete === null || payload_CheckList_IsolamentoRete === undefined)
            throw new Error("The parameter 'payload_CheckList_IsolamentoRete' cannot be null.");
        else
            content_.append("Payload.CheckList.IsolamentoRete", payload_CheckList_IsolamentoRete.toString());
        if (payload_CheckList_IntroduzioneSistema === null || payload_CheckList_IntroduzioneSistema === undefined)
            throw new Error("The parameter 'payload_CheckList_IntroduzioneSistema' cannot be null.");
        else
            content_.append("Payload.CheckList.IntroduzioneSistema", payload_CheckList_IntroduzioneSistema.toString());
        if (payload_CheckList_SostituzioneSistema === null || payload_CheckList_SostituzioneSistema === undefined)
            throw new Error("The parameter 'payload_CheckList_SostituzioneSistema' cannot be null.");
        else
            content_.append("Payload.CheckList.SostituzioneSistema", payload_CheckList_SostituzioneSistema.toString());
        if (payload_CheckList_Osservazioni !== null && payload_CheckList_Osservazioni !== undefined)
            content_.append("Payload.CheckList.Osservazioni", payload_CheckList_Osservazioni.toString());
        if (payload_CheckList_Osservazioni2 !== null && payload_CheckList_Osservazioni2 !== undefined)
            content_.append("Payload.CheckList.Osservazioni2", payload_CheckList_Osservazioni2.toString());
        if (payload_CheckList_Raccomandazioni !== null && payload_CheckList_Raccomandazioni !== undefined)
            content_.append("Payload.CheckList.Raccomandazioni", payload_CheckList_Raccomandazioni.toString());
        if (payload_CheckList_Raccomandazioni2 !== null && payload_CheckList_Raccomandazioni2 !== undefined)
            content_.append("Payload.CheckList.Raccomandazioni2", payload_CheckList_Raccomandazioni2.toString());
        if (payload_CheckList_Prescrizioni !== null && payload_CheckList_Prescrizioni !== undefined)
            content_.append("Payload.CheckList.Prescrizioni", payload_CheckList_Prescrizioni.toString());
        if (payload_CheckList_Prescrizioni2 !== null && payload_CheckList_Prescrizioni2 !== undefined)
            content_.append("Payload.CheckList.Prescrizioni2", payload_CheckList_Prescrizioni2.toString());
        if (payload_CheckList_ImpiantoPuoFunzionare !== null && payload_CheckList_ImpiantoPuoFunzionare !== undefined)
            content_.append("Payload.CheckList.ImpiantoPuoFunzionare", payload_CheckList_ImpiantoPuoFunzionare.toString());
        if (payload_CheckList_DataControllo !== null && payload_CheckList_DataControllo !== undefined)
            content_.append("Payload.CheckList.DataControllo", payload_CheckList_DataControllo.toString());
        if (payload_CheckList_OrarioArrivo !== null && payload_CheckList_OrarioArrivo !== undefined)
            content_.append("Payload.CheckList.OrarioArrivo", payload_CheckList_OrarioArrivo.toString());
        if (payload_CheckList_OrarioPartenza !== null && payload_CheckList_OrarioPartenza !== undefined)
            content_.append("Payload.CheckList.OrarioPartenza", payload_CheckList_OrarioPartenza.toString());
        if (payload_CheckList_NomeTecnico !== null && payload_CheckList_NomeTecnico !== undefined)
            content_.append("Payload.CheckList.NomeTecnico", payload_CheckList_NomeTecnico.toString());
        if (payload_CheckList_ControlloEntroIl !== null && payload_CheckList_ControlloEntroIl !== undefined)
            content_.append("Payload.CheckList.ControlloEntroIl", payload_CheckList_ControlloEntroIl.toString());
        if (payload_TrattamentoAcquaLombardia !== null && payload_TrattamentoAcquaLombardia !== undefined)
            payload_TrattamentoAcquaLombardia.forEach(item_ => content_.append("Payload.TrattamentoAcquaLombardia", item_.toString()));
        if (payload_CombustileLombardia !== null && payload_CombustileLombardia !== undefined)
            payload_CombustileLombardia.forEach(item_ => content_.append("Payload.CombustileLombardia", item_.toString()));
        if (payload_ElettricitaLombardia !== null && payload_ElettricitaLombardia !== undefined)
            payload_ElettricitaLombardia.forEach(item_ => content_.append("Payload.ElettricitaLombardia", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveFrigo(year: number | undefined, number: number | undefined, payload_DatiImpianto_TargaImpianto: string | null | undefined, payload_DatiImpianto_PotenzaNominale: string | null | undefined, payload_DatiImpianto_Comune: string | null | undefined, payload_DatiImpianto_Provincia: string | null | undefined, payload_DatiImpianto_Indirizzo: string | null | undefined, payload_DatiImpianto_Piano: string | null | undefined, payload_DatiImpianto_Pod: string | null | undefined, payload_DatiImpianto_Pdr: string | null | undefined, payload_DatiImpianto_Scala: string | null | undefined, payload_DatiImpianto_Interno: string | null | undefined, payload_DatiImpianto_Sezione: string | null | undefined, payload_DatiImpianto_Foglio: string | null | undefined, payload_DatiImpianto_Particella: string | null | undefined, payload_DatiImpianto_Sub: string | null | undefined, payload_Responsabile_Nominativo: string | null | undefined, payload_Responsabile_PartitaIva: string | null | undefined, payload_Responsabile_CodiceFiscale: string | null | undefined, payload_Responsabile_RagioneSociale: string | null | undefined, payload_Responsabile_Indirizzo: string | null | undefined, payload_Responsabile_Comune: string | null | undefined, payload_Responsabile_Provincia: string | null | undefined, payload_Responsabile_TipoResponsabile: TipoResponsabile | null | undefined, payload_ImpresaManutentrice_RagioneSociale: string | null | undefined, payload_ImpresaManutentrice_PartitaIva: string | null | undefined, payload_ImpresaManutentrice_Indirizzo: string | null | undefined, payload_ImpresaManutentrice_Comune: string | null | undefined, payload_ImpresaManutentrice_Provincia: string | null | undefined, payload_DocumentazioneCorredo_ConformitaPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoPresente: boolean | null | undefined, payload_DocumentazioneCorredo_LibrettoGeneratorePresente: boolean | null | undefined, payload_DocumentazioneCorredo_CompilatoTutteParti: boolean | null | undefined, payload_TrattamentoAcqua_DurezzaTotale: string | null | undefined, payload_TrattamentoAcqua_TrattamentoNonRichiesto: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAssente: boolean | undefined, payload_TrattamentoAcqua_TrattamentoFiltrazione: boolean | undefined, payload_TrattamentoAcqua_TrattamentoAddolcimento: boolean | undefined, payload_TrattamentoAcqua_TrattamentoChimico: boolean | undefined, payload_ControlloImpianto_LocaleInstallazioneIdoneo: Flag | undefined, payload_ControlloImpianto_AperureAdeguate: Flag | undefined, payload_ControlloImpianto_VentilazioneLibere: Flag | undefined, payload_ControlloImpianto_LineeElettricheIdonee: Flag | undefined, payload_ControlloImpianto_CoibentazioniIdonee: Flag | undefined, payload_VerificaEnergetica_CodGruppo: string | null | undefined, payload_VerificaEnergetica_Fabbricante: string | null | undefined, payload_VerificaEnergetica_Modello: string | null | undefined, payload_VerificaEnergetica_Matricola: string | null | undefined, payload_VerificaEnergetica_NrCircuiti: number | undefined, payload_VerificaEnergetica_PotenzaNominaleRaffrescamento: number | undefined, payload_VerificaEnergetica_PotenzaNominaleRiscaldamento: number | undefined, payload_VerificaEnergetica_ProvaRaffrescamento: boolean | undefined, payload_VerificaEnergetica_RecuperoCalore: boolean | undefined, payload_VerificaEnergetica_AssorbimentoFiammaDiretta: boolean | undefined, payload_VerificaEnergetica_CicloCompressione: boolean | undefined, payload_VerificaEnergetica_AssenzaPerditeGas: Flag | undefined, payload_VerificaEnergetica_PresenzaLeakDetector: Flag | undefined, payload_VerificaEnergetica_PresenzaFugheRefrigerante: Flag | undefined, payload_VerificaEnergetica_ScambiatoriPuliti: Flag | undefined, payload_Misurazioni_Surriscald: number | undefined, payload_Misurazioni_Sottoraffredd: number | undefined, payload_Misurazioni_TCondens: number | undefined, payload_Misurazioni_TEvapor: number | undefined, payload_Misurazioni_TIngLatoEst: number | undefined, payload_Misurazioni_TUscLatoEst: number | undefined, payload_Misurazioni_TIngLatUtenze: number | undefined, payload_Misurazioni_TUscLatUtenze: number | undefined, payload_Misurazioni_NCircuito: number | undefined, payload_CheckList_SostituzioneGeneratoriF1: boolean | undefined, payload_CheckList_SostituzioneSistemiF2: boolean | undefined, payload_CheckList_IsolamentoReteF3: boolean | undefined, payload_CheckList_IsolamentoCanaliF4: boolean | undefined, payload_CheckList_Osservazioni: string | null | undefined, payload_CheckList_Osservazioni2: string | null | undefined, payload_CheckList_Raccomandazioni: string | null | undefined, payload_CheckList_Raccomandazioni2: string | null | undefined, payload_CheckList_Prescrizioni: string | null | undefined, payload_CheckList_Prescrizioni2: string | null | undefined, payload_CheckList_ImpiantoPuoFunzionare: boolean | null | undefined, payload_CheckList_DataControllo: string | null | undefined, payload_CheckList_OrarioArrivo: string | null | undefined, payload_CheckList_OrarioPartenza: string | null | undefined, payload_CheckList_NomeTecnico: string | null | undefined, payload_CheckList_ControlloEntroIl: string | null | undefined, type: RapportoControlloTypeDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/save/frigo/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (number === null || number === undefined)
            throw new Error("The parameter 'number' cannot be null.");
        else
            content_.append("Number", number.toString());
        if (payload_DatiImpianto_TargaImpianto !== null && payload_DatiImpianto_TargaImpianto !== undefined)
            content_.append("Payload.DatiImpianto.TargaImpianto", payload_DatiImpianto_TargaImpianto.toString());
        if (payload_DatiImpianto_PotenzaNominale !== null && payload_DatiImpianto_PotenzaNominale !== undefined)
            content_.append("Payload.DatiImpianto.PotenzaNominale", payload_DatiImpianto_PotenzaNominale.toString());
        if (payload_DatiImpianto_Comune !== null && payload_DatiImpianto_Comune !== undefined)
            content_.append("Payload.DatiImpianto.Comune", payload_DatiImpianto_Comune.toString());
        if (payload_DatiImpianto_Provincia !== null && payload_DatiImpianto_Provincia !== undefined)
            content_.append("Payload.DatiImpianto.Provincia", payload_DatiImpianto_Provincia.toString());
        if (payload_DatiImpianto_Indirizzo !== null && payload_DatiImpianto_Indirizzo !== undefined)
            content_.append("Payload.DatiImpianto.Indirizzo", payload_DatiImpianto_Indirizzo.toString());
        if (payload_DatiImpianto_Piano !== null && payload_DatiImpianto_Piano !== undefined)
            content_.append("Payload.DatiImpianto.Piano", payload_DatiImpianto_Piano.toString());
        if (payload_DatiImpianto_Pod !== null && payload_DatiImpianto_Pod !== undefined)
            content_.append("Payload.DatiImpianto.Pod", payload_DatiImpianto_Pod.toString());
        if (payload_DatiImpianto_Pdr !== null && payload_DatiImpianto_Pdr !== undefined)
            content_.append("Payload.DatiImpianto.Pdr", payload_DatiImpianto_Pdr.toString());
        if (payload_DatiImpianto_Scala !== null && payload_DatiImpianto_Scala !== undefined)
            content_.append("Payload.DatiImpianto.Scala", payload_DatiImpianto_Scala.toString());
        if (payload_DatiImpianto_Interno !== null && payload_DatiImpianto_Interno !== undefined)
            content_.append("Payload.DatiImpianto.Interno", payload_DatiImpianto_Interno.toString());
        if (payload_DatiImpianto_Sezione !== null && payload_DatiImpianto_Sezione !== undefined)
            content_.append("Payload.DatiImpianto.Sezione", payload_DatiImpianto_Sezione.toString());
        if (payload_DatiImpianto_Foglio !== null && payload_DatiImpianto_Foglio !== undefined)
            content_.append("Payload.DatiImpianto.Foglio", payload_DatiImpianto_Foglio.toString());
        if (payload_DatiImpianto_Particella !== null && payload_DatiImpianto_Particella !== undefined)
            content_.append("Payload.DatiImpianto.Particella", payload_DatiImpianto_Particella.toString());
        if (payload_DatiImpianto_Sub !== null && payload_DatiImpianto_Sub !== undefined)
            content_.append("Payload.DatiImpianto.Sub", payload_DatiImpianto_Sub.toString());
        if (payload_Responsabile_Nominativo !== null && payload_Responsabile_Nominativo !== undefined)
            content_.append("Payload.Responsabile.Nominativo", payload_Responsabile_Nominativo.toString());
        if (payload_Responsabile_PartitaIva !== null && payload_Responsabile_PartitaIva !== undefined)
            content_.append("Payload.Responsabile.PartitaIva", payload_Responsabile_PartitaIva.toString());
        if (payload_Responsabile_CodiceFiscale !== null && payload_Responsabile_CodiceFiscale !== undefined)
            content_.append("Payload.Responsabile.CodiceFiscale", payload_Responsabile_CodiceFiscale.toString());
        if (payload_Responsabile_RagioneSociale !== null && payload_Responsabile_RagioneSociale !== undefined)
            content_.append("Payload.Responsabile.RagioneSociale", payload_Responsabile_RagioneSociale.toString());
        if (payload_Responsabile_Indirizzo !== null && payload_Responsabile_Indirizzo !== undefined)
            content_.append("Payload.Responsabile.Indirizzo", payload_Responsabile_Indirizzo.toString());
        if (payload_Responsabile_Comune !== null && payload_Responsabile_Comune !== undefined)
            content_.append("Payload.Responsabile.Comune", payload_Responsabile_Comune.toString());
        if (payload_Responsabile_Provincia !== null && payload_Responsabile_Provincia !== undefined)
            content_.append("Payload.Responsabile.Provincia", payload_Responsabile_Provincia.toString());
        if (payload_Responsabile_TipoResponsabile !== null && payload_Responsabile_TipoResponsabile !== undefined)
            content_.append("Payload.Responsabile.TipoResponsabile", payload_Responsabile_TipoResponsabile.toString());
        if (payload_ImpresaManutentrice_RagioneSociale !== null && payload_ImpresaManutentrice_RagioneSociale !== undefined)
            content_.append("Payload.ImpresaManutentrice.RagioneSociale", payload_ImpresaManutentrice_RagioneSociale.toString());
        if (payload_ImpresaManutentrice_PartitaIva !== null && payload_ImpresaManutentrice_PartitaIva !== undefined)
            content_.append("Payload.ImpresaManutentrice.PartitaIva", payload_ImpresaManutentrice_PartitaIva.toString());
        if (payload_ImpresaManutentrice_Indirizzo !== null && payload_ImpresaManutentrice_Indirizzo !== undefined)
            content_.append("Payload.ImpresaManutentrice.Indirizzo", payload_ImpresaManutentrice_Indirizzo.toString());
        if (payload_ImpresaManutentrice_Comune !== null && payload_ImpresaManutentrice_Comune !== undefined)
            content_.append("Payload.ImpresaManutentrice.Comune", payload_ImpresaManutentrice_Comune.toString());
        if (payload_ImpresaManutentrice_Provincia !== null && payload_ImpresaManutentrice_Provincia !== undefined)
            content_.append("Payload.ImpresaManutentrice.Provincia", payload_ImpresaManutentrice_Provincia.toString());
        if (payload_DocumentazioneCorredo_ConformitaPresente !== null && payload_DocumentazioneCorredo_ConformitaPresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.ConformitaPresente", payload_DocumentazioneCorredo_ConformitaPresente.toString());
        if (payload_DocumentazioneCorredo_LibrettoPresente !== null && payload_DocumentazioneCorredo_LibrettoPresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.LibrettoPresente", payload_DocumentazioneCorredo_LibrettoPresente.toString());
        if (payload_DocumentazioneCorredo_LibrettoGeneratorePresente !== null && payload_DocumentazioneCorredo_LibrettoGeneratorePresente !== undefined)
            content_.append("Payload.DocumentazioneCorredo.LibrettoGeneratorePresente", payload_DocumentazioneCorredo_LibrettoGeneratorePresente.toString());
        if (payload_DocumentazioneCorredo_CompilatoTutteParti !== null && payload_DocumentazioneCorredo_CompilatoTutteParti !== undefined)
            content_.append("Payload.DocumentazioneCorredo.CompilatoTutteParti", payload_DocumentazioneCorredo_CompilatoTutteParti.toString());
        if (payload_TrattamentoAcqua_DurezzaTotale !== null && payload_TrattamentoAcqua_DurezzaTotale !== undefined)
            content_.append("Payload.TrattamentoAcqua.DurezzaTotale", payload_TrattamentoAcqua_DurezzaTotale.toString());
        if (payload_TrattamentoAcqua_TrattamentoNonRichiesto === null || payload_TrattamentoAcqua_TrattamentoNonRichiesto === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoNonRichiesto' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoNonRichiesto", payload_TrattamentoAcqua_TrattamentoNonRichiesto.toString());
        if (payload_TrattamentoAcqua_TrattamentoAssente === null || payload_TrattamentoAcqua_TrattamentoAssente === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoAssente' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoAssente", payload_TrattamentoAcqua_TrattamentoAssente.toString());
        if (payload_TrattamentoAcqua_TrattamentoFiltrazione === null || payload_TrattamentoAcqua_TrattamentoFiltrazione === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoFiltrazione' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoFiltrazione", payload_TrattamentoAcqua_TrattamentoFiltrazione.toString());
        if (payload_TrattamentoAcqua_TrattamentoAddolcimento === null || payload_TrattamentoAcqua_TrattamentoAddolcimento === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoAddolcimento' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoAddolcimento", payload_TrattamentoAcqua_TrattamentoAddolcimento.toString());
        if (payload_TrattamentoAcqua_TrattamentoChimico === null || payload_TrattamentoAcqua_TrattamentoChimico === undefined)
            throw new Error("The parameter 'payload_TrattamentoAcqua_TrattamentoChimico' cannot be null.");
        else
            content_.append("Payload.TrattamentoAcqua.TrattamentoChimico", payload_TrattamentoAcqua_TrattamentoChimico.toString());
        if (payload_ControlloImpianto_LocaleInstallazioneIdoneo === null || payload_ControlloImpianto_LocaleInstallazioneIdoneo === undefined)
            throw new Error("The parameter 'payload_ControlloImpianto_LocaleInstallazioneIdoneo' cannot be null.");
        else
            content_.append("Payload.ControlloImpianto.LocaleInstallazioneIdoneo", payload_ControlloImpianto_LocaleInstallazioneIdoneo.toString());
        if (payload_ControlloImpianto_AperureAdeguate === null || payload_ControlloImpianto_AperureAdeguate === undefined)
            throw new Error("The parameter 'payload_ControlloImpianto_AperureAdeguate' cannot be null.");
        else
            content_.append("Payload.ControlloImpianto.AperureAdeguate", payload_ControlloImpianto_AperureAdeguate.toString());
        if (payload_ControlloImpianto_VentilazioneLibere === null || payload_ControlloImpianto_VentilazioneLibere === undefined)
            throw new Error("The parameter 'payload_ControlloImpianto_VentilazioneLibere' cannot be null.");
        else
            content_.append("Payload.ControlloImpianto.VentilazioneLibere", payload_ControlloImpianto_VentilazioneLibere.toString());
        if (payload_ControlloImpianto_LineeElettricheIdonee === null || payload_ControlloImpianto_LineeElettricheIdonee === undefined)
            throw new Error("The parameter 'payload_ControlloImpianto_LineeElettricheIdonee' cannot be null.");
        else
            content_.append("Payload.ControlloImpianto.LineeElettricheIdonee", payload_ControlloImpianto_LineeElettricheIdonee.toString());
        if (payload_ControlloImpianto_CoibentazioniIdonee === null || payload_ControlloImpianto_CoibentazioniIdonee === undefined)
            throw new Error("The parameter 'payload_ControlloImpianto_CoibentazioniIdonee' cannot be null.");
        else
            content_.append("Payload.ControlloImpianto.CoibentazioniIdonee", payload_ControlloImpianto_CoibentazioniIdonee.toString());
        if (payload_VerificaEnergetica_CodGruppo !== null && payload_VerificaEnergetica_CodGruppo !== undefined)
            content_.append("Payload.VerificaEnergetica.CodGruppo", payload_VerificaEnergetica_CodGruppo.toString());
        if (payload_VerificaEnergetica_Fabbricante !== null && payload_VerificaEnergetica_Fabbricante !== undefined)
            content_.append("Payload.VerificaEnergetica.Fabbricante", payload_VerificaEnergetica_Fabbricante.toString());
        if (payload_VerificaEnergetica_Modello !== null && payload_VerificaEnergetica_Modello !== undefined)
            content_.append("Payload.VerificaEnergetica.Modello", payload_VerificaEnergetica_Modello.toString());
        if (payload_VerificaEnergetica_Matricola !== null && payload_VerificaEnergetica_Matricola !== undefined)
            content_.append("Payload.VerificaEnergetica.Matricola", payload_VerificaEnergetica_Matricola.toString());
        if (payload_VerificaEnergetica_NrCircuiti === null || payload_VerificaEnergetica_NrCircuiti === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_NrCircuiti' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.NrCircuiti", payload_VerificaEnergetica_NrCircuiti.toString());
        if (payload_VerificaEnergetica_PotenzaNominaleRaffrescamento === null || payload_VerificaEnergetica_PotenzaNominaleRaffrescamento === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_PotenzaNominaleRaffrescamento' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.PotenzaNominaleRaffrescamento", payload_VerificaEnergetica_PotenzaNominaleRaffrescamento.toString());
        if (payload_VerificaEnergetica_PotenzaNominaleRiscaldamento === null || payload_VerificaEnergetica_PotenzaNominaleRiscaldamento === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_PotenzaNominaleRiscaldamento' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.PotenzaNominaleRiscaldamento", payload_VerificaEnergetica_PotenzaNominaleRiscaldamento.toString());
        if (payload_VerificaEnergetica_ProvaRaffrescamento === null || payload_VerificaEnergetica_ProvaRaffrescamento === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_ProvaRaffrescamento' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.ProvaRaffrescamento", payload_VerificaEnergetica_ProvaRaffrescamento.toString());
        if (payload_VerificaEnergetica_RecuperoCalore === null || payload_VerificaEnergetica_RecuperoCalore === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_RecuperoCalore' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.RecuperoCalore", payload_VerificaEnergetica_RecuperoCalore.toString());
        if (payload_VerificaEnergetica_AssorbimentoFiammaDiretta === null || payload_VerificaEnergetica_AssorbimentoFiammaDiretta === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_AssorbimentoFiammaDiretta' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.AssorbimentoFiammaDiretta", payload_VerificaEnergetica_AssorbimentoFiammaDiretta.toString());
        if (payload_VerificaEnergetica_CicloCompressione === null || payload_VerificaEnergetica_CicloCompressione === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_CicloCompressione' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.CicloCompressione", payload_VerificaEnergetica_CicloCompressione.toString());
        if (payload_VerificaEnergetica_AssenzaPerditeGas === null || payload_VerificaEnergetica_AssenzaPerditeGas === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_AssenzaPerditeGas' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.AssenzaPerditeGas", payload_VerificaEnergetica_AssenzaPerditeGas.toString());
        if (payload_VerificaEnergetica_PresenzaLeakDetector === null || payload_VerificaEnergetica_PresenzaLeakDetector === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_PresenzaLeakDetector' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.PresenzaLeakDetector", payload_VerificaEnergetica_PresenzaLeakDetector.toString());
        if (payload_VerificaEnergetica_PresenzaFugheRefrigerante === null || payload_VerificaEnergetica_PresenzaFugheRefrigerante === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_PresenzaFugheRefrigerante' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.PresenzaFugheRefrigerante", payload_VerificaEnergetica_PresenzaFugheRefrigerante.toString());
        if (payload_VerificaEnergetica_ScambiatoriPuliti === null || payload_VerificaEnergetica_ScambiatoriPuliti === undefined)
            throw new Error("The parameter 'payload_VerificaEnergetica_ScambiatoriPuliti' cannot be null.");
        else
            content_.append("Payload.VerificaEnergetica.ScambiatoriPuliti", payload_VerificaEnergetica_ScambiatoriPuliti.toString());
        if (payload_Misurazioni_Surriscald === null || payload_Misurazioni_Surriscald === undefined)
            throw new Error("The parameter 'payload_Misurazioni_Surriscald' cannot be null.");
        else
            content_.append("Payload.Misurazioni.Surriscald", payload_Misurazioni_Surriscald.toString());
        if (payload_Misurazioni_Sottoraffredd === null || payload_Misurazioni_Sottoraffredd === undefined)
            throw new Error("The parameter 'payload_Misurazioni_Sottoraffredd' cannot be null.");
        else
            content_.append("Payload.Misurazioni.Sottoraffredd", payload_Misurazioni_Sottoraffredd.toString());
        if (payload_Misurazioni_TCondens === null || payload_Misurazioni_TCondens === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TCondens' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TCondens", payload_Misurazioni_TCondens.toString());
        if (payload_Misurazioni_TEvapor === null || payload_Misurazioni_TEvapor === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TEvapor' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TEvapor", payload_Misurazioni_TEvapor.toString());
        if (payload_Misurazioni_TIngLatoEst === null || payload_Misurazioni_TIngLatoEst === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TIngLatoEst' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TIngLatoEst", payload_Misurazioni_TIngLatoEst.toString());
        if (payload_Misurazioni_TUscLatoEst === null || payload_Misurazioni_TUscLatoEst === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TUscLatoEst' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TUscLatoEst", payload_Misurazioni_TUscLatoEst.toString());
        if (payload_Misurazioni_TIngLatUtenze === null || payload_Misurazioni_TIngLatUtenze === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TIngLatUtenze' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TIngLatUtenze", payload_Misurazioni_TIngLatUtenze.toString());
        if (payload_Misurazioni_TUscLatUtenze === null || payload_Misurazioni_TUscLatUtenze === undefined)
            throw new Error("The parameter 'payload_Misurazioni_TUscLatUtenze' cannot be null.");
        else
            content_.append("Payload.Misurazioni.TUscLatUtenze", payload_Misurazioni_TUscLatUtenze.toString());
        if (payload_Misurazioni_NCircuito === null || payload_Misurazioni_NCircuito === undefined)
            throw new Error("The parameter 'payload_Misurazioni_NCircuito' cannot be null.");
        else
            content_.append("Payload.Misurazioni.NCircuito", payload_Misurazioni_NCircuito.toString());
        if (payload_CheckList_SostituzioneGeneratoriF1 === null || payload_CheckList_SostituzioneGeneratoriF1 === undefined)
            throw new Error("The parameter 'payload_CheckList_SostituzioneGeneratoriF1' cannot be null.");
        else
            content_.append("Payload.CheckList.SostituzioneGeneratoriF1", payload_CheckList_SostituzioneGeneratoriF1.toString());
        if (payload_CheckList_SostituzioneSistemiF2 === null || payload_CheckList_SostituzioneSistemiF2 === undefined)
            throw new Error("The parameter 'payload_CheckList_SostituzioneSistemiF2' cannot be null.");
        else
            content_.append("Payload.CheckList.SostituzioneSistemiF2", payload_CheckList_SostituzioneSistemiF2.toString());
        if (payload_CheckList_IsolamentoReteF3 === null || payload_CheckList_IsolamentoReteF3 === undefined)
            throw new Error("The parameter 'payload_CheckList_IsolamentoReteF3' cannot be null.");
        else
            content_.append("Payload.CheckList.IsolamentoReteF3", payload_CheckList_IsolamentoReteF3.toString());
        if (payload_CheckList_IsolamentoCanaliF4 === null || payload_CheckList_IsolamentoCanaliF4 === undefined)
            throw new Error("The parameter 'payload_CheckList_IsolamentoCanaliF4' cannot be null.");
        else
            content_.append("Payload.CheckList.IsolamentoCanaliF4", payload_CheckList_IsolamentoCanaliF4.toString());
        if (payload_CheckList_Osservazioni !== null && payload_CheckList_Osservazioni !== undefined)
            content_.append("Payload.CheckList.Osservazioni", payload_CheckList_Osservazioni.toString());
        if (payload_CheckList_Osservazioni2 !== null && payload_CheckList_Osservazioni2 !== undefined)
            content_.append("Payload.CheckList.Osservazioni2", payload_CheckList_Osservazioni2.toString());
        if (payload_CheckList_Raccomandazioni !== null && payload_CheckList_Raccomandazioni !== undefined)
            content_.append("Payload.CheckList.Raccomandazioni", payload_CheckList_Raccomandazioni.toString());
        if (payload_CheckList_Raccomandazioni2 !== null && payload_CheckList_Raccomandazioni2 !== undefined)
            content_.append("Payload.CheckList.Raccomandazioni2", payload_CheckList_Raccomandazioni2.toString());
        if (payload_CheckList_Prescrizioni !== null && payload_CheckList_Prescrizioni !== undefined)
            content_.append("Payload.CheckList.Prescrizioni", payload_CheckList_Prescrizioni.toString());
        if (payload_CheckList_Prescrizioni2 !== null && payload_CheckList_Prescrizioni2 !== undefined)
            content_.append("Payload.CheckList.Prescrizioni2", payload_CheckList_Prescrizioni2.toString());
        if (payload_CheckList_ImpiantoPuoFunzionare !== null && payload_CheckList_ImpiantoPuoFunzionare !== undefined)
            content_.append("Payload.CheckList.ImpiantoPuoFunzionare", payload_CheckList_ImpiantoPuoFunzionare.toString());
        if (payload_CheckList_DataControllo !== null && payload_CheckList_DataControllo !== undefined)
            content_.append("Payload.CheckList.DataControllo", payload_CheckList_DataControllo.toString());
        if (payload_CheckList_OrarioArrivo !== null && payload_CheckList_OrarioArrivo !== undefined)
            content_.append("Payload.CheckList.OrarioArrivo", payload_CheckList_OrarioArrivo.toString());
        if (payload_CheckList_OrarioPartenza !== null && payload_CheckList_OrarioPartenza !== undefined)
            content_.append("Payload.CheckList.OrarioPartenza", payload_CheckList_OrarioPartenza.toString());
        if (payload_CheckList_NomeTecnico !== null && payload_CheckList_NomeTecnico !== undefined)
            content_.append("Payload.CheckList.NomeTecnico", payload_CheckList_NomeTecnico.toString());
        if (payload_CheckList_ControlloEntroIl !== null && payload_CheckList_ControlloEntroIl !== undefined)
            content_.append("Payload.CheckList.ControlloEntroIl", payload_CheckList_ControlloEntroIl.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveFrigo(_response);
        });
    }

    protected processSaveFrigo(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IAttachmentsClient {

    get(folderName: string | null | undefined, subfolderName: string | null | undefined): Promise<AttachmentDto[] | null>;

    download(fileKey: string | null | undefined): Promise<FileResponse | null>;

    preview(fileKey: string | null | undefined): Promise<string | null>;

    uploadDocument(file: FileParameter | null | undefined, folderName: string | null | undefined, subfolderName: string | null | undefined): Promise<AttachmentDto | null>;

    deleteDocument(fileKey: string | null | undefined): Promise<AttachmentDto | null>;
}

export class AttachmentsClient extends BaseClient implements IAttachmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(folderName: string | null | undefined, subfolderName: string | null | undefined): Promise<AttachmentDto[] | null> {
        let url_ = this.baseUrl + "/attachments?";
        if (folderName !== undefined && folderName !== null)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (subfolderName !== undefined && subfolderName !== null)
            url_ += "subfolderName=" + encodeURIComponent("" + subfolderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AttachmentDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto[] | null>(null as any);
    }

    download(fileKey: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/attachments/download?";
        if (fileKey !== undefined && fileKey !== null)
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    preview(fileKey: string | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/attachments/preview?";
        if (fileKey !== undefined && fileKey !== null)
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    uploadDocument(file: FileParameter | null | undefined, folderName: string | null | undefined, subfolderName: string | null | undefined): Promise<AttachmentDto | null> {
        let url_ = this.baseUrl + "/attachments/upload?";
        if (folderName !== undefined && folderName !== null)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (subfolderName !== undefined && subfolderName !== null)
            url_ += "subfolderName=" + encodeURIComponent("" + subfolderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<AttachmentDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AttachmentDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto | null>(null as any);
    }

    deleteDocument(fileKey: string | null | undefined): Promise<AttachmentDto | null> {
        let url_ = this.baseUrl + "/attachments/delete?";
        if (fileKey !== undefined && fileKey !== null)
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<AttachmentDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AttachmentDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDto | null>(null as any);
    }
}

export interface IBolliniVerdiClient {

    getByImpianto(idImpianto: number | undefined): Promise<BollinoDto[] | null>;

    add(data: BollinoDataDto): Promise<number>;

    delete(idBollino: number | undefined): Promise<boolean>;

    update(data: BollinoDataDto, idBollino: number): Promise<boolean>;
}

export class BolliniVerdiClient extends BaseClient implements IBolliniVerdiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getByImpianto(idImpianto: number | undefined): Promise<BollinoDto[] | null> {
        let url_ = this.baseUrl + "/bolliniVerdi?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByImpianto(_response);
        });
    }

    protected processGetByImpianto(response: Response): Promise<BollinoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BollinoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BollinoDto[] | null>(null as any);
    }

    add(data: BollinoDataDto): Promise<number> {
        let url_ = this.baseUrl + "/bolliniVerdi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(idBollino: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/bolliniVerdi?";
        if (idBollino === null)
            throw new Error("The parameter 'idBollino' cannot be null.");
        else if (idBollino !== undefined)
            url_ += "idBollino=" + encodeURIComponent("" + idBollino) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(data: BollinoDataDto, idBollino: number): Promise<boolean> {
        let url_ = this.baseUrl + "/bolliniVerdi/{idBollino}";
        if (idBollino === undefined || idBollino === null)
            throw new Error("The parameter 'idBollino' must be defined.");
        url_ = url_.replace("{idBollino}", encodeURIComponent("" + idBollino));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IBruciatoriClient {

    getAll(): Promise<BruciatoreDto[] | null>;

    add(data: BruciatoreDataDto): Promise<number>;

    delete(idBruciatore: number | undefined): Promise<boolean>;

    get(idBruciatore: number): Promise<BruciatoreDto | null>;

    update(data: BruciatoreDataDto, id: number): Promise<boolean>;

    getMarcheBruciatoriList(filtroMarca: string | null | undefined): Promise<string[] | null>;

    getModelliBruciatoriList(marcaBruciatore: string | null | undefined): Promise<string[] | null>;
}

export class BruciatoriClient extends BaseClient implements IBruciatoriClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<BruciatoreDto[] | null> {
        let url_ = this.baseUrl + "/bruciatori";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BruciatoreDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BruciatoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BruciatoreDto[] | null>(null as any);
    }

    add(data: BruciatoreDataDto): Promise<number> {
        let url_ = this.baseUrl + "/bruciatori";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(idBruciatore: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/bruciatori?";
        if (idBruciatore === null)
            throw new Error("The parameter 'idBruciatore' cannot be null.");
        else if (idBruciatore !== undefined)
            url_ += "idBruciatore=" + encodeURIComponent("" + idBruciatore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(idBruciatore: number): Promise<BruciatoreDto | null> {
        let url_ = this.baseUrl + "/bruciatori/{idBruciatore}";
        if (idBruciatore === undefined || idBruciatore === null)
            throw new Error("The parameter 'idBruciatore' must be defined.");
        url_ = url_.replace("{idBruciatore}", encodeURIComponent("" + idBruciatore));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BruciatoreDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BruciatoreDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BruciatoreDto | null>(null as any);
    }

    update(data: BruciatoreDataDto, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/bruciatori/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getMarcheBruciatoriList(filtroMarca: string | null | undefined): Promise<string[] | null> {
        let url_ = this.baseUrl + "/bruciatori/marche?";
        if (filtroMarca !== undefined && filtroMarca !== null)
            url_ += "filtroMarca=" + encodeURIComponent("" + filtroMarca) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarcheBruciatoriList(_response);
        });
    }

    protected processGetMarcheBruciatoriList(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getModelliBruciatoriList(marcaBruciatore: string | null | undefined): Promise<string[] | null> {
        let url_ = this.baseUrl + "/bruciatori/modelli?";
        if (marcaBruciatore !== undefined && marcaBruciatore !== null)
            url_ += "marcaBruciatore=" + encodeURIComponent("" + marcaBruciatore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelliBruciatoriList(_response);
        });
    }

    protected processGetModelliBruciatoriList(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }
}

export interface ICaldaieClient {

    getAll(): Promise<CaldaiaDto[] | null>;

    add(data: CaldaiaDataDto): Promise<number>;

    deleteCaldaia(idCaldaia: number | undefined): Promise<boolean>;

    get(idCaldaia: number): Promise<CaldaiaDto | null>;

    update(data: CaldaiaDataDto, id: number): Promise<boolean>;

    getCaldaieByMarca(filtroMarca: string | null | undefined, likeSearch: boolean | undefined): Promise<CaldaiaDto[] | null>;

    getAllMarcheCaldaieList(): Promise<string[] | null>;

    getMarcheCaldaieList(): Promise<string[] | null>;

    getModelliCaldaiaList(marcaCaldaia: string | null | undefined): Promise<string[] | null>;

    getTipiCaldaia(): Promise<string[] | null>;

    getTipiTiraggio(): Promise<string[] | null>;

    getTipiCombustibile(): Promise<string[] | null>;

    getTipiLocaleInstallazione(): Promise<string[] | null>;

    getTipiUsoCaldaia(): Promise<string[] | null>;

    getListaNuoveCaldaiePrecaricate(filtroMarca: string | null | undefined): Promise<CaldaiaDto[] | null>;

    inserisciCaldaiePrecaricate(caldaieToInsert: CaldaiaDto[]): Promise<CaldaiaDto[] | null>;
}

export class CaldaieClient extends BaseClient implements ICaldaieClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CaldaiaDto[] | null> {
        let url_ = this.baseUrl + "/caldaie";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<CaldaiaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaldaiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaldaiaDto[] | null>(null as any);
    }

    add(data: CaldaiaDataDto): Promise<number> {
        let url_ = this.baseUrl + "/caldaie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCaldaia(idCaldaia: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/caldaie?";
        if (idCaldaia === null)
            throw new Error("The parameter 'idCaldaia' cannot be null.");
        else if (idCaldaia !== undefined)
            url_ += "idCaldaia=" + encodeURIComponent("" + idCaldaia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCaldaia(_response);
        });
    }

    protected processDeleteCaldaia(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(idCaldaia: number): Promise<CaldaiaDto | null> {
        let url_ = this.baseUrl + "/caldaie/{idCaldaia}";
        if (idCaldaia === undefined || idCaldaia === null)
            throw new Error("The parameter 'idCaldaia' must be defined.");
        url_ = url_.replace("{idCaldaia}", encodeURIComponent("" + idCaldaia));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CaldaiaDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CaldaiaDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaldaiaDto | null>(null as any);
    }

    update(data: CaldaiaDataDto, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/caldaie/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCaldaieByMarca(filtroMarca: string | null | undefined, likeSearch: boolean | undefined): Promise<CaldaiaDto[] | null> {
        let url_ = this.baseUrl + "/caldaie/byMarca?";
        if (filtroMarca !== undefined && filtroMarca !== null)
            url_ += "filtroMarca=" + encodeURIComponent("" + filtroMarca) + "&";
        if (likeSearch === null)
            throw new Error("The parameter 'likeSearch' cannot be null.");
        else if (likeSearch !== undefined)
            url_ += "likeSearch=" + encodeURIComponent("" + likeSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaldaieByMarca(_response);
        });
    }

    protected processGetCaldaieByMarca(response: Response): Promise<CaldaiaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaldaiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaldaiaDto[] | null>(null as any);
    }

    getAllMarcheCaldaieList(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/marche-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMarcheCaldaieList(_response);
        });
    }

    protected processGetAllMarcheCaldaieList(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getMarcheCaldaieList(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/marche";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarcheCaldaieList(_response);
        });
    }

    protected processGetMarcheCaldaieList(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getModelliCaldaiaList(marcaCaldaia: string | null | undefined): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/modelli?";
        if (marcaCaldaia !== undefined && marcaCaldaia !== null)
            url_ += "marcaCaldaia=" + encodeURIComponent("" + marcaCaldaia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelliCaldaiaList(_response);
        });
    }

    protected processGetModelliCaldaiaList(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getTipiCaldaia(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/tipi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiCaldaia(_response);
        });
    }

    protected processGetTipiCaldaia(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getTipiTiraggio(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/tiptiraggio";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiTiraggio(_response);
        });
    }

    protected processGetTipiTiraggio(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getTipiCombustibile(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/tipicombustibile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiCombustibile(_response);
        });
    }

    protected processGetTipiCombustibile(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getTipiLocaleInstallazione(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/tipilocaleinstallazione";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiLocaleInstallazione(_response);
        });
    }

    protected processGetTipiLocaleInstallazione(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getTipiUsoCaldaia(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/caldaie/tipiUso";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiUsoCaldaia(_response);
        });
    }

    protected processGetTipiUsoCaldaia(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getListaNuoveCaldaiePrecaricate(filtroMarca: string | null | undefined): Promise<CaldaiaDto[] | null> {
        let url_ = this.baseUrl + "/caldaie/precaricate?";
        if (filtroMarca !== undefined && filtroMarca !== null)
            url_ += "filtroMarca=" + encodeURIComponent("" + filtroMarca) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListaNuoveCaldaiePrecaricate(_response);
        });
    }

    protected processGetListaNuoveCaldaiePrecaricate(response: Response): Promise<CaldaiaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaldaiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaldaiaDto[] | null>(null as any);
    }

    inserisciCaldaiePrecaricate(caldaieToInsert: CaldaiaDto[]): Promise<CaldaiaDto[] | null> {
        let url_ = this.baseUrl + "/caldaie/precaricate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caldaieToInsert);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInserisciCaldaiePrecaricate(_response);
        });
    }

    protected processInserisciCaldaiePrecaricate(response: Response): Promise<CaldaiaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaldaiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaldaiaDto[] | null>(null as any);
    }
}

export interface ICalendarClient {

    get(apiKey: string): Promise<FileResponse | null>;
}

export class CalendarClient extends BaseClient implements ICalendarClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(apiKey: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/calendars/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ICatastiClient {

    getEsaExport(idInterventi: string | null | undefined): Promise<FileResponse | null>;

    getSiertExport(idInterventi: string | null | undefined, idAziendaSiert: number | undefined): Promise<FileResponse | null>;
}

export class CatastiClient extends BaseClient implements ICatastiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEsaExport(idInterventi: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/catasti/esa?";
        if (idInterventi !== undefined && idInterventi !== null)
            url_ += "idInterventi=" + encodeURIComponent("" + idInterventi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEsaExport(_response);
        });
    }

    protected processGetEsaExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSiertExport(idInterventi: string | null | undefined, idAziendaSiert: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/catasti/siert?";
        if (idInterventi !== undefined && idInterventi !== null)
            url_ += "idInterventi=" + encodeURIComponent("" + idInterventi) + "&";
        if (idAziendaSiert === null)
            throw new Error("The parameter 'idAziendaSiert' cannot be null.");
        else if (idAziendaSiert !== undefined)
            url_ += "idAziendaSiert=" + encodeURIComponent("" + idAziendaSiert) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSiertExport(_response);
        });
    }

    protected processGetSiertExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IClientiClient {

    getClientiList(codClienteAzienda: number | null | undefined, filtroNominativo: string | null | undefined, filtroContatto: string | null | undefined, filtroLocalita: string | null | undefined, filtroCaldaia: string | null | undefined, filtroCombustibile: string | null | undefined, codPdrCatasto: string | null | undefined, viewAnagDismesse: boolean | undefined): Promise<ClienteDto[] | null>;

    addCliente(newCliente: ClienteData): Promise<number>;

    deleteCliente(idCliente: number): Promise<boolean>;

    getCliente(idCliente: number): Promise<ClienteDto | null>;

    updateCliente(clienteUpdate: ClienteData, id: number): Promise<boolean>;

    getAvailableCodiceClienteAzienda(): Promise<number>;

    codiceClienteAziendaExist(codice: number, currentIdCliente: number | null | undefined): Promise<boolean>;
}

export class ClientiClient extends BaseClient implements IClientiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getClientiList(codClienteAzienda: number | null | undefined, filtroNominativo: string | null | undefined, filtroContatto: string | null | undefined, filtroLocalita: string | null | undefined, filtroCaldaia: string | null | undefined, filtroCombustibile: string | null | undefined, codPdrCatasto: string | null | undefined, viewAnagDismesse: boolean | undefined): Promise<ClienteDto[] | null> {
        let url_ = this.baseUrl + "/clienti?";
        if (codClienteAzienda !== undefined && codClienteAzienda !== null)
            url_ += "codClienteAzienda=" + encodeURIComponent("" + codClienteAzienda) + "&";
        if (filtroNominativo !== undefined && filtroNominativo !== null)
            url_ += "filtroNominativo=" + encodeURIComponent("" + filtroNominativo) + "&";
        if (filtroContatto !== undefined && filtroContatto !== null)
            url_ += "filtroContatto=" + encodeURIComponent("" + filtroContatto) + "&";
        if (filtroLocalita !== undefined && filtroLocalita !== null)
            url_ += "filtroLocalita=" + encodeURIComponent("" + filtroLocalita) + "&";
        if (filtroCaldaia !== undefined && filtroCaldaia !== null)
            url_ += "filtroCaldaia=" + encodeURIComponent("" + filtroCaldaia) + "&";
        if (filtroCombustibile !== undefined && filtroCombustibile !== null)
            url_ += "filtroCombustibile=" + encodeURIComponent("" + filtroCombustibile) + "&";
        if (codPdrCatasto !== undefined && codPdrCatasto !== null)
            url_ += "codPdrCatasto=" + encodeURIComponent("" + codPdrCatasto) + "&";
        if (viewAnagDismesse === null)
            throw new Error("The parameter 'viewAnagDismesse' cannot be null.");
        else if (viewAnagDismesse !== undefined)
            url_ += "viewAnagDismesse=" + encodeURIComponent("" + viewAnagDismesse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientiList(_response);
        });
    }

    protected processGetClientiList(response: Response): Promise<ClienteDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClienteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClienteDto[] | null>(null as any);
    }

    addCliente(newCliente: ClienteData): Promise<number> {
        let url_ = this.baseUrl + "/clienti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCliente);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCliente(_response);
        });
    }

    protected processAddCliente(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCliente(idCliente: number): Promise<boolean> {
        let url_ = this.baseUrl + "/clienti?";
        if (idCliente === undefined || idCliente === null)
            throw new Error("The parameter 'idCliente' must be defined and cannot be null.");
        else
            url_ += "idCliente=" + encodeURIComponent("" + idCliente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCliente(_response);
        });
    }

    protected processDeleteCliente(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCliente(idCliente: number): Promise<ClienteDto | null> {
        let url_ = this.baseUrl + "/clienti/{idCliente}";
        if (idCliente === undefined || idCliente === null)
            throw new Error("The parameter 'idCliente' must be defined.");
        url_ = url_.replace("{idCliente}", encodeURIComponent("" + idCliente));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCliente(_response);
        });
    }

    protected processGetCliente(response: Response): Promise<ClienteDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClienteDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClienteDto | null>(null as any);
    }

    updateCliente(clienteUpdate: ClienteData, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/clienti/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clienteUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCliente(_response);
        });
    }

    protected processUpdateCliente(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableCodiceClienteAzienda(): Promise<number> {
        let url_ = this.baseUrl + "/clienti/availablecodiceclienteAzienda";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCodiceClienteAzienda(_response);
        });
    }

    protected processGetAvailableCodiceClienteAzienda(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    codiceClienteAziendaExist(codice: number, currentIdCliente: number | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/clienti/exists?";
        if (codice === undefined || codice === null)
            throw new Error("The parameter 'codice' must be defined and cannot be null.");
        else
            url_ += "codice=" + encodeURIComponent("" + codice) + "&";
        if (currentIdCliente !== undefined && currentIdCliente !== null)
            url_ += "currentIdCliente=" + encodeURIComponent("" + currentIdCliente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCodiceClienteAziendaExist(_response);
        });
    }

    protected processCodiceClienteAziendaExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IContrattiClient {

    getContrattiImpianto(idImpianto: number | undefined): Promise<Contratto[] | null>;

    addContratto(contrattoDto: ContrattoData): Promise<void>;

    updateContratto(contrattoDto: Contratto): Promise<void>;

    deleteContratto(id: string | undefined): Promise<void>;
}

export class ContrattiClient extends BaseClient implements IContrattiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getContrattiImpianto(idImpianto: number | undefined): Promise<Contratto[] | null> {
        let url_ = this.baseUrl + "/contratti?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContrattiImpianto(_response);
        });
    }

    protected processGetContrattiImpianto(response: Response): Promise<Contratto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Contratto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contratto[] | null>(null as any);
    }

    addContratto(contrattoDto: ContrattoData): Promise<void> {
        let url_ = this.baseUrl + "/contratti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contrattoDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddContratto(_response);
        });
    }

    protected processAddContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateContratto(contrattoDto: Contratto): Promise<void> {
        let url_ = this.baseUrl + "/contratti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contrattoDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateContratto(_response);
        });
    }

    protected processUpdateContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContratto(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/contratti?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteContratto(_response);
        });
    }

    protected processDeleteContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEsercentiClient {

    get(): Promise<CompanyDto | null>;

    add(request: RegisterCompanyRequest): Promise<boolean>;

    update(data: CompanyDataDto, companyId: number | undefined): Promise<boolean>;

    esercenteExist(partitaIva: string | null | undefined): Promise<boolean>;
}

export class EsercentiClient extends BaseClient implements IEsercentiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<CompanyDto | null> {
        let url_ = this.baseUrl + "/esercenti";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CompanyDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDto | null>(null as any);
    }

    add(request: RegisterCompanyRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/esercenti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(data: CompanyDataDto, companyId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/esercenti/companyId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    esercenteExist(partitaIva: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/esercenti/exists?";
        if (partitaIva !== undefined && partitaIva !== null)
            url_ += "partitaIva=" + encodeURIComponent("" + partitaIva) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEsercenteExist(_response);
        });
    }

    protected processEsercenteExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IExpirationsSettingsClient {

    getCurrent(): Promise<ExpirationSettingsDto | null>;

    save(data: ExpirationSettingsDto): Promise<void>;
}

export class ExpirationsSettingsClient extends BaseClient implements IExpirationsSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCurrent(): Promise<ExpirationSettingsDto | null> {
        let url_ = this.baseUrl + "/expirationsSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrent(_response);
        });
    }

    protected processGetCurrent(response: Response): Promise<ExpirationSettingsDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExpirationSettingsDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpirationSettingsDto | null>(null as any);
    }

    save(data: ExpirationSettingsDto): Promise<void> {
        let url_ = this.baseUrl + "/expirationsSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IGeographicClient {

    getComune(codFisComune: string | null | undefined): Promise<Comune | null>;

    getFrazione(codFisComune: string | null | undefined, codFrazione: string | null | undefined): Promise<Frazione | null>;

    getProvince(): Promise<string[] | null>;

    getFrazioniByComune(codfisComune: string | null | undefined): Promise<Frazione[] | null>;

    getComuniByNome(nomeComune: string | null | undefined): Promise<Comune[] | null>;

    getFrazioniByNome(nomeFrazione: string | null | undefined): Promise<Frazione[] | null>;

    getStaticMapsUrl(indirizzo: string | null | undefined, zoom: number | undefined, mapMode: string | null | undefined, mapWidth: number | undefined, mapHeight: number | undefined): Promise<string | null>;

    getCoordinate(indirizzo: string | null | undefined): Promise<string[] | null>;
}

export class GeographicClient extends BaseClient implements IGeographicClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getComune(codFisComune: string | null | undefined): Promise<Comune | null> {
        let url_ = this.baseUrl + "/geographic/comuni?";
        if (codFisComune !== undefined && codFisComune !== null)
            url_ += "codFisComune=" + encodeURIComponent("" + codFisComune) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComune(_response);
        });
    }

    protected processGetComune(response: Response): Promise<Comune | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Comune.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Comune | null>(null as any);
    }

    getFrazione(codFisComune: string | null | undefined, codFrazione: string | null | undefined): Promise<Frazione | null> {
        let url_ = this.baseUrl + "/geographic/frazioni?";
        if (codFisComune !== undefined && codFisComune !== null)
            url_ += "codFisComune=" + encodeURIComponent("" + codFisComune) + "&";
        if (codFrazione !== undefined && codFrazione !== null)
            url_ += "codFrazione=" + encodeURIComponent("" + codFrazione) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFrazione(_response);
        });
    }

    protected processGetFrazione(response: Response): Promise<Frazione | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Frazione.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Frazione | null>(null as any);
    }

    getProvince(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/geographic/province";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProvince(_response);
        });
    }

    protected processGetProvince(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }

    getFrazioniByComune(codfisComune: string | null | undefined): Promise<Frazione[] | null> {
        let url_ = this.baseUrl + "/geographic/frazioni/byComune?";
        if (codfisComune !== undefined && codfisComune !== null)
            url_ += "codfisComune=" + encodeURIComponent("" + codfisComune) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFrazioniByComune(_response);
        });
    }

    protected processGetFrazioniByComune(response: Response): Promise<Frazione[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Frazione.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Frazione[] | null>(null as any);
    }

    getComuniByNome(nomeComune: string | null | undefined): Promise<Comune[] | null> {
        let url_ = this.baseUrl + "/geographic/comuni/byNome?";
        if (nomeComune !== undefined && nomeComune !== null)
            url_ += "nomeComune=" + encodeURIComponent("" + nomeComune) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComuniByNome(_response);
        });
    }

    protected processGetComuniByNome(response: Response): Promise<Comune[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Comune.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Comune[] | null>(null as any);
    }

    getFrazioniByNome(nomeFrazione: string | null | undefined): Promise<Frazione[] | null> {
        let url_ = this.baseUrl + "/geographic/frazioni/byNome?";
        if (nomeFrazione !== undefined && nomeFrazione !== null)
            url_ += "nomeFrazione=" + encodeURIComponent("" + nomeFrazione) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFrazioniByNome(_response);
        });
    }

    protected processGetFrazioniByNome(response: Response): Promise<Frazione[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Frazione.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Frazione[] | null>(null as any);
    }

    getStaticMapsUrl(indirizzo: string | null | undefined, zoom: number | undefined, mapMode: string | null | undefined, mapWidth: number | undefined, mapHeight: number | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/geographic/map?";
        if (indirizzo !== undefined && indirizzo !== null)
            url_ += "indirizzo=" + encodeURIComponent("" + indirizzo) + "&";
        if (zoom === null)
            throw new Error("The parameter 'zoom' cannot be null.");
        else if (zoom !== undefined)
            url_ += "zoom=" + encodeURIComponent("" + zoom) + "&";
        if (mapMode !== undefined && mapMode !== null)
            url_ += "mapMode=" + encodeURIComponent("" + mapMode) + "&";
        if (mapWidth === null)
            throw new Error("The parameter 'mapWidth' cannot be null.");
        else if (mapWidth !== undefined)
            url_ += "mapWidth=" + encodeURIComponent("" + mapWidth) + "&";
        if (mapHeight === null)
            throw new Error("The parameter 'mapHeight' cannot be null.");
        else if (mapHeight !== undefined)
            url_ += "mapHeight=" + encodeURIComponent("" + mapHeight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStaticMapsUrl(_response);
        });
    }

    protected processGetStaticMapsUrl(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getCoordinate(indirizzo: string | null | undefined): Promise<string[] | null> {
        let url_ = this.baseUrl + "/geographic?";
        if (indirizzo !== undefined && indirizzo !== null)
            url_ += "indirizzo=" + encodeURIComponent("" + indirizzo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCoordinate(_response);
        });
    }

    protected processGetCoordinate(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }
}

export interface IImpiantiClienteClient {

    get(idCliente: number | undefined): Promise<ImpiantoLight[] | null>;

    setGroup(data: SetImpiantoKeyDto): Promise<void>;
}

export class ImpiantiClienteClient extends BaseClient implements IImpiantiClienteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(idCliente: number | undefined): Promise<ImpiantoLight[] | null> {
        let url_ = this.baseUrl + "/impianticliente?";
        if (idCliente === null)
            throw new Error("The parameter 'idCliente' cannot be null.");
        else if (idCliente !== undefined)
            url_ += "idCliente=" + encodeURIComponent("" + idCliente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ImpiantoLight[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantoLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantoLight[] | null>(null as any);
    }

    setGroup(data: SetImpiantoKeyDto): Promise<void> {
        let url_ = this.baseUrl + "/impianticliente/groupkey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetGroup(_response);
        });
    }

    protected processSetGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IImpiantiClimaClient {

    get(id: number): Promise<ImpiantoClimaDto | null>;

    update(impUpdate: ImpiantoClimaData, id: number): Promise<boolean>;

    add(imp: ImpiantoClimaData): Promise<number>;

    delete(idImpianto: number | undefined): Promise<boolean>;
}

export class ImpiantiClimaClient extends BaseClient implements IImpiantiClimaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: number): Promise<ImpiantoClimaDto | null> {
        let url_ = this.baseUrl + "/impianticlima/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ImpiantoClimaDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpiantoClimaDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantoClimaDto | null>(null as any);
    }

    update(impUpdate: ImpiantoClimaData, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/impianticlima/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(impUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    add(imp: ImpiantoClimaData): Promise<number> {
        let url_ = this.baseUrl + "/impianticlima";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imp);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(idImpianto: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/impianticlima?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IImpiantiTermiciClient {

    getApparecchiCateogories(): Promise<ApparecchioCategory[] | null>;

    getById(idImpianto: number | undefined): Promise<ImpiantoDto | null>;

    addImpianto(imp: ImpiantoData): Promise<number>;

    deleteImpianto(idImpianto: number | undefined): Promise<boolean>;

    getByIdImpianti(idImpianti: number[]): Promise<ImpiantoDto[] | null>;

    updateImpianto(impUpdate: ImpiantoData, id: number): Promise<boolean>;
}

export class ImpiantiTermiciClient extends BaseClient implements IImpiantiTermiciClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApparecchiCateogories(): Promise<ApparecchioCategory[] | null> {
        let url_ = this.baseUrl + "/impianti/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApparecchiCateogories(_response);
        });
    }

    protected processGetApparecchiCateogories(response: Response): Promise<ApparecchioCategory[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApparecchioCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApparecchioCategory[] | null>(null as any);
    }

    getById(idImpianto: number | undefined): Promise<ImpiantoDto | null> {
        let url_ = this.baseUrl + "/impianti?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ImpiantoDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpiantoDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantoDto | null>(null as any);
    }

    addImpianto(imp: ImpiantoData): Promise<number> {
        let url_ = this.baseUrl + "/impianti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imp);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddImpianto(_response);
        });
    }

    protected processAddImpianto(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteImpianto(idImpianto: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/impianti?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteImpianto(_response);
        });
    }

    protected processDeleteImpianto(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getByIdImpianti(idImpianti: number[]): Promise<ImpiantoDto[] | null> {
        let url_ = this.baseUrl + "/impianti/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idImpianti);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByIdImpianti(_response);
        });
    }

    protected processGetByIdImpianti(response: Response): Promise<ImpiantoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantoDto[] | null>(null as any);
    }

    updateImpianto(impUpdate: ImpiantoData, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/impianti/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(impUpdate);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateImpianto(_response);
        });
    }

    protected processUpdateImpianto(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IInterventiClient {

    getInterventiByCliente(idCliente: number | undefined): Promise<InterventoDto[] | null>;

    addIntervento(newIntervento: InterventoData): Promise<number>;

    deleteIntervento(idIntervento: number | undefined): Promise<boolean>;

    getInterventiByImpianto(idImpianto: number | undefined): Promise<InterventoDto[] | null>;

    updateIntervento(updateIntervento: InterventoData, id: number): Promise<boolean>;

    getByTechnician(idTechnician: number | undefined, from: Date | undefined, to: Date | undefined): Promise<InterventoDto[] | null>;

    saveSignature(data: RapportinoSignatureData): Promise<string | null>;

    getTipiIntervento(): Promise<TipoIntervento[] | null>;

    getReportInterventi(dataDa: Date | undefined, dataA: Date | undefined): Promise<InterventoDto[] | null>;
}

export class InterventiClient extends BaseClient implements IInterventiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getInterventiByCliente(idCliente: number | undefined): Promise<InterventoDto[] | null> {
        let url_ = this.baseUrl + "/interventi?";
        if (idCliente === null)
            throw new Error("The parameter 'idCliente' cannot be null.");
        else if (idCliente !== undefined)
            url_ += "idCliente=" + encodeURIComponent("" + idCliente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInterventiByCliente(_response);
        });
    }

    protected processGetInterventiByCliente(response: Response): Promise<InterventoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventoDto[] | null>(null as any);
    }

    addIntervento(newIntervento: InterventoData): Promise<number> {
        let url_ = this.baseUrl + "/interventi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newIntervento);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddIntervento(_response);
        });
    }

    protected processAddIntervento(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteIntervento(idIntervento: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/interventi?";
        if (idIntervento === null)
            throw new Error("The parameter 'idIntervento' cannot be null.");
        else if (idIntervento !== undefined)
            url_ += "idIntervento=" + encodeURIComponent("" + idIntervento) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteIntervento(_response);
        });
    }

    protected processDeleteIntervento(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getInterventiByImpianto(idImpianto: number | undefined): Promise<InterventoDto[] | null> {
        let url_ = this.baseUrl + "/interventi/byImpianto?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInterventiByImpianto(_response);
        });
    }

    protected processGetInterventiByImpianto(response: Response): Promise<InterventoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventoDto[] | null>(null as any);
    }

    updateIntervento(updateIntervento: InterventoData, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/interventi/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateIntervento);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIntervento(_response);
        });
    }

    protected processUpdateIntervento(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getByTechnician(idTechnician: number | undefined, from: Date | undefined, to: Date | undefined): Promise<InterventoDto[] | null> {
        let url_ = this.baseUrl + "/interventi/byTechnician?";
        if (idTechnician === null)
            throw new Error("The parameter 'idTechnician' cannot be null.");
        else if (idTechnician !== undefined)
            url_ += "idTechnician=" + encodeURIComponent("" + idTechnician) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByTechnician(_response);
        });
    }

    protected processGetByTechnician(response: Response): Promise<InterventoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventoDto[] | null>(null as any);
    }

    saveSignature(data: RapportinoSignatureData): Promise<string | null> {
        let url_ = this.baseUrl + "/interventi/signature/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSignature(_response);
        });
    }

    protected processSaveSignature(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getTipiIntervento(): Promise<TipoIntervento[] | null> {
        let url_ = this.baseUrl + "/interventi/tipi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipiIntervento(_response);
        });
    }

    protected processGetTipiIntervento(response: Response): Promise<TipoIntervento[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipoIntervento.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TipoIntervento[] | null>(null as any);
    }

    getReportInterventi(dataDa: Date | undefined, dataA: Date | undefined): Promise<InterventoDto[] | null> {
        let url_ = this.baseUrl + "/interventi/report?";
        if (dataDa === null)
            throw new Error("The parameter 'dataDa' cannot be null.");
        else if (dataDa !== undefined)
            url_ += "dataDa=" + encodeURIComponent(dataDa ? "" + dataDa.toISOString() : "") + "&";
        if (dataA === null)
            throw new Error("The parameter 'dataA' cannot be null.");
        else if (dataA !== undefined)
            url_ += "dataA=" + encodeURIComponent(dataA ? "" + dataA.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportInterventi(_response);
        });
    }

    protected processGetReportInterventi(response: Response): Promise<InterventoDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterventoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterventoDto[] | null>(null as any);
    }
}

export interface IModelliClimaClient {

    getAll(): Promise<ModelloClimaDto[] | null>;

    add(data: ModelloClimaDataDto): Promise<number>;

    deleteCaldaia(idCaldaia: number | undefined): Promise<boolean>;

    get(id: number): Promise<ModelloClimaDto | null>;

    update(data: ModelloClimaDataDto, id: number): Promise<boolean>;

    getCaldaieByMarca(filtroMarca: string | null | undefined, likeSearch: boolean | undefined): Promise<ModelloClimaDto[] | null>;

    getMarche(): Promise<string[] | null>;
}

export class ModelliClimaClient extends BaseClient implements IModelliClimaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<ModelloClimaDto[] | null> {
        let url_ = this.baseUrl + "/modelliclima";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ModelloClimaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelloClimaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelloClimaDto[] | null>(null as any);
    }

    add(data: ModelloClimaDataDto): Promise<number> {
        let url_ = this.baseUrl + "/modelliclima";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCaldaia(idCaldaia: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/modelliclima?";
        if (idCaldaia === null)
            throw new Error("The parameter 'idCaldaia' cannot be null.");
        else if (idCaldaia !== undefined)
            url_ += "idCaldaia=" + encodeURIComponent("" + idCaldaia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCaldaia(_response);
        });
    }

    protected processDeleteCaldaia(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(id: number): Promise<ModelloClimaDto | null> {
        let url_ = this.baseUrl + "/modelliclima/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ModelloClimaDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ModelloClimaDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelloClimaDto | null>(null as any);
    }

    update(data: ModelloClimaDataDto, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/modelliclima/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCaldaieByMarca(filtroMarca: string | null | undefined, likeSearch: boolean | undefined): Promise<ModelloClimaDto[] | null> {
        let url_ = this.baseUrl + "/modelliclima/byMarca?";
        if (filtroMarca !== undefined && filtroMarca !== null)
            url_ += "filtroMarca=" + encodeURIComponent("" + filtroMarca) + "&";
        if (likeSearch === null)
            throw new Error("The parameter 'likeSearch' cannot be null.");
        else if (likeSearch !== undefined)
            url_ += "likeSearch=" + encodeURIComponent("" + likeSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaldaieByMarca(_response);
        });
    }

    protected processGetCaldaieByMarca(response: Response): Promise<ModelloClimaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelloClimaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelloClimaDto[] | null>(null as any);
    }

    getMarche(): Promise<string[] | null> {
        let url_ = this.baseUrl + "/modelliclima/marche";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarche(_response);
        });
    }

    protected processGetMarche(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(null as any);
    }
}

export interface IOperatoriClient {

    getOperatoriByEsercente(): Promise<UserDto[] | null>;

    add(data: UserDataDto): Promise<boolean>;

    update(data: UserDataDto, userId: number): Promise<boolean>;
}

export class OperatoriClient extends BaseClient implements IOperatoriClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getOperatoriByEsercente(): Promise<UserDto[] | null> {
        let url_ = this.baseUrl + "/operatori";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOperatoriByEsercente(_response);
        });
    }

    protected processGetOperatoriByEsercente(response: Response): Promise<UserDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[] | null>(null as any);
    }

    add(data: UserDataDto): Promise<boolean> {
        let url_ = this.baseUrl + "/operatori";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(data: UserDataDto, userId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/operatori/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRapportiControlloClient {

    getByImpianto(idImpianto: number | undefined): Promise<RapportoControlloLite[] | null>;

    getLastNumber(year: number | undefined): Promise<number>;

    numberExist(year: number | undefined, number: number | undefined): Promise<boolean>;

    create(dto: CreateRapportoControlloDto): Promise<RapportoControlloLite | null>;

    saveSignature(data: SignatureData): Promise<string | null>;

    delete(year: number | undefined, number: number | undefined): Promise<boolean>;
}

export class RapportiControlloClient extends BaseClient implements IRapportiControlloClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getByImpianto(idImpianto: number | undefined): Promise<RapportoControlloLite[] | null> {
        let url_ = this.baseUrl + "/rapporticontrollo/filter?";
        if (idImpianto === null)
            throw new Error("The parameter 'idImpianto' cannot be null.");
        else if (idImpianto !== undefined)
            url_ += "idImpianto=" + encodeURIComponent("" + idImpianto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByImpianto(_response);
        });
    }

    protected processGetByImpianto(response: Response): Promise<RapportoControlloLite[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RapportoControlloLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportoControlloLite[] | null>(null as any);
    }

    getLastNumber(year: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/rapporticontrollo/lastnumber?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastNumber(_response);
        });
    }

    protected processGetLastNumber(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    numberExist(year: number | undefined, number: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/rapporticontrollo/numberexist?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNumberExist(_response);
        });
    }

    protected processNumberExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(dto: CreateRapportoControlloDto): Promise<RapportoControlloLite | null> {
        let url_ = this.baseUrl + "/rapporticontrollo/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<RapportoControlloLite | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RapportoControlloLite.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportoControlloLite | null>(null as any);
    }

    saveSignature(data: SignatureData): Promise<string | null> {
        let url_ = this.baseUrl + "/rapporticontrollo/signature/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSignature(_response);
        });
    }

    protected processSaveSignature(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    delete(year: number | undefined, number: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/rapporticontrollo?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRefrigerantiClient {

    getAll(): Promise<RefrigeranteType[] | null>;
}

export class RefrigerantiClient extends BaseClient implements IRefrigerantiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<RefrigeranteType[] | null> {
        let url_ = this.baseUrl + "/refrigeranti";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RefrigeranteType[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefrigeranteType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefrigeranteType[] | null>(null as any);
    }
}

export interface IReportsClient {

    getCustomersByLocalityReport(): Promise<CustomerByLocalityReport[] | null>;

    getCustomersByYearReport(): Promise<CustomersByYears[] | null>;

    getImpiantiByYearReport(): Promise<ImpiantiByYears[] | null>;

    getImpiantiByModelloReport(): Promise<ImpiantiByModello[] | null>;

    getTopImpiantiClima(): Promise<ImpiantiByModello[] | null>;

    getPlantForReplacementsCampaign(minInstallationAge: number | undefined): Promise<ImpiantoReport[] | null>;
}

export class ReportsClient extends BaseClient implements IReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCustomersByLocalityReport(): Promise<CustomerByLocalityReport[] | null> {
        let url_ = this.baseUrl + "/reports/customersbylocality";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomersByLocalityReport(_response);
        });
    }

    protected processGetCustomersByLocalityReport(response: Response): Promise<CustomerByLocalityReport[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerByLocalityReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerByLocalityReport[] | null>(null as any);
    }

    getCustomersByYearReport(): Promise<CustomersByYears[] | null> {
        let url_ = this.baseUrl + "/reports/customersbyyear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomersByYearReport(_response);
        });
    }

    protected processGetCustomersByYearReport(response: Response): Promise<CustomersByYears[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomersByYears.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomersByYears[] | null>(null as any);
    }

    getImpiantiByYearReport(): Promise<ImpiantiByYears[] | null> {
        let url_ = this.baseUrl + "/reports/impiantibyyear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImpiantiByYearReport(_response);
        });
    }

    protected processGetImpiantiByYearReport(response: Response): Promise<ImpiantiByYears[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantiByYears.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantiByYears[] | null>(null as any);
    }

    getImpiantiByModelloReport(): Promise<ImpiantiByModello[] | null> {
        let url_ = this.baseUrl + "/reports/topcaldaie";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImpiantiByModelloReport(_response);
        });
    }

    protected processGetImpiantiByModelloReport(response: Response): Promise<ImpiantiByModello[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantiByModello.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantiByModello[] | null>(null as any);
    }

    getTopImpiantiClima(): Promise<ImpiantiByModello[] | null> {
        let url_ = this.baseUrl + "/reports/topclima";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTopImpiantiClima(_response);
        });
    }

    protected processGetTopImpiantiClima(response: Response): Promise<ImpiantiByModello[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantiByModello.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantiByModello[] | null>(null as any);
    }

    getPlantForReplacementsCampaign(minInstallationAge: number | undefined): Promise<ImpiantoReport[] | null> {
        let url_ = this.baseUrl + "/reports/replacementscampaign?";
        if (minInstallationAge === null)
            throw new Error("The parameter 'minInstallationAge' cannot be null.");
        else if (minInstallationAge !== undefined)
            url_ += "minInstallationAge=" + encodeURIComponent("" + minInstallationAge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlantForReplacementsCampaign(_response);
        });
    }

    protected processGetPlantForReplacementsCampaign(response: Response): Promise<ImpiantoReport[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImpiantoReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpiantoReport[] | null>(null as any);
    }
}

export interface IScadenzeClient {

    getScadenze(dataDa: Date | undefined, dataA: Date | undefined, includePreviousYears: boolean | undefined): Promise<ScadenzaDto[] | null>;

    evasioneScadenzeMassivo(impList: number[] | null | undefined, data: AggiornaDateControlloData): Promise<boolean>;

    inviaNotitiche(request: SendNotificationsRequest): Promise<void>;
}

export class ScadenzeClient extends BaseClient implements IScadenzeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getScadenze(dataDa: Date | undefined, dataA: Date | undefined, includePreviousYears: boolean | undefined): Promise<ScadenzaDto[] | null> {
        let url_ = this.baseUrl + "/scadenze?";
        if (dataDa === null)
            throw new Error("The parameter 'dataDa' cannot be null.");
        else if (dataDa !== undefined)
            url_ += "dataDa=" + encodeURIComponent(dataDa ? "" + dataDa.toISOString() : "") + "&";
        if (dataA === null)
            throw new Error("The parameter 'dataA' cannot be null.");
        else if (dataA !== undefined)
            url_ += "dataA=" + encodeURIComponent(dataA ? "" + dataA.toISOString() : "") + "&";
        if (includePreviousYears === null)
            throw new Error("The parameter 'includePreviousYears' cannot be null.");
        else if (includePreviousYears !== undefined)
            url_ += "includePreviousYears=" + encodeURIComponent("" + includePreviousYears) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScadenze(_response);
        });
    }

    protected processGetScadenze(response: Response): Promise<ScadenzaDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScadenzaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScadenzaDto[] | null>(null as any);
    }

    evasioneScadenzeMassivo(impList: number[] | null | undefined, data: AggiornaDateControlloData): Promise<boolean> {
        let url_ = this.baseUrl + "/scadenze/evasionescadenzemassivo?";
        if (impList !== undefined && impList !== null)
            impList && impList.forEach(item => { url_ += "impList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEvasioneScadenzeMassivo(_response);
        });
    }

    protected processEvasioneScadenzeMassivo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    inviaNotitiche(request: SendNotificationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/scadenze/sendNotitications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviaNotitiche(_response);
        });
    }

    protected processInviaNotitiche(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISettingsClient {

    getConfigEsercente(): Promise<ConfigEsercente | null>;

    insertConfigEsercente(): Promise<boolean>;

    updateConfigEsercente(newConfig: ConfigEsercente): Promise<boolean>;
}

export class SettingsClient extends BaseClient implements ISettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getConfigEsercente(): Promise<ConfigEsercente | null> {
        let url_ = this.baseUrl + "/settings/configEsercente";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigEsercente(_response);
        });
    }

    protected processGetConfigEsercente(response: Response): Promise<ConfigEsercente | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConfigEsercente.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigEsercente | null>(null as any);
    }

    insertConfigEsercente(): Promise<boolean> {
        let url_ = this.baseUrl + "/settings/esercente";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertConfigEsercente(_response);
        });
    }

    protected processInsertConfigEsercente(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateConfigEsercente(newConfig: ConfigEsercente): Promise<boolean> {
        let url_ = this.baseUrl + "/settings/esercente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConfigEsercente(_response);
        });
    }

    protected processUpdateConfigEsercente(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ISkebbyClient {

    post(delivery_date: string | null | undefined, order_id: string | null | undefined, status: string | null | undefined, recipient: string | null | undefined): Promise<void>;
}

export class SkebbyClient extends BaseClient implements ISkebbyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    post(delivery_date: string | null | undefined, order_id: string | null | undefined, status: string | null | undefined, recipient: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/skebby/hook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (delivery_date !== null && delivery_date !== undefined)
            content_.append("delivery_date", delivery_date.toString());
        if (order_id !== null && order_id !== undefined)
            content_.append("order_id", order_id.toString());
        if (status !== null && status !== undefined)
            content_.append("status", status.toString());
        if (recipient !== null && recipient !== undefined)
            content_.append("recipient", recipient.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IStripeClient {

    get(): Promise<string | null>;

    getSms(smsCount: number | undefined): Promise<string | null>;
}

export class StripeClient extends BaseClient implements IStripeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<string | null> {
        let url_ = this.baseUrl + "/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getSms(smsCount: number | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/stripe/sms?";
        if (smsCount === null)
            throw new Error("The parameter 'smsCount' cannot be null.");
        else if (smsCount !== undefined)
            url_ += "smsCount=" + encodeURIComponent("" + smsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSms(_response);
        });
    }

    protected processGetSms(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }
}

export interface ITechniciansClient {

    getAll(): Promise<TechnicianDto[] | null>;

    add(data: TechnicianData): Promise<number>;

    update(data: TechnicianData, id: number): Promise<boolean>;

    delete(id: number): Promise<boolean>;
}

export class TechniciansClient extends BaseClient implements ITechniciansClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<TechnicianDto[] | null> {
        let url_ = this.baseUrl + "/technicians";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TechnicianDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicianDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicianDto[] | null>(null as any);
    }

    add(data: TechnicianData): Promise<number> {
        let url_ = this.baseUrl + "/technicians";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(data: TechnicianData, id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/technicians/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    delete(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/technicians/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ITipiContrattoClient {

    getTipoContratto(id: string): Promise<TipoContratto | null>;

    getAllTipiContratto(): Promise<TipoContratto[] | null>;

    addTipoContratto(tipoContrattoDto: TipoContratto): Promise<void>;

    updateTipoContratto(tipoContrattoDto: TipoContratto): Promise<void>;

    deleteTipoContratto(id: string | undefined): Promise<void>;
}

export class TipiContrattoClient extends BaseClient implements ITipiContrattoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTipoContratto(id: string): Promise<TipoContratto | null> {
        let url_ = this.baseUrl + "/tipicontratto/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTipoContratto(_response);
        });
    }

    protected processGetTipoContratto(response: Response): Promise<TipoContratto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TipoContratto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TipoContratto | null>(null as any);
    }

    getAllTipiContratto(): Promise<TipoContratto[] | null> {
        let url_ = this.baseUrl + "/tipicontratto";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTipiContratto(_response);
        });
    }

    protected processGetAllTipiContratto(response: Response): Promise<TipoContratto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipoContratto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TipoContratto[] | null>(null as any);
    }

    addTipoContratto(tipoContrattoDto: TipoContratto): Promise<void> {
        let url_ = this.baseUrl + "/tipicontratto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tipoContrattoDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddTipoContratto(_response);
        });
    }

    protected processAddTipoContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTipoContratto(tipoContrattoDto: TipoContratto): Promise<void> {
        let url_ = this.baseUrl + "/tipicontratto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tipoContrattoDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTipoContratto(_response);
        });
    }

    protected processUpdateTipoContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTipoContratto(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/tipicontratto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTipoContratto(_response);
        });
    }

    protected processDeleteTipoContratto(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUsersClient {

    get(): Promise<AccountData | null>;

    setNewsRead(): Promise<void>;

    login(loginRequest: LoginRequestDto): Promise<FileResponse | null>;

    tokenLogin(loginRequest: LoginRequestDto): Promise<TokenResponseDto | null>;

    signOut(): Promise<void>;

    forgotPassword(request: ForgotPasswordRequest): Promise<boolean>;

    resetPassword(request: ResetPasswordRequest): Promise<boolean>;
}

export class UsersClient extends BaseClient implements IUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<AccountData | null> {
        let url_ = this.baseUrl + "/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AccountData | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccountData.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountData | null>(null as any);
    }

    setNewsRead(): Promise<void> {
        let url_ = this.baseUrl + "/auth/newsread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetNewsRead(_response);
        });
    }

    protected processSetNewsRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    login(loginRequest: LoginRequestDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    tokenLogin(loginRequest: LoginRequestDto): Promise<TokenResponseDto | null> {
        let url_ = this.baseUrl + "/auth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTokenLogin(_response);
        });
    }

    protected processTokenLogin(response: Response): Promise<TokenResponseDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TokenResponseDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseDto | null>(null as any);
    }

    signOut(): Promise<void> {
        let url_ = this.baseUrl + "/auth/signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignOut(_response);
        });
    }

    protected processSignOut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/auth/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    resetPassword(request: ResetPasswordRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/auth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export enum RapportoControlloTypeDto {
    Standard = 0,
    Lombardia = 1,
    BiomassaStandard = 2,
    Piemonte = 3,
    Frigo = 4,
}

export enum TipoResponsabile {
    Proprietario = 0,
    Occupante = 1,
    AmministratoreCondominio = 2,
    TerzoResponsabile = 3,
}

export enum Flag {
    No = 0,
    Si = 1,
    Nc = 2,
}

export enum TipoGruppo {
    GruppoSingolo = 0,
    GruppoModulare = 1,
    TuboNastroRadiante = 2,
    GeneratoreAria = 3,
    Tradizionale = 4,
    Condensazione = 5,
    Altro = 6,
}

export enum TipoCombustibile {
    GPL = 0,
    GasNaturale = 1,
    Gasolio = 2,
    Altro = 3,
    Legna = 4,
    Pellet = 5,
    Bricchette = 6,
    Cippato = 7,
}

export enum TipoTiraggio {
    Naturale = 0,
    Forzato = 1,
}

export enum TipoGruppoBiomasse {
    Caldaia = 0,
    Stufa = 1,
    StufaAccumulo = 2,
    Termocucina = 3,
    CaminettoAperto = 4,
    CaminettoChiuso = 5,
    InsertoCaminetto = 6,
    StufaInOpera = 7,
    StufaPellet = 8,
    Tradizionale = 9,
    Condensazione = 10,
    Altro1 = 11,
    Altro2 = 12,
}

export class TrattamentoAcquaLombardia implements ITrattamentoAcquaLombardia {
    esercizio1_1?: string | undefined;
    esercizio2_1?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;
    nomeProdotto?: string | undefined;
    esercizio1_2?: string | undefined;
    esercizio2_2?: string | undefined;
    quantita?: string | undefined;
    unitaMisura?: string | undefined;
    impTermico!: boolean;
    acs!: boolean;
    ausiliari!: boolean;

    constructor(data?: ITrattamentoAcquaLombardia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.esercizio1_1 = _data["esercizio1_1"];
            this.esercizio2_1 = _data["esercizio2_1"];
            this.iniziale = _data["iniziale"];
            this.finale = _data["finale"];
            this.consumo = _data["consumo"];
            this.nomeProdotto = _data["nomeProdotto"];
            this.esercizio1_2 = _data["esercizio1_2"];
            this.esercizio2_2 = _data["esercizio2_2"];
            this.quantita = _data["quantita"];
            this.unitaMisura = _data["unitaMisura"];
            this.impTermico = _data["impTermico"];
            this.acs = _data["acs"];
            this.ausiliari = _data["ausiliari"];
        }
    }

    static fromJS(data: any): TrattamentoAcquaLombardia {
        data = typeof data === 'object' ? data : {};
        let result = new TrattamentoAcquaLombardia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["esercizio1_1"] = this.esercizio1_1;
        data["esercizio2_1"] = this.esercizio2_1;
        data["iniziale"] = this.iniziale;
        data["finale"] = this.finale;
        data["consumo"] = this.consumo;
        data["nomeProdotto"] = this.nomeProdotto;
        data["esercizio1_2"] = this.esercizio1_2;
        data["esercizio2_2"] = this.esercizio2_2;
        data["quantita"] = this.quantita;
        data["unitaMisura"] = this.unitaMisura;
        data["impTermico"] = this.impTermico;
        data["acs"] = this.acs;
        data["ausiliari"] = this.ausiliari;
        return data;
    }

    clone(): TrattamentoAcquaLombardia {
        const json = this.toJSON();
        let result = new TrattamentoAcquaLombardia();
        result.init(json);
        return result;
    }
}

export interface ITrattamentoAcquaLombardia {
    esercizio1_1?: string | undefined;
    esercizio2_1?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;
    nomeProdotto?: string | undefined;
    esercizio1_2?: string | undefined;
    esercizio2_2?: string | undefined;
    quantita?: string | undefined;
    unitaMisura?: string | undefined;
    impTermico: boolean;
    acs: boolean;
    ausiliari: boolean;
}

export class CombustibileLombardia implements ICombustibileLombardia {
    combustibile?: string | undefined;
    unitaMisura?: string | undefined;
    esercizio1?: string | undefined;
    esercizio2?: string | undefined;
    acquisti?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;

    constructor(data?: ICombustibileLombardia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.combustibile = _data["combustibile"];
            this.unitaMisura = _data["unitaMisura"];
            this.esercizio1 = _data["esercizio1"];
            this.esercizio2 = _data["esercizio2"];
            this.acquisti = _data["acquisti"];
            this.iniziale = _data["iniziale"];
            this.finale = _data["finale"];
            this.consumo = _data["consumo"];
        }
    }

    static fromJS(data: any): CombustibileLombardia {
        data = typeof data === 'object' ? data : {};
        let result = new CombustibileLombardia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["combustibile"] = this.combustibile;
        data["unitaMisura"] = this.unitaMisura;
        data["esercizio1"] = this.esercizio1;
        data["esercizio2"] = this.esercizio2;
        data["acquisti"] = this.acquisti;
        data["iniziale"] = this.iniziale;
        data["finale"] = this.finale;
        data["consumo"] = this.consumo;
        return data;
    }

    clone(): CombustibileLombardia {
        const json = this.toJSON();
        let result = new CombustibileLombardia();
        result.init(json);
        return result;
    }
}

export interface ICombustibileLombardia {
    combustibile?: string | undefined;
    unitaMisura?: string | undefined;
    esercizio1?: string | undefined;
    esercizio2?: string | undefined;
    acquisti?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;
}

export class ElettricitaLombardia implements IElettricitaLombardia {
    esercizio1?: string | undefined;
    esercizio2?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;

    constructor(data?: IElettricitaLombardia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.esercizio1 = _data["esercizio1"];
            this.esercizio2 = _data["esercizio2"];
            this.iniziale = _data["iniziale"];
            this.finale = _data["finale"];
            this.consumo = _data["consumo"];
        }
    }

    static fromJS(data: any): ElettricitaLombardia {
        data = typeof data === 'object' ? data : {};
        let result = new ElettricitaLombardia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["esercizio1"] = this.esercizio1;
        data["esercizio2"] = this.esercizio2;
        data["iniziale"] = this.iniziale;
        data["finale"] = this.finale;
        data["consumo"] = this.consumo;
        return data;
    }

    clone(): ElettricitaLombardia {
        const json = this.toJSON();
        let result = new ElettricitaLombardia();
        result.init(json);
        return result;
    }
}

export interface IElettricitaLombardia {
    esercizio1?: string | undefined;
    esercizio2?: string | undefined;
    iniziale?: string | undefined;
    finale?: string | undefined;
    consumo?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    key!: string;
    fileName!: string;
    folderName!: string;
    subfolderName!: string;
    previewAvailable!: boolean;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.fileName = _data["fileName"];
            this.folderName = _data["folderName"];
            this.subfolderName = _data["subfolderName"];
            this.previewAvailable = _data["previewAvailable"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["fileName"] = this.fileName;
        data["folderName"] = this.folderName;
        data["subfolderName"] = this.subfolderName;
        data["previewAvailable"] = this.previewAvailable;
        return data;
    }

    clone(): AttachmentDto {
        const json = this.toJSON();
        let result = new AttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IAttachmentDto {
    key: string;
    fileName: string;
    folderName: string;
    subfolderName: string;
    previewAvailable: boolean;
}

export class BollinoDataDto implements IBollinoDataDto {
    idImpianto!: number;
    codiceBollino?: string | undefined;
    validity!: PeriodDto;

    constructor(data?: IBollinoDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.validity = new PeriodDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idImpianto = _data["idImpianto"];
            this.codiceBollino = _data["codiceBollino"];
            this.validity = _data["validity"] ? PeriodDto.fromJS(_data["validity"]) : new PeriodDto();
        }
    }

    static fromJS(data: any): BollinoDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BollinoDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idImpianto"] = this.idImpianto;
        data["codiceBollino"] = this.codiceBollino;
        data["validity"] = this.validity ? this.validity.toJSON() : <any>undefined;
        return data;
    }

    clone(): BollinoDataDto {
        const json = this.toJSON();
        let result = new BollinoDataDto();
        result.init(json);
        return result;
    }
}

export interface IBollinoDataDto {
    idImpianto: number;
    codiceBollino?: string | undefined;
    validity: PeriodDto;
}

export class BollinoDto extends BollinoDataDto implements IBollinoDto {
    idBollino!: number;

    constructor(data?: IBollinoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idBollino = _data["idBollino"];
        }
    }

    static override fromJS(data: any): BollinoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BollinoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idBollino"] = this.idBollino;
        super.toJSON(data);
        return data;
    }

    clone(): BollinoDto {
        const json = this.toJSON();
        let result = new BollinoDto();
        result.init(json);
        return result;
    }
}

export interface IBollinoDto extends IBollinoDataDto {
    idBollino: number;
}

export class PeriodDto implements IPeriodDto {
    from!: Date;
    to!: Date;

    constructor(data?: IPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }

    clone(): PeriodDto {
        const json = this.toJSON();
        let result = new PeriodDto();
        result.init(json);
        return result;
    }
}

export interface IPeriodDto {
    from: Date;
    to: Date;
}

export class BruciatoreDataDto implements IBruciatoreDataDto {
    marcaBruciatore?: string | undefined;
    modelloBruciatore?: string | undefined;
    campoFunzionamentoDa!: number;
    campoFunzionamentoA!: number;
    tipoBruciatore?: string | undefined;

    constructor(data?: IBruciatoreDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marcaBruciatore = _data["marcaBruciatore"];
            this.modelloBruciatore = _data["modelloBruciatore"];
            this.campoFunzionamentoDa = _data["campoFunzionamentoDa"];
            this.campoFunzionamentoA = _data["campoFunzionamentoA"];
            this.tipoBruciatore = _data["tipoBruciatore"];
        }
    }

    static fromJS(data: any): BruciatoreDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BruciatoreDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marcaBruciatore"] = this.marcaBruciatore;
        data["modelloBruciatore"] = this.modelloBruciatore;
        data["campoFunzionamentoDa"] = this.campoFunzionamentoDa;
        data["campoFunzionamentoA"] = this.campoFunzionamentoA;
        data["tipoBruciatore"] = this.tipoBruciatore;
        return data;
    }

    clone(): BruciatoreDataDto {
        const json = this.toJSON();
        let result = new BruciatoreDataDto();
        result.init(json);
        return result;
    }
}

export interface IBruciatoreDataDto {
    marcaBruciatore?: string | undefined;
    modelloBruciatore?: string | undefined;
    campoFunzionamentoDa: number;
    campoFunzionamentoA: number;
    tipoBruciatore?: string | undefined;
}

export class BruciatoreDto extends BruciatoreDataDto implements IBruciatoreDto {
    idBruciatore!: number;

    constructor(data?: IBruciatoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idBruciatore = _data["idBruciatore"];
        }
    }

    static override fromJS(data: any): BruciatoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new BruciatoreDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idBruciatore"] = this.idBruciatore;
        super.toJSON(data);
        return data;
    }

    clone(): BruciatoreDto {
        const json = this.toJSON();
        let result = new BruciatoreDto();
        result.init(json);
        return result;
    }
}

export interface IBruciatoreDto extends IBruciatoreDataDto {
    idBruciatore: number;
}

export class CaldaiaDataDto implements ICaldaiaDataDto {
    marcaCaldaia?: string | undefined;
    modelloCaldaia?: string | undefined;
    potenzaFocolare!: number;
    potenzaUtile!: number;

    constructor(data?: ICaldaiaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marcaCaldaia = _data["marcaCaldaia"];
            this.modelloCaldaia = _data["modelloCaldaia"];
            this.potenzaFocolare = _data["potenzaFocolare"];
            this.potenzaUtile = _data["potenzaUtile"];
        }
    }

    static fromJS(data: any): CaldaiaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaldaiaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marcaCaldaia"] = this.marcaCaldaia;
        data["modelloCaldaia"] = this.modelloCaldaia;
        data["potenzaFocolare"] = this.potenzaFocolare;
        data["potenzaUtile"] = this.potenzaUtile;
        return data;
    }

    clone(): CaldaiaDataDto {
        const json = this.toJSON();
        let result = new CaldaiaDataDto();
        result.init(json);
        return result;
    }
}

export interface ICaldaiaDataDto {
    marcaCaldaia?: string | undefined;
    modelloCaldaia?: string | undefined;
    potenzaFocolare: number;
    potenzaUtile: number;
}

export class CaldaiaDto extends CaldaiaDataDto implements ICaldaiaDto {
    idCaldaia!: number;

    constructor(data?: ICaldaiaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idCaldaia = _data["idCaldaia"];
        }
    }

    static override fromJS(data: any): CaldaiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaldaiaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCaldaia"] = this.idCaldaia;
        super.toJSON(data);
        return data;
    }

    clone(): CaldaiaDto {
        const json = this.toJSON();
        let result = new CaldaiaDto();
        result.init(json);
        return result;
    }
}

export interface ICaldaiaDto extends ICaldaiaDataDto {
    idCaldaia: number;
}

export class ClienteData implements IClienteData {
    sezione?: string | undefined;
    foglio?: string | undefined;
    particella?: string | undefined;
    sub?: string | undefined;
    codiceClienteAzienda!: number;
    dismessa!: boolean;
    nomeProprietario?: string | undefined;
    cognomeProprietario?: string | undefined;
    responsabile?: string | undefined;
    azienda!: boolean;
    sesso?: string | undefined;
    comune?: Comune | undefined;
    frazione?: Frazione | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    piano?: string | undefined;
    latitudine?: number | undefined;
    longitudine?: number | undefined;
    telefono?: string | undefined;
    cell?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    notaCliente?: string | undefined;
    codiceFiscale?: string | undefined;
    partitaIva?: string | undefined;
    pec?: string | undefined;
    sdi?: string | undefined;

    constructor(data?: IClienteData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sezione = _data["sezione"];
            this.foglio = _data["foglio"];
            this.particella = _data["particella"];
            this.sub = _data["sub"];
            this.codiceClienteAzienda = _data["codiceClienteAzienda"];
            this.dismessa = _data["dismessa"];
            this.nomeProprietario = _data["nomeProprietario"];
            this.cognomeProprietario = _data["cognomeProprietario"];
            this.responsabile = _data["responsabile"];
            this.azienda = _data["azienda"];
            this.sesso = _data["sesso"];
            this.comune = _data["comune"] ? Comune.fromJS(_data["comune"]) : <any>undefined;
            this.frazione = _data["frazione"] ? Frazione.fromJS(_data["frazione"]) : <any>undefined;
            this.indirizzo = _data["indirizzo"];
            this.cap = _data["cap"];
            this.piano = _data["piano"];
            this.latitudine = _data["latitudine"];
            this.longitudine = _data["longitudine"];
            this.telefono = _data["telefono"];
            this.cell = _data["cell"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.notaCliente = _data["notaCliente"];
            this.codiceFiscale = _data["codiceFiscale"];
            this.partitaIva = _data["partitaIva"];
            this.pec = _data["pec"];
            this.sdi = _data["sdi"];
        }
    }

    static fromJS(data: any): ClienteData {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sezione"] = this.sezione;
        data["foglio"] = this.foglio;
        data["particella"] = this.particella;
        data["sub"] = this.sub;
        data["codiceClienteAzienda"] = this.codiceClienteAzienda;
        data["dismessa"] = this.dismessa;
        data["nomeProprietario"] = this.nomeProprietario;
        data["cognomeProprietario"] = this.cognomeProprietario;
        data["responsabile"] = this.responsabile;
        data["azienda"] = this.azienda;
        data["sesso"] = this.sesso;
        data["comune"] = this.comune ? this.comune.toJSON() : <any>undefined;
        data["frazione"] = this.frazione ? this.frazione.toJSON() : <any>undefined;
        data["indirizzo"] = this.indirizzo;
        data["cap"] = this.cap;
        data["piano"] = this.piano;
        data["latitudine"] = this.latitudine;
        data["longitudine"] = this.longitudine;
        data["telefono"] = this.telefono;
        data["cell"] = this.cell;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["notaCliente"] = this.notaCliente;
        data["codiceFiscale"] = this.codiceFiscale;
        data["partitaIva"] = this.partitaIva;
        data["pec"] = this.pec;
        data["sdi"] = this.sdi;
        return data;
    }

    clone(): ClienteData {
        const json = this.toJSON();
        let result = new ClienteData();
        result.init(json);
        return result;
    }
}

export interface IClienteData {
    sezione?: string | undefined;
    foglio?: string | undefined;
    particella?: string | undefined;
    sub?: string | undefined;
    codiceClienteAzienda: number;
    dismessa: boolean;
    nomeProprietario?: string | undefined;
    cognomeProprietario?: string | undefined;
    responsabile?: string | undefined;
    azienda: boolean;
    sesso?: string | undefined;
    comune?: Comune | undefined;
    frazione?: Frazione | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    piano?: string | undefined;
    latitudine?: number | undefined;
    longitudine?: number | undefined;
    telefono?: string | undefined;
    cell?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    notaCliente?: string | undefined;
    codiceFiscale?: string | undefined;
    partitaIva?: string | undefined;
    pec?: string | undefined;
    sdi?: string | undefined;
}

export class ClienteDto extends ClienteData implements IClienteDto {
    idCliente!: number;

    constructor(data?: IClienteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idCliente = _data["idCliente"];
        }
    }

    static override fromJS(data: any): ClienteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCliente"] = this.idCliente;
        super.toJSON(data);
        return data;
    }

    clone(): ClienteDto {
        const json = this.toJSON();
        let result = new ClienteDto();
        result.init(json);
        return result;
    }
}

export interface IClienteDto extends IClienteData {
    idCliente: number;
}

export class Comune implements IComune {
    codFisComune!: string;
    nomeComune?: string | undefined;
    provincia?: string | undefined;
    regione?: string | undefined;
    cap?: string | undefined;
    prefisso?: string | undefined;
    codiceIstat?: string | undefined;

    constructor(data?: IComune) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codFisComune = _data["codFisComune"];
            this.nomeComune = _data["nomeComune"];
            this.provincia = _data["provincia"];
            this.regione = _data["regione"];
            this.cap = _data["cap"];
            this.prefisso = _data["prefisso"];
            this.codiceIstat = _data["codiceIstat"];
        }
    }

    static fromJS(data: any): Comune {
        data = typeof data === 'object' ? data : {};
        let result = new Comune();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codFisComune"] = this.codFisComune;
        data["nomeComune"] = this.nomeComune;
        data["provincia"] = this.provincia;
        data["regione"] = this.regione;
        data["cap"] = this.cap;
        data["prefisso"] = this.prefisso;
        data["codiceIstat"] = this.codiceIstat;
        return data;
    }

    clone(): Comune {
        const json = this.toJSON();
        let result = new Comune();
        result.init(json);
        return result;
    }
}

export interface IComune {
    codFisComune: string;
    nomeComune?: string | undefined;
    provincia?: string | undefined;
    regione?: string | undefined;
    cap?: string | undefined;
    prefisso?: string | undefined;
    codiceIstat?: string | undefined;
}

export class Frazione implements IFrazione {
    codFisComune!: string;
    codFrazione!: string;
    nomeFrazione?: string | undefined;

    constructor(data?: IFrazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codFisComune = _data["codFisComune"];
            this.codFrazione = _data["codFrazione"];
            this.nomeFrazione = _data["nomeFrazione"];
        }
    }

    static fromJS(data: any): Frazione {
        data = typeof data === 'object' ? data : {};
        let result = new Frazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codFisComune"] = this.codFisComune;
        data["codFrazione"] = this.codFrazione;
        data["nomeFrazione"] = this.nomeFrazione;
        return data;
    }

    clone(): Frazione {
        const json = this.toJSON();
        let result = new Frazione();
        result.init(json);
        return result;
    }
}

export interface IFrazione {
    codFisComune: string;
    codFrazione: string;
    nomeFrazione?: string | undefined;
}

export class ContrattoData implements IContrattoData {
    idImpianto!: number;
    inizioValidita!: Date;
    fineValidita!: Date;
    dataInserimento!: Date;
    dataUltimaModifica!: Date;
    tipoContrattoId!: string;

    constructor(data?: IContrattoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idImpianto = _data["idImpianto"];
            this.inizioValidita = _data["inizioValidita"] ? new Date(_data["inizioValidita"].toString()) : <any>undefined;
            this.fineValidita = _data["fineValidita"] ? new Date(_data["fineValidita"].toString()) : <any>undefined;
            this.dataInserimento = _data["dataInserimento"] ? new Date(_data["dataInserimento"].toString()) : <any>undefined;
            this.dataUltimaModifica = _data["dataUltimaModifica"] ? new Date(_data["dataUltimaModifica"].toString()) : <any>undefined;
            this.tipoContrattoId = _data["tipoContrattoId"];
        }
    }

    static fromJS(data: any): ContrattoData {
        data = typeof data === 'object' ? data : {};
        let result = new ContrattoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idImpianto"] = this.idImpianto;
        data["inizioValidita"] = this.inizioValidita ? this.inizioValidita.toISOString() : <any>undefined;
        data["fineValidita"] = this.fineValidita ? this.fineValidita.toISOString() : <any>undefined;
        data["dataInserimento"] = this.dataInserimento ? this.dataInserimento.toISOString() : <any>undefined;
        data["dataUltimaModifica"] = this.dataUltimaModifica ? this.dataUltimaModifica.toISOString() : <any>undefined;
        data["tipoContrattoId"] = this.tipoContrattoId;
        return data;
    }

    clone(): ContrattoData {
        const json = this.toJSON();
        let result = new ContrattoData();
        result.init(json);
        return result;
    }
}

export interface IContrattoData {
    idImpianto: number;
    inizioValidita: Date;
    fineValidita: Date;
    dataInserimento: Date;
    dataUltimaModifica: Date;
    tipoContrattoId: string;
}

export class Contratto extends ContrattoData implements IContratto {
    id!: string;

    constructor(data?: IContratto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): Contratto {
        data = typeof data === 'object' ? data : {};
        let result = new Contratto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): Contratto {
        const json = this.toJSON();
        let result = new Contratto();
        result.init(json);
        return result;
    }
}

export interface IContratto extends IContrattoData {
    id: string;
}

export class CompanyDataDto implements ICompanyDataDto {
    ragioneSocialeEsercente?: string | undefined;
    partitaIvaEsercente?: string | undefined;
    codiceFiscaleEsercente?: string | undefined;
    indirizzoEsercente?: string | undefined;
    cittaEsercente?: string | undefined;
    provinciaEsercente?: string | undefined;
    capEsercente?: string | undefined;
    emailEsercente?: string | undefined;
    telFissoEsercente?: string | undefined;
    telMobileEsercente?: string | undefined;
    linkLogoEsercente?: string | undefined;
    pec?: string | undefined;
    sdi?: string | undefined;
    marketingUse!: boolean;

    constructor(data?: ICompanyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ragioneSocialeEsercente = _data["ragioneSocialeEsercente"];
            this.partitaIvaEsercente = _data["partitaIvaEsercente"];
            this.codiceFiscaleEsercente = _data["codiceFiscaleEsercente"];
            this.indirizzoEsercente = _data["indirizzoEsercente"];
            this.cittaEsercente = _data["cittaEsercente"];
            this.provinciaEsercente = _data["provinciaEsercente"];
            this.capEsercente = _data["capEsercente"];
            this.emailEsercente = _data["emailEsercente"];
            this.telFissoEsercente = _data["telFissoEsercente"];
            this.telMobileEsercente = _data["telMobileEsercente"];
            this.linkLogoEsercente = _data["linkLogoEsercente"];
            this.pec = _data["pec"];
            this.sdi = _data["sdi"];
            this.marketingUse = _data["marketingUse"];
        }
    }

    static fromJS(data: any): CompanyDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ragioneSocialeEsercente"] = this.ragioneSocialeEsercente;
        data["partitaIvaEsercente"] = this.partitaIvaEsercente;
        data["codiceFiscaleEsercente"] = this.codiceFiscaleEsercente;
        data["indirizzoEsercente"] = this.indirizzoEsercente;
        data["cittaEsercente"] = this.cittaEsercente;
        data["provinciaEsercente"] = this.provinciaEsercente;
        data["capEsercente"] = this.capEsercente;
        data["emailEsercente"] = this.emailEsercente;
        data["telFissoEsercente"] = this.telFissoEsercente;
        data["telMobileEsercente"] = this.telMobileEsercente;
        data["linkLogoEsercente"] = this.linkLogoEsercente;
        data["pec"] = this.pec;
        data["sdi"] = this.sdi;
        data["marketingUse"] = this.marketingUse;
        return data;
    }

    clone(): CompanyDataDto {
        const json = this.toJSON();
        let result = new CompanyDataDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDataDto {
    ragioneSocialeEsercente?: string | undefined;
    partitaIvaEsercente?: string | undefined;
    codiceFiscaleEsercente?: string | undefined;
    indirizzoEsercente?: string | undefined;
    cittaEsercente?: string | undefined;
    provinciaEsercente?: string | undefined;
    capEsercente?: string | undefined;
    emailEsercente?: string | undefined;
    telFissoEsercente?: string | undefined;
    telMobileEsercente?: string | undefined;
    linkLogoEsercente?: string | undefined;
    pec?: string | undefined;
    sdi?: string | undefined;
    marketingUse: boolean;
}

export class CompanyDto extends CompanyDataDto implements ICompanyDto {
    id!: number;

    constructor(data?: ICompanyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto extends ICompanyDataDto {
    id: number;
}

export class RegisterCompanyRequest implements IRegisterCompanyRequest {
    company?: CompanyDataDto | undefined;
    users?: UserDataDto[] | undefined;

    constructor(data?: IRegisterCompanyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDataDto.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegisterCompanyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCompanyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }

    clone(): RegisterCompanyRequest {
        const json = this.toJSON();
        let result = new RegisterCompanyRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterCompanyRequest {
    company?: CompanyDataDto | undefined;
    users?: UserDataDto[] | undefined;
}

export class UserDataDto implements IUserDataDto {
    nomeOperatore?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    amministratore!: boolean;
    disabilitato!: boolean;

    constructor(data?: IUserDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomeOperatore = _data["nomeOperatore"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.amministratore = _data["amministratore"];
            this.disabilitato = _data["disabilitato"];
        }
    }

    static fromJS(data: any): UserDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeOperatore"] = this.nomeOperatore;
        data["username"] = this.username;
        data["password"] = this.password;
        data["amministratore"] = this.amministratore;
        data["disabilitato"] = this.disabilitato;
        return data;
    }

    clone(): UserDataDto {
        const json = this.toJSON();
        let result = new UserDataDto();
        result.init(json);
        return result;
    }
}

export interface IUserDataDto {
    nomeOperatore?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    amministratore: boolean;
    disabilitato: boolean;
}

export class ExpirationSettingsDto implements IExpirationSettingsDto {
    standard?: ExpirationSingleSettings | undefined;
    combustioneU35?: ExpirationSingleSettings | undefined;
    combustioneO35?: ExpirationSingleSettings | undefined;
    contratti!: boolean;
    bollini?: ExpirationSingleSettings | undefined;

    constructor(data?: IExpirationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standard = _data["standard"] ? ExpirationSingleSettings.fromJS(_data["standard"]) : <any>undefined;
            this.combustioneU35 = _data["combustioneU35"] ? ExpirationSingleSettings.fromJS(_data["combustioneU35"]) : <any>undefined;
            this.combustioneO35 = _data["combustioneO35"] ? ExpirationSingleSettings.fromJS(_data["combustioneO35"]) : <any>undefined;
            this.contratti = _data["contratti"];
            this.bollini = _data["bollini"] ? ExpirationSingleSettings.fromJS(_data["bollini"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpirationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpirationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standard"] = this.standard ? this.standard.toJSON() : <any>undefined;
        data["combustioneU35"] = this.combustioneU35 ? this.combustioneU35.toJSON() : <any>undefined;
        data["combustioneO35"] = this.combustioneO35 ? this.combustioneO35.toJSON() : <any>undefined;
        data["contratti"] = this.contratti;
        data["bollini"] = this.bollini ? this.bollini.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExpirationSettingsDto {
        const json = this.toJSON();
        let result = new ExpirationSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IExpirationSettingsDto {
    standard?: ExpirationSingleSettings | undefined;
    combustioneU35?: ExpirationSingleSettings | undefined;
    combustioneO35?: ExpirationSingleSettings | undefined;
    contratti: boolean;
    bollini?: ExpirationSingleSettings | undefined;
}

export class ExpirationSingleSettings implements IExpirationSingleSettings {
    disabled!: boolean;
    rules!: ExpirationSettingsRule[];
    defaultMonths!: number;
    beginAfterMonths!: number;

    constructor(data?: IExpirationSingleSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ExpirationSettingsRule.fromJS(item));
            }
            this.defaultMonths = _data["defaultMonths"];
            this.beginAfterMonths = _data["beginAfterMonths"];
        }
    }

    static fromJS(data: any): ExpirationSingleSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ExpirationSingleSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["defaultMonths"] = this.defaultMonths;
        data["beginAfterMonths"] = this.beginAfterMonths;
        return data;
    }

    clone(): ExpirationSingleSettings {
        const json = this.toJSON();
        let result = new ExpirationSingleSettings();
        result.init(json);
        return result;
    }
}

export interface IExpirationSingleSettings {
    disabled: boolean;
    rules: ExpirationSettingsRule[];
    defaultMonths: number;
    beginAfterMonths: number;
}

export class ExpirationSettingsRule implements IExpirationSettingsRule {
    months!: number;
    province?: string | undefined;
    beginAfterMonths!: number;

    constructor(data?: IExpirationSettingsRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.months = _data["months"];
            this.province = _data["province"];
            this.beginAfterMonths = _data["beginAfterMonths"];
        }
    }

    static fromJS(data: any): ExpirationSettingsRule {
        data = typeof data === 'object' ? data : {};
        let result = new ExpirationSettingsRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["months"] = this.months;
        data["province"] = this.province;
        data["beginAfterMonths"] = this.beginAfterMonths;
        return data;
    }

    clone(): ExpirationSettingsRule {
        const json = this.toJSON();
        let result = new ExpirationSettingsRule();
        result.init(json);
        return result;
    }
}

export interface IExpirationSettingsRule {
    months: number;
    province?: string | undefined;
    beginAfterMonths: number;
}

export class ImpiantoCliente implements IImpiantoCliente {
    id!: number;
    idCliente!: number;
    codEsercente!: number;
    groupKey?: string | undefined;
    type!: ApparecchioCategoryType;
    dataInserimento!: Date;

    constructor(data?: IImpiantoCliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idCliente = _data["idCliente"];
            this.codEsercente = _data["codEsercente"];
            this.groupKey = _data["groupKey"];
            this.type = _data["type"];
            this.dataInserimento = _data["dataInserimento"] ? new Date(_data["dataInserimento"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImpiantoCliente {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoCliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idCliente"] = this.idCliente;
        data["codEsercente"] = this.codEsercente;
        data["groupKey"] = this.groupKey;
        data["type"] = this.type;
        data["dataInserimento"] = this.dataInserimento ? this.dataInserimento.toISOString() : <any>undefined;
        return data;
    }

    clone(): ImpiantoCliente {
        const json = this.toJSON();
        let result = new ImpiantoCliente();
        result.init(json);
        return result;
    }
}

export interface IImpiantoCliente {
    id: number;
    idCliente: number;
    codEsercente: number;
    groupKey?: string | undefined;
    type: ApparecchioCategoryType;
    dataInserimento: Date;
}

export class ImpiantoLight extends ImpiantoCliente implements IImpiantoLight {
    marca?: string | undefined;
    modello?: string | undefined;
    matricola?: string | undefined;
    dataInstallazione?: Date | undefined;
    dataUltimoControllo?: Date | undefined;
    annoFabbricazione!: number;
    dismesso!: boolean;
    indirizzo?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    potenzaRif!: number;

    constructor(data?: IImpiantoLight) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marca = _data["marca"];
            this.modello = _data["modello"];
            this.matricola = _data["matricola"];
            this.dataInstallazione = _data["dataInstallazione"] ? new Date(_data["dataInstallazione"].toString()) : <any>undefined;
            this.dataUltimoControllo = _data["dataUltimoControllo"] ? new Date(_data["dataUltimoControllo"].toString()) : <any>undefined;
            this.annoFabbricazione = _data["annoFabbricazione"];
            this.dismesso = _data["dismesso"];
            this.indirizzo = _data["indirizzo"];
            this.codFisComune = _data["codFisComune"];
            this.codFrazione = _data["codFrazione"];
            this.potenzaRif = _data["potenzaRif"];
        }
    }

    static override fromJS(data: any): ImpiantoLight {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoLight();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marca"] = this.marca;
        data["modello"] = this.modello;
        data["matricola"] = this.matricola;
        data["dataInstallazione"] = this.dataInstallazione ? this.dataInstallazione.toISOString() : <any>undefined;
        data["dataUltimoControllo"] = this.dataUltimoControllo ? this.dataUltimoControllo.toISOString() : <any>undefined;
        data["annoFabbricazione"] = this.annoFabbricazione;
        data["dismesso"] = this.dismesso;
        data["indirizzo"] = this.indirizzo;
        data["codFisComune"] = this.codFisComune;
        data["codFrazione"] = this.codFrazione;
        data["potenzaRif"] = this.potenzaRif;
        super.toJSON(data);
        return data;
    }

    clone(): ImpiantoLight {
        const json = this.toJSON();
        let result = new ImpiantoLight();
        result.init(json);
        return result;
    }
}

export interface IImpiantoLight extends IImpiantoCliente {
    marca?: string | undefined;
    modello?: string | undefined;
    matricola?: string | undefined;
    dataInstallazione?: Date | undefined;
    dataUltimoControllo?: Date | undefined;
    annoFabbricazione: number;
    dismesso: boolean;
    indirizzo?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    potenzaRif: number;
}

export enum ApparecchioCategoryType {
    Caldaia = 0,
    Scaldabagno = 1,
    Stufa = 2,
    CentraleTermica = 3,
    TermoStufa = 4,
    Bruciatore = 5,
    Generatore = 6,
    Pensile = 7,
    Radiante = 8,
    RadiatoreGas = 9,
    Rampa = 10,
    Aerotermo = 11,
    Condizionatore = 100,
    CondizionatoreUnitaEsterna = 101,
    CondizionatoreUnitaInterna = 102,
    PompaDiCalore = 103,
    ChillerGruppoFrigo = 104,
    PompaDiCaloreACS = 105,
    CentraleFrigo = 106,
    Addolcitore = 200,
    Camino = 201,
    CassettaIdronica = 202,
    Centralina = 203,
    Inserto = 204,
    PompaDosatrice = 205,
    PompaOsmosi = 206,
    TermoCamino = 207,
    Termostato = 208,
    VentilConvettore = 209,
    Scambiatore = 210,
    PannelliSolari = 211,
    Accumulo = 212,
    Bollitore = 213,
}

export class SetImpiantoKeyDto implements ISetImpiantoKeyDto {
    impianti?: number[] | undefined;
    groupKey?: string | undefined;

    constructor(data?: ISetImpiantoKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["impianti"])) {
                this.impianti = [] as any;
                for (let item of _data["impianti"])
                    this.impianti!.push(item);
            }
            this.groupKey = _data["groupKey"];
        }
    }

    static fromJS(data: any): SetImpiantoKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetImpiantoKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.impianti)) {
            data["impianti"] = [];
            for (let item of this.impianti)
                data["impianti"].push(item);
        }
        data["groupKey"] = this.groupKey;
        return data;
    }

    clone(): SetImpiantoKeyDto {
        const json = this.toJSON();
        let result = new SetImpiantoKeyDto();
        result.init(json);
        return result;
    }
}

export interface ISetImpiantoKeyDto {
    impianti?: number[] | undefined;
    groupKey?: string | undefined;
}

export class ImpiantoBaseDto implements IImpiantoBaseDto {
    inheritsAddress!: boolean;
    idCliente!: number;
    codiceImpiantoCatasto?: string | undefined;
    dataInserimento!: Date;
    dataUltimaModifica!: Date;
    codEsercente!: number;
    codOperatore!: number;
    dismesso!: boolean;
    dataInstallazione?: Date | undefined;
    annoFabbricazione!: number;
    matricola?: string | undefined;
    noteImpianto?: string | undefined;
    technicianId?: number | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    piano?: string | undefined;
    groupKey?: string | undefined;
    type!: ApparecchioCategoryType;

    constructor(data?: IImpiantoBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inheritsAddress = _data["inheritsAddress"];
            this.idCliente = _data["idCliente"];
            this.codiceImpiantoCatasto = _data["codiceImpiantoCatasto"];
            this.dataInserimento = _data["dataInserimento"] ? new Date(_data["dataInserimento"].toString()) : <any>undefined;
            this.dataUltimaModifica = _data["dataUltimaModifica"] ? new Date(_data["dataUltimaModifica"].toString()) : <any>undefined;
            this.codEsercente = _data["codEsercente"];
            this.codOperatore = _data["codOperatore"];
            this.dismesso = _data["dismesso"];
            this.dataInstallazione = _data["dataInstallazione"] ? new Date(_data["dataInstallazione"].toString()) : <any>undefined;
            this.annoFabbricazione = _data["annoFabbricazione"];
            this.matricola = _data["matricola"];
            this.noteImpianto = _data["noteImpianto"];
            this.technicianId = _data["technicianId"];
            this.indirizzo = _data["indirizzo"];
            this.cap = _data["cap"];
            this.codFisComune = _data["codFisComune"];
            this.codFrazione = _data["codFrazione"];
            this.piano = _data["piano"];
            this.groupKey = _data["groupKey"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ImpiantoBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inheritsAddress"] = this.inheritsAddress;
        data["idCliente"] = this.idCliente;
        data["codiceImpiantoCatasto"] = this.codiceImpiantoCatasto;
        data["dataInserimento"] = this.dataInserimento ? this.dataInserimento.toISOString() : <any>undefined;
        data["dataUltimaModifica"] = this.dataUltimaModifica ? this.dataUltimaModifica.toISOString() : <any>undefined;
        data["codEsercente"] = this.codEsercente;
        data["codOperatore"] = this.codOperatore;
        data["dismesso"] = this.dismesso;
        data["dataInstallazione"] = this.dataInstallazione ? this.dataInstallazione.toISOString() : <any>undefined;
        data["annoFabbricazione"] = this.annoFabbricazione;
        data["matricola"] = this.matricola;
        data["noteImpianto"] = this.noteImpianto;
        data["technicianId"] = this.technicianId;
        data["indirizzo"] = this.indirizzo;
        data["cap"] = this.cap;
        data["codFisComune"] = this.codFisComune;
        data["codFrazione"] = this.codFrazione;
        data["piano"] = this.piano;
        data["groupKey"] = this.groupKey;
        data["type"] = this.type;
        return data;
    }

    clone(): ImpiantoBaseDto {
        const json = this.toJSON();
        let result = new ImpiantoBaseDto();
        result.init(json);
        return result;
    }
}

export interface IImpiantoBaseDto {
    inheritsAddress: boolean;
    idCliente: number;
    codiceImpiantoCatasto?: string | undefined;
    dataInserimento: Date;
    dataUltimaModifica: Date;
    codEsercente: number;
    codOperatore: number;
    dismesso: boolean;
    dataInstallazione?: Date | undefined;
    annoFabbricazione: number;
    matricola?: string | undefined;
    noteImpianto?: string | undefined;
    technicianId?: number | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    piano?: string | undefined;
    groupKey?: string | undefined;
    type: ApparecchioCategoryType;
}

export class ImpiantoClimaData extends ImpiantoBaseDto implements IImpiantoClimaData {
    idApparecchio!: number;
    refrigeranteType?: string | undefined;
    sorgenteEsterna?: SorgenteClimaType | undefined;
    sorgenteUtenze?: SorgenteClimaType | undefined;
    potenzaFrigoNominale?: number | undefined;
    potAssorbitaRaffreddamento?: number | undefined;
    potenzaTermicaNominale?: number | undefined;
    potAssorbitaRiscaldamento?: number | undefined;
    cop?: string | undefined;
    eer?: string | undefined;
    tipoSplit?: TipoSplit | undefined;
    codiceFgas?: string | undefined;
    tipoFGas?: TipoFGas | undefined;
    capacitaCircuitoRefrigerante?: number | undefined;

    constructor(data?: IImpiantoClimaData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idApparecchio = _data["idApparecchio"];
            this.refrigeranteType = _data["refrigeranteType"];
            this.sorgenteEsterna = _data["sorgenteEsterna"];
            this.sorgenteUtenze = _data["sorgenteUtenze"];
            this.potenzaFrigoNominale = _data["potenzaFrigoNominale"];
            this.potAssorbitaRaffreddamento = _data["potAssorbitaRaffreddamento"];
            this.potenzaTermicaNominale = _data["potenzaTermicaNominale"];
            this.potAssorbitaRiscaldamento = _data["potAssorbitaRiscaldamento"];
            this.cop = _data["cop"];
            this.eer = _data["eer"];
            this.tipoSplit = _data["tipoSplit"];
            this.codiceFgas = _data["codiceFgas"];
            this.tipoFGas = _data["tipoFGas"];
            this.capacitaCircuitoRefrigerante = _data["capacitaCircuitoRefrigerante"];
        }
    }

    static override fromJS(data: any): ImpiantoClimaData {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoClimaData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idApparecchio"] = this.idApparecchio;
        data["refrigeranteType"] = this.refrigeranteType;
        data["sorgenteEsterna"] = this.sorgenteEsterna;
        data["sorgenteUtenze"] = this.sorgenteUtenze;
        data["potenzaFrigoNominale"] = this.potenzaFrigoNominale;
        data["potAssorbitaRaffreddamento"] = this.potAssorbitaRaffreddamento;
        data["potenzaTermicaNominale"] = this.potenzaTermicaNominale;
        data["potAssorbitaRiscaldamento"] = this.potAssorbitaRiscaldamento;
        data["cop"] = this.cop;
        data["eer"] = this.eer;
        data["tipoSplit"] = this.tipoSplit;
        data["codiceFgas"] = this.codiceFgas;
        data["tipoFGas"] = this.tipoFGas;
        data["capacitaCircuitoRefrigerante"] = this.capacitaCircuitoRefrigerante;
        super.toJSON(data);
        return data;
    }

    clone(): ImpiantoClimaData {
        const json = this.toJSON();
        let result = new ImpiantoClimaData();
        result.init(json);
        return result;
    }
}

export interface IImpiantoClimaData extends IImpiantoBaseDto {
    idApparecchio: number;
    refrigeranteType?: string | undefined;
    sorgenteEsterna?: SorgenteClimaType | undefined;
    sorgenteUtenze?: SorgenteClimaType | undefined;
    potenzaFrigoNominale?: number | undefined;
    potAssorbitaRaffreddamento?: number | undefined;
    potenzaTermicaNominale?: number | undefined;
    potAssorbitaRiscaldamento?: number | undefined;
    cop?: string | undefined;
    eer?: string | undefined;
    tipoSplit?: TipoSplit | undefined;
    codiceFgas?: string | undefined;
    tipoFGas?: TipoFGas | undefined;
    capacitaCircuitoRefrigerante?: number | undefined;
}

export class ImpiantoClimaDto extends ImpiantoClimaData implements IImpiantoClimaDto {
    id!: number;

    constructor(data?: IImpiantoClimaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): ImpiantoClimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoClimaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): ImpiantoClimaDto {
        const json = this.toJSON();
        let result = new ImpiantoClimaDto();
        result.init(json);
        return result;
    }
}

export interface IImpiantoClimaDto extends IImpiantoClimaData {
    id: number;
}

export enum SorgenteClimaType {
    Aria = 0,
    Acqua = 1,
    Geotermico = 2,
}

export enum TipoSplit {
    Mono = 0,
    Dual = 1,
    Multi = 2,
}

export enum TipoFGas {
    Refrigerazione = 0,
    Condizionamento = 1,
    PompaCalore = 2,
    ProtezioneAntincendio = 3,
    CellaAutocarro = 4,
    CommutatoreElettrico = 5,
}

export class ApparecchioCategory implements IApparecchioCategory {
    id!: ApparecchioCategoryType;
    name?: string | undefined;
    family!: ApparecchioFamily;

    constructor(data?: IApparecchioCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.family = _data["family"];
        }
    }

    static fromJS(data: any): ApparecchioCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ApparecchioCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["family"] = this.family;
        return data;
    }

    clone(): ApparecchioCategory {
        const json = this.toJSON();
        let result = new ApparecchioCategory();
        result.init(json);
        return result;
    }
}

export interface IApparecchioCategory {
    id: ApparecchioCategoryType;
    name?: string | undefined;
    family: ApparecchioFamily;
}

export enum ApparecchioFamily {
    Idrotermico = 0,
    Biomassa = 1,
    ClimatizzazioneElettrico = 2,
    Altro = 3,
}

export class ImpiantoData extends ImpiantoBaseDto implements IImpiantoData {
    idCaldaia!: number;
    idBruciatore?: number | undefined;
    dataUltimoControlloAnn!: Date;
    dataUltimoControlloComb!: Date;
    dataInstallazione?: Date | undefined;
    dataPrimoAvvio?: Date | undefined;
    matricolaBruciatore?: string | undefined;
    annoFabbricazioneBruciatore!: number;
    volumetriaRiscaldata?: string | undefined;
    combustibile?: string | undefined;
    localeInstallazione?: string | undefined;
    usoCaldaia?: string | undefined;
    pod?: string | undefined;
    pdr?: string | undefined;
    tiraggio?: string | undefined;
    tipoInstallazione?: string | undefined;

    constructor(data?: IImpiantoData) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idCaldaia = _data["idCaldaia"];
            this.idBruciatore = _data["idBruciatore"];
            this.dataUltimoControlloAnn = _data["dataUltimoControlloAnn"] ? new Date(_data["dataUltimoControlloAnn"].toString()) : <any>undefined;
            this.dataUltimoControlloComb = _data["dataUltimoControlloComb"] ? new Date(_data["dataUltimoControlloComb"].toString()) : <any>undefined;
            this.dataInstallazione = _data["dataInstallazione"] ? new Date(_data["dataInstallazione"].toString()) : <any>undefined;
            this.dataPrimoAvvio = _data["dataPrimoAvvio"] ? new Date(_data["dataPrimoAvvio"].toString()) : <any>undefined;
            this.matricolaBruciatore = _data["matricolaBruciatore"];
            this.annoFabbricazioneBruciatore = _data["annoFabbricazioneBruciatore"];
            this.volumetriaRiscaldata = _data["volumetriaRiscaldata"];
            this.combustibile = _data["combustibile"];
            this.localeInstallazione = _data["localeInstallazione"];
            this.usoCaldaia = _data["usoCaldaia"];
            this.pod = _data["pod"];
            this.pdr = _data["pdr"];
            this.tiraggio = _data["tiraggio"];
            this.tipoInstallazione = _data["tipoInstallazione"];
        }
    }

    static override fromJS(data: any): ImpiantoData {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCaldaia"] = this.idCaldaia;
        data["idBruciatore"] = this.idBruciatore;
        data["dataUltimoControlloAnn"] = this.dataUltimoControlloAnn ? this.dataUltimoControlloAnn.toISOString() : <any>undefined;
        data["dataUltimoControlloComb"] = this.dataUltimoControlloComb ? this.dataUltimoControlloComb.toISOString() : <any>undefined;
        data["dataInstallazione"] = this.dataInstallazione ? this.dataInstallazione.toISOString() : <any>undefined;
        data["dataPrimoAvvio"] = this.dataPrimoAvvio ? this.dataPrimoAvvio.toISOString() : <any>undefined;
        data["matricolaBruciatore"] = this.matricolaBruciatore;
        data["annoFabbricazioneBruciatore"] = this.annoFabbricazioneBruciatore;
        data["volumetriaRiscaldata"] = this.volumetriaRiscaldata;
        data["combustibile"] = this.combustibile;
        data["localeInstallazione"] = this.localeInstallazione;
        data["usoCaldaia"] = this.usoCaldaia;
        data["pod"] = this.pod;
        data["pdr"] = this.pdr;
        data["tiraggio"] = this.tiraggio;
        data["tipoInstallazione"] = this.tipoInstallazione;
        super.toJSON(data);
        return data;
    }

    clone(): ImpiantoData {
        const json = this.toJSON();
        let result = new ImpiantoData();
        result.init(json);
        return result;
    }
}

export interface IImpiantoData extends IImpiantoBaseDto {
    idCaldaia: number;
    idBruciatore?: number | undefined;
    dataUltimoControlloAnn: Date;
    dataUltimoControlloComb: Date;
    dataInstallazione?: Date | undefined;
    dataPrimoAvvio?: Date | undefined;
    matricolaBruciatore?: string | undefined;
    annoFabbricazioneBruciatore: number;
    volumetriaRiscaldata?: string | undefined;
    combustibile?: string | undefined;
    localeInstallazione?: string | undefined;
    usoCaldaia?: string | undefined;
    pod?: string | undefined;
    pdr?: string | undefined;
    tiraggio?: string | undefined;
    tipoInstallazione?: string | undefined;
}

export class ImpiantoDto extends ImpiantoData implements IImpiantoDto {
    idImpianto!: number;

    constructor(data?: IImpiantoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idImpianto = _data["idImpianto"];
        }
    }

    static override fromJS(data: any): ImpiantoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idImpianto"] = this.idImpianto;
        super.toJSON(data);
        return data;
    }

    clone(): ImpiantoDto {
        const json = this.toJSON();
        let result = new ImpiantoDto();
        result.init(json);
        return result;
    }
}

export interface IImpiantoDto extends IImpiantoData {
    idImpianto: number;
}

export class InterventoData implements IInterventoData {
    idImpianto?: number | undefined;
    idCliente?: number | undefined;
    oggettoIntervento?: string | undefined;
    dettaglioIntervento?: string | undefined;
    dataIntervento!: Date;
    dataFineIntervento?: Date | undefined;
    tipoIntervento!: TipoIntervento;
    identificativoIntervento?: string | undefined;
    idTechnician?: number | undefined;
    applicazioneBollino!: boolean;
    controlloStandard!: boolean;
    controlloCombustione!: boolean;
    rapportoControlloId?: RapportoControlloKey | undefined;
    details?: InterventoRowDto[] | undefined;

    constructor(data?: IInterventoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tipoIntervento = new TipoIntervento();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idImpianto = _data["idImpianto"];
            this.idCliente = _data["idCliente"];
            this.oggettoIntervento = _data["oggettoIntervento"];
            this.dettaglioIntervento = _data["dettaglioIntervento"];
            this.dataIntervento = _data["dataIntervento"] ? new Date(_data["dataIntervento"].toString()) : <any>undefined;
            this.dataFineIntervento = _data["dataFineIntervento"] ? new Date(_data["dataFineIntervento"].toString()) : <any>undefined;
            this.tipoIntervento = _data["tipoIntervento"] ? TipoIntervento.fromJS(_data["tipoIntervento"]) : new TipoIntervento();
            this.identificativoIntervento = _data["identificativoIntervento"];
            this.idTechnician = _data["idTechnician"];
            this.applicazioneBollino = _data["applicazioneBollino"];
            this.controlloStandard = _data["controlloStandard"];
            this.controlloCombustione = _data["controlloCombustione"];
            this.rapportoControlloId = _data["rapportoControlloId"] ? RapportoControlloKey.fromJS(_data["rapportoControlloId"]) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(InterventoRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterventoData {
        data = typeof data === 'object' ? data : {};
        let result = new InterventoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idImpianto"] = this.idImpianto;
        data["idCliente"] = this.idCliente;
        data["oggettoIntervento"] = this.oggettoIntervento;
        data["dettaglioIntervento"] = this.dettaglioIntervento;
        data["dataIntervento"] = this.dataIntervento ? this.dataIntervento.toISOString() : <any>undefined;
        data["dataFineIntervento"] = this.dataFineIntervento ? this.dataFineIntervento.toISOString() : <any>undefined;
        data["tipoIntervento"] = this.tipoIntervento ? this.tipoIntervento.toJSON() : <any>undefined;
        data["identificativoIntervento"] = this.identificativoIntervento;
        data["idTechnician"] = this.idTechnician;
        data["applicazioneBollino"] = this.applicazioneBollino;
        data["controlloStandard"] = this.controlloStandard;
        data["controlloCombustione"] = this.controlloCombustione;
        data["rapportoControlloId"] = this.rapportoControlloId ? this.rapportoControlloId.toJSON() : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }

    clone(): InterventoData {
        const json = this.toJSON();
        let result = new InterventoData();
        result.init(json);
        return result;
    }
}

export interface IInterventoData {
    idImpianto?: number | undefined;
    idCliente?: number | undefined;
    oggettoIntervento?: string | undefined;
    dettaglioIntervento?: string | undefined;
    dataIntervento: Date;
    dataFineIntervento?: Date | undefined;
    tipoIntervento: TipoIntervento;
    identificativoIntervento?: string | undefined;
    idTechnician?: number | undefined;
    applicazioneBollino: boolean;
    controlloStandard: boolean;
    controlloCombustione: boolean;
    rapportoControlloId?: RapportoControlloKey | undefined;
    details?: InterventoRowDto[] | undefined;
}

export class InterventoDto extends InterventoData implements IInterventoDto {
    idIntervento!: number;

    constructor(data?: IInterventoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idIntervento = _data["idIntervento"];
        }
    }

    static override fromJS(data: any): InterventoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntervento"] = this.idIntervento;
        super.toJSON(data);
        return data;
    }

    clone(): InterventoDto {
        const json = this.toJSON();
        let result = new InterventoDto();
        result.init(json);
        return result;
    }
}

export interface IInterventoDto extends IInterventoData {
    idIntervento: number;
}

export class TipoIntervento implements ITipoIntervento {
    idTipoIntervento!: number;
    descTipoIntervento!: string;
    ordine!: number;

    constructor(data?: ITipoIntervento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTipoIntervento = _data["idTipoIntervento"];
            this.descTipoIntervento = _data["descTipoIntervento"];
            this.ordine = _data["ordine"];
        }
    }

    static fromJS(data: any): TipoIntervento {
        data = typeof data === 'object' ? data : {};
        let result = new TipoIntervento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTipoIntervento"] = this.idTipoIntervento;
        data["descTipoIntervento"] = this.descTipoIntervento;
        data["ordine"] = this.ordine;
        return data;
    }

    clone(): TipoIntervento {
        const json = this.toJSON();
        let result = new TipoIntervento();
        result.init(json);
        return result;
    }
}

export interface ITipoIntervento {
    idTipoIntervento: number;
    descTipoIntervento: string;
    ordine: number;
}

export class RapportoControlloKey implements IRapportoControlloKey {
    year!: number;
    number!: number;

    constructor(data?: IRapportoControlloKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): RapportoControlloKey {
        data = typeof data === 'object' ? data : {};
        let result = new RapportoControlloKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["number"] = this.number;
        return data;
    }

    clone(): RapportoControlloKey {
        const json = this.toJSON();
        let result = new RapportoControlloKey();
        result.init(json);
        return result;
    }
}

export interface IRapportoControlloKey {
    year: number;
    number: number;
}

export class InterventoRowDto implements IInterventoRowDto {
    type!: UnitType;
    qty!: number;
    description?: string | undefined;
    discount!: number;
    amount!: number;
    vat!: number;

    constructor(data?: IInterventoRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.qty = _data["qty"];
            this.description = _data["description"];
            this.discount = _data["discount"];
            this.amount = _data["amount"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): InterventoRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterventoRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["qty"] = this.qty;
        data["description"] = this.description;
        data["discount"] = this.discount;
        data["amount"] = this.amount;
        data["vat"] = this.vat;
        return data;
    }

    clone(): InterventoRowDto {
        const json = this.toJSON();
        let result = new InterventoRowDto();
        result.init(json);
        return result;
    }
}

export interface IInterventoRowDto {
    type: UnitType;
    qty: number;
    description?: string | undefined;
    discount: number;
    amount: number;
    vat: number;
}

export enum UnitType {
    Pieces = 0,
    Kg = 1,
    Liters = 2,
    Hours = 3,
    Days = 4,
    Months = 5,
    Km = 6,
}

export class RapportinoSignatureData implements IRapportinoSignatureData {
    idIntervento!: number;
    signature?: string | undefined;

    constructor(data?: IRapportinoSignatureData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntervento = _data["idIntervento"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): RapportinoSignatureData {
        data = typeof data === 'object' ? data : {};
        let result = new RapportinoSignatureData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntervento"] = this.idIntervento;
        data["signature"] = this.signature;
        return data;
    }

    clone(): RapportinoSignatureData {
        const json = this.toJSON();
        let result = new RapportinoSignatureData();
        result.init(json);
        return result;
    }
}

export interface IRapportinoSignatureData {
    idIntervento: number;
    signature?: string | undefined;
}

export class ModelloClimaDataDto implements IModelloClimaDataDto {
    marca?: string | undefined;
    modello?: string | undefined;

    constructor(data?: IModelloClimaDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marca = _data["marca"];
            this.modello = _data["modello"];
        }
    }

    static fromJS(data: any): ModelloClimaDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelloClimaDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marca"] = this.marca;
        data["modello"] = this.modello;
        return data;
    }

    clone(): ModelloClimaDataDto {
        const json = this.toJSON();
        let result = new ModelloClimaDataDto();
        result.init(json);
        return result;
    }
}

export interface IModelloClimaDataDto {
    marca?: string | undefined;
    modello?: string | undefined;
}

export class ModelloClimaDto extends ModelloClimaDataDto implements IModelloClimaDto {
    id!: number;

    constructor(data?: IModelloClimaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): ModelloClimaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelloClimaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): ModelloClimaDto {
        const json = this.toJSON();
        let result = new ModelloClimaDto();
        result.init(json);
        return result;
    }
}

export interface IModelloClimaDto extends IModelloClimaDataDto {
    id: number;
}

export class UserDto extends UserDataDto implements IUserDto {
    codOperatore!: number;

    constructor(data?: IUserDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codOperatore = _data["codOperatore"];
        }
    }

    static override fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codOperatore"] = this.codOperatore;
        super.toJSON(data);
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto extends IUserDataDto {
    codOperatore: number;
}

export class RapportoControlloLite implements IRapportoControlloLite {
    year!: number;
    number!: number;
    nrRapporto?: string | undefined;
    date!: Date;
    idImpianto!: number;
    idIntervento?: number | undefined;
    codEsercente!: number;

    constructor(data?: IRapportoControlloLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.number = _data["number"];
            this.nrRapporto = _data["nrRapporto"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.idImpianto = _data["idImpianto"];
            this.idIntervento = _data["idIntervento"];
            this.codEsercente = _data["codEsercente"];
        }
    }

    static fromJS(data: any): RapportoControlloLite {
        data = typeof data === 'object' ? data : {};
        let result = new RapportoControlloLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["number"] = this.number;
        data["nrRapporto"] = this.nrRapporto;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["idImpianto"] = this.idImpianto;
        data["idIntervento"] = this.idIntervento;
        data["codEsercente"] = this.codEsercente;
        return data;
    }

    clone(): RapportoControlloLite {
        const json = this.toJSON();
        let result = new RapportoControlloLite();
        result.init(json);
        return result;
    }
}

export interface IRapportoControlloLite {
    year: number;
    number: number;
    nrRapporto?: string | undefined;
    date: Date;
    idImpianto: number;
    idIntervento?: number | undefined;
    codEsercente: number;
}

export class CreateRapportoControlloDto implements ICreateRapportoControlloDto {
    idImpianto!: number;
    idIntervento?: number | undefined;
    type!: RapportoControlloTypeDto;
    number?: number | undefined;
    rapportoDate!: Date;

    constructor(data?: ICreateRapportoControlloDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idImpianto = _data["idImpianto"];
            this.idIntervento = _data["idIntervento"];
            this.type = _data["type"];
            this.number = _data["number"];
            this.rapportoDate = _data["rapportoDate"] ? new Date(_data["rapportoDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRapportoControlloDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRapportoControlloDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idImpianto"] = this.idImpianto;
        data["idIntervento"] = this.idIntervento;
        data["type"] = this.type;
        data["number"] = this.number;
        data["rapportoDate"] = this.rapportoDate ? this.rapportoDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateRapportoControlloDto {
        const json = this.toJSON();
        let result = new CreateRapportoControlloDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRapportoControlloDto {
    idImpianto: number;
    idIntervento?: number | undefined;
    type: RapportoControlloTypeDto;
    number?: number | undefined;
    rapportoDate: Date;
}

export class SignatureData implements ISignatureData {
    year!: number;
    number!: number;
    type!: RapportoControlloTypeDto;
    signature?: string | undefined;

    constructor(data?: ISignatureData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.number = _data["number"];
            this.type = _data["type"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SignatureData {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["number"] = this.number;
        data["type"] = this.type;
        data["signature"] = this.signature;
        return data;
    }

    clone(): SignatureData {
        const json = this.toJSON();
        let result = new SignatureData();
        result.init(json);
        return result;
    }
}

export interface ISignatureData {
    year: number;
    number: number;
    type: RapportoControlloTypeDto;
    signature?: string | undefined;
}

export class RefrigeranteType implements IRefrigeranteType {
    id?: string | undefined;
    description?: string | undefined;
    gwp?: string | undefined;

    constructor(data?: IRefrigeranteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.gwp = _data["gwp"];
        }
    }

    static fromJS(data: any): RefrigeranteType {
        data = typeof data === 'object' ? data : {};
        let result = new RefrigeranteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["gwp"] = this.gwp;
        return data;
    }

    clone(): RefrigeranteType {
        const json = this.toJSON();
        let result = new RefrigeranteType();
        result.init(json);
        return result;
    }
}

export interface IRefrigeranteType {
    id?: string | undefined;
    description?: string | undefined;
    gwp?: string | undefined;
}

export class CustomerByLocalityReport implements ICustomerByLocalityReport {
    localityId?: string | undefined;
    localityDescription?: string | undefined;
    customers!: number;

    constructor(data?: ICustomerByLocalityReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localityId = _data["localityId"];
            this.localityDescription = _data["localityDescription"];
            this.customers = _data["customers"];
        }
    }

    static fromJS(data: any): CustomerByLocalityReport {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerByLocalityReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localityId"] = this.localityId;
        data["localityDescription"] = this.localityDescription;
        data["customers"] = this.customers;
        return data;
    }

    clone(): CustomerByLocalityReport {
        const json = this.toJSON();
        let result = new CustomerByLocalityReport();
        result.init(json);
        return result;
    }
}

export interface ICustomerByLocalityReport {
    localityId?: string | undefined;
    localityDescription?: string | undefined;
    customers: number;
}

export class CustomersByYears implements ICustomersByYears {
    year!: number;
    new!: number;
    dismissed!: number;

    constructor(data?: ICustomersByYears) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.new = _data["new"];
            this.dismissed = _data["dismissed"];
        }
    }

    static fromJS(data: any): CustomersByYears {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersByYears();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["new"] = this.new;
        data["dismissed"] = this.dismissed;
        return data;
    }

    clone(): CustomersByYears {
        const json = this.toJSON();
        let result = new CustomersByYears();
        result.init(json);
        return result;
    }
}

export interface ICustomersByYears {
    year: number;
    new: number;
    dismissed: number;
}

export class ImpiantiByYears implements IImpiantiByYears {
    year!: number;
    tot!: number;
    dismissed!: number;

    constructor(data?: IImpiantiByYears) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.tot = _data["tot"];
            this.dismissed = _data["dismissed"];
        }
    }

    static fromJS(data: any): ImpiantiByYears {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantiByYears();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["tot"] = this.tot;
        data["dismissed"] = this.dismissed;
        return data;
    }

    clone(): ImpiantiByYears {
        const json = this.toJSON();
        let result = new ImpiantiByYears();
        result.init(json);
        return result;
    }
}

export interface IImpiantiByYears {
    year: number;
    tot: number;
    dismissed: number;
}

export class ImpiantiByModello implements IImpiantiByModello {
    marca?: string | undefined;
    modello?: string | undefined;
    tot!: number;

    constructor(data?: IImpiantiByModello) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marca = _data["marca"];
            this.modello = _data["modello"];
            this.tot = _data["tot"];
        }
    }

    static fromJS(data: any): ImpiantiByModello {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantiByModello();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marca"] = this.marca;
        data["modello"] = this.modello;
        data["tot"] = this.tot;
        return data;
    }

    clone(): ImpiantiByModello {
        const json = this.toJSON();
        let result = new ImpiantiByModello();
        result.init(json);
        return result;
    }
}

export interface IImpiantiByModello {
    marca?: string | undefined;
    modello?: string | undefined;
    tot: number;
}

export class ImpiantoReport implements IImpiantoReport {
    marca?: string | undefined;
    modello?: string | undefined;
    potenzaFocolare!: number;
    potenzaUtile!: number;
    nome?: string | undefined;
    cognome?: string | undefined;
    responsabile?: string | undefined;
    indirizzo?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    dataInstallazione?: Date | undefined;
    idCliente!: number;
    idCaldaia!: number;
    idImpianto!: number;

    constructor(data?: IImpiantoReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marca = _data["marca"];
            this.modello = _data["modello"];
            this.potenzaFocolare = _data["potenzaFocolare"];
            this.potenzaUtile = _data["potenzaUtile"];
            this.nome = _data["nome"];
            this.cognome = _data["cognome"];
            this.responsabile = _data["responsabile"];
            this.indirizzo = _data["indirizzo"];
            this.codFisComune = _data["codFisComune"];
            this.codFrazione = _data["codFrazione"];
            this.dataInstallazione = _data["dataInstallazione"] ? new Date(_data["dataInstallazione"].toString()) : <any>undefined;
            this.idCliente = _data["idCliente"];
            this.idCaldaia = _data["idCaldaia"];
            this.idImpianto = _data["idImpianto"];
        }
    }

    static fromJS(data: any): ImpiantoReport {
        data = typeof data === 'object' ? data : {};
        let result = new ImpiantoReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marca"] = this.marca;
        data["modello"] = this.modello;
        data["potenzaFocolare"] = this.potenzaFocolare;
        data["potenzaUtile"] = this.potenzaUtile;
        data["nome"] = this.nome;
        data["cognome"] = this.cognome;
        data["responsabile"] = this.responsabile;
        data["indirizzo"] = this.indirizzo;
        data["codFisComune"] = this.codFisComune;
        data["codFrazione"] = this.codFrazione;
        data["dataInstallazione"] = this.dataInstallazione ? this.dataInstallazione.toISOString() : <any>undefined;
        data["idCliente"] = this.idCliente;
        data["idCaldaia"] = this.idCaldaia;
        data["idImpianto"] = this.idImpianto;
        return data;
    }

    clone(): ImpiantoReport {
        const json = this.toJSON();
        let result = new ImpiantoReport();
        result.init(json);
        return result;
    }
}

export interface IImpiantoReport {
    marca?: string | undefined;
    modello?: string | undefined;
    potenzaFocolare: number;
    potenzaUtile: number;
    nome?: string | undefined;
    cognome?: string | undefined;
    responsabile?: string | undefined;
    indirizzo?: string | undefined;
    codFisComune?: string | undefined;
    codFrazione?: string | undefined;
    dataInstallazione?: Date | undefined;
    idCliente: number;
    idCaldaia: number;
    idImpianto: number;
}

export class ScadenzaBaseDto implements IScadenzaBaseDto {
    idCaldaia!: number;
    marca?: string | undefined;
    modello?: string | undefined;
    potenzaFocolare!: number;
    idCliente!: number;
    nome?: string | undefined;
    cognome?: string | undefined;
    responsabile?: string | undefined;
    tel?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    idImpianto!: number;
    dataInstallazione?: Date | undefined;
    dataPrimoAvvio?: Date | undefined;
    dataUltimoControlloAnn!: Date;
    dataUltimoControlloComb!: Date;
    comune?: string | undefined;
    frazione?: string | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    provincia?: string | undefined;
    note?: string | undefined;
    impiantoDismesso!: boolean;
    clienteDismesso!: boolean;
    codEsercente!: number;
    lat?: number | undefined;
    lon?: number | undefined;
    contractExpiration?: Date | undefined;
    localeInstallazione?: string | undefined;

    constructor(data?: IScadenzaBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idCaldaia = _data["idCaldaia"];
            this.marca = _data["marca"];
            this.modello = _data["modello"];
            this.potenzaFocolare = _data["potenzaFocolare"];
            this.idCliente = _data["idCliente"];
            this.nome = _data["nome"];
            this.cognome = _data["cognome"];
            this.responsabile = _data["responsabile"];
            this.tel = _data["tel"];
            this.cell = _data["cell"];
            this.email = _data["email"];
            this.idImpianto = _data["idImpianto"];
            this.dataInstallazione = _data["dataInstallazione"] ? new Date(_data["dataInstallazione"].toString()) : <any>undefined;
            this.dataPrimoAvvio = _data["dataPrimoAvvio"] ? new Date(_data["dataPrimoAvvio"].toString()) : <any>undefined;
            this.dataUltimoControlloAnn = _data["dataUltimoControlloAnn"] ? new Date(_data["dataUltimoControlloAnn"].toString()) : <any>undefined;
            this.dataUltimoControlloComb = _data["dataUltimoControlloComb"] ? new Date(_data["dataUltimoControlloComb"].toString()) : <any>undefined;
            this.comune = _data["comune"];
            this.frazione = _data["frazione"];
            this.indirizzo = _data["indirizzo"];
            this.cap = _data["cap"];
            this.provincia = _data["provincia"];
            this.note = _data["note"];
            this.impiantoDismesso = _data["impiantoDismesso"];
            this.clienteDismesso = _data["clienteDismesso"];
            this.codEsercente = _data["codEsercente"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.contractExpiration = _data["contractExpiration"] ? new Date(_data["contractExpiration"].toString()) : <any>undefined;
            this.localeInstallazione = _data["localeInstallazione"];
        }
    }

    static fromJS(data: any): ScadenzaBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScadenzaBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCaldaia"] = this.idCaldaia;
        data["marca"] = this.marca;
        data["modello"] = this.modello;
        data["potenzaFocolare"] = this.potenzaFocolare;
        data["idCliente"] = this.idCliente;
        data["nome"] = this.nome;
        data["cognome"] = this.cognome;
        data["responsabile"] = this.responsabile;
        data["tel"] = this.tel;
        data["cell"] = this.cell;
        data["email"] = this.email;
        data["idImpianto"] = this.idImpianto;
        data["dataInstallazione"] = this.dataInstallazione ? this.dataInstallazione.toISOString() : <any>undefined;
        data["dataPrimoAvvio"] = this.dataPrimoAvvio ? this.dataPrimoAvvio.toISOString() : <any>undefined;
        data["dataUltimoControlloAnn"] = this.dataUltimoControlloAnn ? this.dataUltimoControlloAnn.toISOString() : <any>undefined;
        data["dataUltimoControlloComb"] = this.dataUltimoControlloComb ? this.dataUltimoControlloComb.toISOString() : <any>undefined;
        data["comune"] = this.comune;
        data["frazione"] = this.frazione;
        data["indirizzo"] = this.indirizzo;
        data["cap"] = this.cap;
        data["provincia"] = this.provincia;
        data["note"] = this.note;
        data["impiantoDismesso"] = this.impiantoDismesso;
        data["clienteDismesso"] = this.clienteDismesso;
        data["codEsercente"] = this.codEsercente;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["contractExpiration"] = this.contractExpiration ? this.contractExpiration.toISOString() : <any>undefined;
        data["localeInstallazione"] = this.localeInstallazione;
        return data;
    }

    clone(): ScadenzaBaseDto {
        const json = this.toJSON();
        let result = new ScadenzaBaseDto();
        result.init(json);
        return result;
    }
}

export interface IScadenzaBaseDto {
    idCaldaia: number;
    marca?: string | undefined;
    modello?: string | undefined;
    potenzaFocolare: number;
    idCliente: number;
    nome?: string | undefined;
    cognome?: string | undefined;
    responsabile?: string | undefined;
    tel?: string | undefined;
    cell?: string | undefined;
    email?: string | undefined;
    idImpianto: number;
    dataInstallazione?: Date | undefined;
    dataPrimoAvvio?: Date | undefined;
    dataUltimoControlloAnn: Date;
    dataUltimoControlloComb: Date;
    comune?: string | undefined;
    frazione?: string | undefined;
    indirizzo?: string | undefined;
    cap?: string | undefined;
    provincia?: string | undefined;
    note?: string | undefined;
    impiantoDismesso: boolean;
    clienteDismesso: boolean;
    codEsercente: number;
    lat?: number | undefined;
    lon?: number | undefined;
    contractExpiration?: Date | undefined;
    localeInstallazione?: string | undefined;
}

export class ScadenzaDto extends ScadenzaBaseDto implements IScadenzaDto {
    tipologiaScadenza!: TipoScadenza;
    contractExpiration?: Date | undefined;
    scheduledDateTime?: Date | undefined;
    idIntervento?: number | undefined;
    lastBollino?: BollinoDto | undefined;

    constructor(data?: IScadenzaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologiaScadenza = _data["tipologiaScadenza"];
            this.contractExpiration = _data["contractExpiration"] ? new Date(_data["contractExpiration"].toString()) : <any>undefined;
            this.scheduledDateTime = _data["scheduledDateTime"] ? new Date(_data["scheduledDateTime"].toString()) : <any>undefined;
            this.idIntervento = _data["idIntervento"];
            this.lastBollino = _data["lastBollino"] ? BollinoDto.fromJS(_data["lastBollino"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ScadenzaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScadenzaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologiaScadenza"] = this.tipologiaScadenza;
        data["contractExpiration"] = this.contractExpiration ? this.contractExpiration.toISOString() : <any>undefined;
        data["scheduledDateTime"] = this.scheduledDateTime ? this.scheduledDateTime.toISOString() : <any>undefined;
        data["idIntervento"] = this.idIntervento;
        data["lastBollino"] = this.lastBollino ? this.lastBollino.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ScadenzaDto {
        const json = this.toJSON();
        let result = new ScadenzaDto();
        result.init(json);
        return result;
    }
}

export interface IScadenzaDto extends IScadenzaBaseDto {
    tipologiaScadenza: TipoScadenza;
    contractExpiration?: Date | undefined;
    scheduledDateTime?: Date | undefined;
    idIntervento?: number | undefined;
    lastBollino?: BollinoDto | undefined;
}

export enum TipoScadenza {
    ControlloAnnuale = 1,
    ControlloCombustione = 2,
    ContrattoScaduto = 4,
}

export class AggiornaDateControlloData implements IAggiornaDateControlloData {
    controlloAnnualeChecked!: boolean;
    controlloCombustioneChecked!: boolean;
    dataUltimoControlloAnnuale?: Date | undefined;
    dataUltimoControlloCombustione?: Date | undefined;
    interventoAnnualeChecked!: boolean;
    interventoCombustioneChecked!: boolean;
    bollinoChecked!: boolean;
    bollinoValidity?: PeriodDto | undefined;
    codiceBollino?: string | undefined;
    identificativoAnnuale?: string | undefined;
    identificativoCombutione?: string | undefined;
    idTechnician?: number | undefined;

    constructor(data?: IAggiornaDateControlloData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlloAnnualeChecked = _data["controlloAnnualeChecked"];
            this.controlloCombustioneChecked = _data["controlloCombustioneChecked"];
            this.dataUltimoControlloAnnuale = _data["dataUltimoControlloAnnuale"] ? new Date(_data["dataUltimoControlloAnnuale"].toString()) : <any>undefined;
            this.dataUltimoControlloCombustione = _data["dataUltimoControlloCombustione"] ? new Date(_data["dataUltimoControlloCombustione"].toString()) : <any>undefined;
            this.interventoAnnualeChecked = _data["interventoAnnualeChecked"];
            this.interventoCombustioneChecked = _data["interventoCombustioneChecked"];
            this.bollinoChecked = _data["bollinoChecked"];
            this.bollinoValidity = _data["bollinoValidity"] ? PeriodDto.fromJS(_data["bollinoValidity"]) : <any>undefined;
            this.codiceBollino = _data["codiceBollino"];
            this.identificativoAnnuale = _data["identificativoAnnuale"];
            this.identificativoCombutione = _data["identificativoCombutione"];
            this.idTechnician = _data["idTechnician"];
        }
    }

    static fromJS(data: any): AggiornaDateControlloData {
        data = typeof data === 'object' ? data : {};
        let result = new AggiornaDateControlloData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlloAnnualeChecked"] = this.controlloAnnualeChecked;
        data["controlloCombustioneChecked"] = this.controlloCombustioneChecked;
        data["dataUltimoControlloAnnuale"] = this.dataUltimoControlloAnnuale ? this.dataUltimoControlloAnnuale.toISOString() : <any>undefined;
        data["dataUltimoControlloCombustione"] = this.dataUltimoControlloCombustione ? this.dataUltimoControlloCombustione.toISOString() : <any>undefined;
        data["interventoAnnualeChecked"] = this.interventoAnnualeChecked;
        data["interventoCombustioneChecked"] = this.interventoCombustioneChecked;
        data["bollinoChecked"] = this.bollinoChecked;
        data["bollinoValidity"] = this.bollinoValidity ? this.bollinoValidity.toJSON() : <any>undefined;
        data["codiceBollino"] = this.codiceBollino;
        data["identificativoAnnuale"] = this.identificativoAnnuale;
        data["identificativoCombutione"] = this.identificativoCombutione;
        data["idTechnician"] = this.idTechnician;
        return data;
    }

    clone(): AggiornaDateControlloData {
        const json = this.toJSON();
        let result = new AggiornaDateControlloData();
        result.init(json);
        return result;
    }
}

export interface IAggiornaDateControlloData {
    controlloAnnualeChecked: boolean;
    controlloCombustioneChecked: boolean;
    dataUltimoControlloAnnuale?: Date | undefined;
    dataUltimoControlloCombustione?: Date | undefined;
    interventoAnnualeChecked: boolean;
    interventoCombustioneChecked: boolean;
    bollinoChecked: boolean;
    bollinoValidity?: PeriodDto | undefined;
    codiceBollino?: string | undefined;
    identificativoAnnuale?: string | undefined;
    identificativoCombutione?: string | undefined;
    idTechnician?: number | undefined;
}

export class SendNotificationsRequest implements ISendNotificationsRequest {
    smsTemplate?: string | undefined;
    emailSubject?: string | undefined;
    emailTemplate?: string | undefined;
    impiantiSms?: number[] | undefined;
    impiantiEmail?: number[] | undefined;

    constructor(data?: ISendNotificationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsTemplate = _data["smsTemplate"];
            this.emailSubject = _data["emailSubject"];
            this.emailTemplate = _data["emailTemplate"];
            if (Array.isArray(_data["impiantiSms"])) {
                this.impiantiSms = [] as any;
                for (let item of _data["impiantiSms"])
                    this.impiantiSms!.push(item);
            }
            if (Array.isArray(_data["impiantiEmail"])) {
                this.impiantiEmail = [] as any;
                for (let item of _data["impiantiEmail"])
                    this.impiantiEmail!.push(item);
            }
        }
    }

    static fromJS(data: any): SendNotificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsTemplate"] = this.smsTemplate;
        data["emailSubject"] = this.emailSubject;
        data["emailTemplate"] = this.emailTemplate;
        if (Array.isArray(this.impiantiSms)) {
            data["impiantiSms"] = [];
            for (let item of this.impiantiSms)
                data["impiantiSms"].push(item);
        }
        if (Array.isArray(this.impiantiEmail)) {
            data["impiantiEmail"] = [];
            for (let item of this.impiantiEmail)
                data["impiantiEmail"].push(item);
        }
        return data;
    }

    clone(): SendNotificationsRequest {
        const json = this.toJSON();
        let result = new SendNotificationsRequest();
        result.init(json);
        return result;
    }
}

export interface ISendNotificationsRequest {
    smsTemplate?: string | undefined;
    emailSubject?: string | undefined;
    emailTemplate?: string | undefined;
    impiantiSms?: number[] | undefined;
    impiantiEmail?: number[] | undefined;
}

export class ConfigEsercente implements IConfigEsercente {
    codEsercente!: number;
    idModalitaCalcoloScadenze!: number;

    constructor(data?: IConfigEsercente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codEsercente = _data["codEsercente"];
            this.idModalitaCalcoloScadenze = _data["idModalitaCalcoloScadenze"];
        }
    }

    static fromJS(data: any): ConfigEsercente {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigEsercente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codEsercente"] = this.codEsercente;
        data["idModalitaCalcoloScadenze"] = this.idModalitaCalcoloScadenze;
        return data;
    }

    clone(): ConfigEsercente {
        const json = this.toJSON();
        let result = new ConfigEsercente();
        result.init(json);
        return result;
    }
}

export interface IConfigEsercente {
    codEsercente: number;
    idModalitaCalcoloScadenze: number;
}

export class TechnicianData implements ITechnicianData {
    firstName?: string | undefined;
    lastName?: string | undefined;
    color?: string | undefined;
    calendarLink?: string | undefined;

    constructor(data?: ITechnicianData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.color = _data["color"];
            this.calendarLink = _data["calendarLink"];
        }
    }

    static fromJS(data: any): TechnicianData {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["color"] = this.color;
        data["calendarLink"] = this.calendarLink;
        return data;
    }

    clone(): TechnicianData {
        const json = this.toJSON();
        let result = new TechnicianData();
        result.init(json);
        return result;
    }
}

export interface ITechnicianData {
    firstName?: string | undefined;
    lastName?: string | undefined;
    color?: string | undefined;
    calendarLink?: string | undefined;
}

export class TechnicianDto extends TechnicianData implements ITechnicianDto {
    id!: number;

    constructor(data?: ITechnicianDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): TechnicianDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): TechnicianDto {
        const json = this.toJSON();
        let result = new TechnicianDto();
        result.init(json);
        return result;
    }
}

export interface ITechnicianDto extends ITechnicianData {
    id: number;
}

export class TipoContratto implements ITipoContratto {
    id!: string;
    descrizione?: string | undefined;
    mesiValidita!: number;
    codEsercente!: number;

    constructor(data?: ITipoContratto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descrizione = _data["descrizione"];
            this.mesiValidita = _data["mesiValidita"];
            this.codEsercente = _data["codEsercente"];
        }
    }

    static fromJS(data: any): TipoContratto {
        data = typeof data === 'object' ? data : {};
        let result = new TipoContratto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descrizione"] = this.descrizione;
        data["mesiValidita"] = this.mesiValidita;
        data["codEsercente"] = this.codEsercente;
        return data;
    }

    clone(): TipoContratto {
        const json = this.toJSON();
        let result = new TipoContratto();
        result.init(json);
        return result;
    }
}

export interface ITipoContratto {
    id: string;
    descrizione?: string | undefined;
    mesiValidita: number;
    codEsercente: number;
}

export class AccountData implements IAccountData {
    codOperatore!: number;
    nomeOperatore?: string | undefined;
    username?: string | undefined;
    amministratore!: boolean;
    disabilitato!: boolean;
    codEsercente!: number;
    expiration!: Date;
    lastAccess?: Date | undefined;
    lastVersion?: string | undefined;
    remainingSms!: number;
    lastNewsVersion?: string | undefined;

    constructor(data?: IAccountData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codOperatore = _data["codOperatore"];
            this.nomeOperatore = _data["nomeOperatore"];
            this.username = _data["username"];
            this.amministratore = _data["amministratore"];
            this.disabilitato = _data["disabilitato"];
            this.codEsercente = _data["codEsercente"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.lastAccess = _data["lastAccess"] ? new Date(_data["lastAccess"].toString()) : <any>undefined;
            this.lastVersion = _data["lastVersion"];
            this.remainingSms = _data["remainingSms"];
            this.lastNewsVersion = _data["lastNewsVersion"];
        }
    }

    static fromJS(data: any): AccountData {
        data = typeof data === 'object' ? data : {};
        let result = new AccountData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codOperatore"] = this.codOperatore;
        data["nomeOperatore"] = this.nomeOperatore;
        data["username"] = this.username;
        data["amministratore"] = this.amministratore;
        data["disabilitato"] = this.disabilitato;
        data["codEsercente"] = this.codEsercente;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["lastAccess"] = this.lastAccess ? this.lastAccess.toISOString() : <any>undefined;
        data["lastVersion"] = this.lastVersion;
        data["remainingSms"] = this.remainingSms;
        data["lastNewsVersion"] = this.lastNewsVersion;
        return data;
    }

    clone(): AccountData {
        const json = this.toJSON();
        let result = new AccountData();
        result.init(json);
        return result;
    }
}

export interface IAccountData {
    codOperatore: number;
    nomeOperatore?: string | undefined;
    username?: string | undefined;
    amministratore: boolean;
    disabilitato: boolean;
    codEsercente: number;
    expiration: Date;
    lastAccess?: Date | undefined;
    lastVersion?: string | undefined;
    remainingSms: number;
    lastNewsVersion?: string | undefined;
}

export class LoginRequestDto implements ILoginRequestDto {
    user!: string;
    password!: string;
    rememberMe!: boolean;

    constructor(data?: ILoginRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
        }
    }

    static fromJS(data: any): LoginRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        return data;
    }

    clone(): LoginRequestDto {
        const json = this.toJSON();
        let result = new LoginRequestDto();
        result.init(json);
        return result;
    }
}

export interface ILoginRequestDto {
    user: string;
    password: string;
    rememberMe: boolean;
}

export class TokenResponseDto implements ITokenResponseDto {
    token?: string | undefined;
    expiresIn?: Date | undefined;

    constructor(data?: ITokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiresIn = _data["expiresIn"] ? new Date(_data["expiresIn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiresIn"] = this.expiresIn ? this.expiresIn.toISOString() : <any>undefined;
        return data;
    }

    clone(): TokenResponseDto {
        const json = this.toJSON();
        let result = new TokenResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITokenResponseDto {
    token?: string | undefined;
    expiresIn?: Date | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email?: string | undefined;
    resetPasswordPage?: string | undefined;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.resetPasswordPage = _data["resetPasswordPage"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["resetPasswordPage"] = this.resetPasswordPage;
        return data;
    }

    clone(): ForgotPasswordRequest {
        const json = this.toJSON();
        let result = new ForgotPasswordRequest();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordRequest {
    email?: string | undefined;
    resetPasswordPage?: string | undefined;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email?: string | undefined;
    resetToken?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.resetToken = _data["resetToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["resetToken"] = this.resetToken;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordRequest {
        const json = this.toJSON();
        let result = new ResetPasswordRequest();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordRequest {
    email?: string | undefined;
    resetToken?: string | undefined;
    newPassword?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}